export const ar: { [key: string]: string } = {
  subscribe_with_click: 'اشترك بنقرة واحدة',
  subscribe: 'اشترك بنقرة واحدة',
  minimum_number_characters: 'الحد الأدنى لعدد الأحرف هو 2',
  request_details: 'طلب التفاصيل',
  form_title: 'سنتواصل معك قريبًا',
  form_required: 'الحقول المميزة بـ * إلزامية',
  form_name_placeholder: 'الاسم',
  form_email_placeholder: 'البريد الإلكتروني',
  form_phone_placeholder: 'رقم الهاتف',
  form_company_placeholder: 'الشركة',
  form_submit: 'إرسال',
  form_1: 'أمنح موافقتي على معالجة البيانات الشخصية وفقًا لـ',
  form_2: 'سياسة الخصوصية',
  validation_privacy_policy: 'يرجى قبول سياسة الخصوصية',
  validation_phone: 'رقم الهاتف غير صالح',
  validation_email: 'تنسيق البريد الإلكتروني غير صالح',
  validation_required: 'الحقول المطلوبة غير مملوءة',
  submit_error: 'حدث خطأ أثناء حفظ النموذج',
  footer_1: 'شركاؤنا:',
  footer_2: 'الأساليب',
  footer_3: 'المنتجات',
  footer_4: 'جهات الاتصال:',
  footer_5: 'البيان القانوني',
  footer_6: 'سياسة الخصوصية',
  footer_7: 'أبحاث السوق',
  about_us_1: 'المسؤولية الاجتماعية لشركة 4Service',
  about_us_2:
    'من قلب وروح كل عضو في فريقنا. نبذل قصارى جهدنا للحفاظ على شرارة اللطف في كل موظف وجعل العالم من حولنا أفضل قليلاً',
  about_us_3: 'المسؤولية الاجتماعية لشركة 4Service',
  about_us_4:
    'من قلب وروح كل عضو في فريقنا. نبذل قصارى جهدنا للحفاظ على شرارة اللطف في كل موظف وجعل العالم من حولنا أفضل قليلاً',
  about_us_5: 'لعبة الأعمال Service Mania',
  about_us_6: 'مبادراتنا التعليمية للأطفال والطلاب',
  about_us_7: 'الأعمال الخيرية / التطوع',
  about_us_8:
    'دور الأيتام، دور رعاية المسنين، والتطوع من أجل الجيش الأوكراني. الجزء الأكثر تأثيرًا في أنشطتنا',
  about_us_9: 'رعاية الحيوانات',
  about_us_10:
    'يمكن لأي شخص زيارة مكتبنا مع حيوانه الأليف. نحن نساعد الملاجئ، نجمع التبرعات للطعام وأحيانًا نحاول العثور على منزل للحيوانات المشردة',
  about_us_11: 'مجموعة 4Service',
  about_us_12: 'هي شركة أبحاث دولية تدير تجربة العملاء.',
  about_us_13:
    'ننفذ مشاريع معقدة لزيادة المبيعات وتطوير أعمال الشركات التي تركز على العملاء.',
  about_us_14:
    'هي شركة أبحاث دولية يقع مقرها الرئيسي في فيينا، النمسا. تأسست الشركة في عام 2001 بهدف تحسين جودة حياة عملائها والأشخاص الذين يتفاعلون مع الأعمال التجارية ويستخدمون خدماتها ومنتجاتها. ولهذا السبب تم اختيار اسم “Forservice” لتمثيل خدمة العملاء والجودة العالية.',
  about_us_15:
    'كانت هذه بداية قصة 4Service في كييف، أوكرانيا كمزود رائد لخدمات التسوق السري. وواصلت الشركة نجاحها كشركة أبحاث تعمل في 52 دولة مع فرص جديدة ضمن نهج شامل لتحليل وتحسين تجربة العملاء بالكامل.',
  about_us_16: 'وُلدت باسم الخدمة',
  about_us_17: 'المكتب الأول خارج أوكرانيا',
  about_us_18: 'نقل المقر الرئيسي إلى فيينا',
  about_us_19: 'عضو نخبة في MSPA، من بين أفضل 10 وكالات في أوروبا',
  about_us_20: 'تأسيس مكاتب في 9 دول',
  about_us_21: 'أول المشاريع الرقمية، Voicer',
  about_us_22: 'شركاء أكاديمية DesignThinkers',
  about_us_23: 'أول مشاريع CX العالمية',
  about_us_24: 'المهمة',
  about_us_25:
    'مهمتنا هي تحسين خدمة العملاء في جميع أنحاء العالم! مصدر إلهامنا هو التغييرات النوعية التي نراها في الأشخاص والشركات التي نعمل معها.',
  about_us_26: 'أكثر من 20 عامًا من تجربة العملاء',
  about_us_27: '95 دولة',
  about_us_28: 'نجمع ونتبادل أفضل الخبرات الصناعية من جميع أنحاء العالم',
  about_us_29: 'المقر الرئيسي في فيينا',
  about_us_30: 'دول. نجمع ونتبادل أفضل الخبرات الصناعية من جميع أنحاء العالم',
  about_us_31: 'تصنيفات جودة الخدمة',
  about_us_32: 'نحن ضمن أفضل 10 وكالات CX أوروبية',
  about_us_33: 'مكاتب تمثيلية / المقر الرئيسي في النمسا',
  about_us_34: 'مشاريع نشطة',
  about_us_35: 'مكان عملك المستقبلي',
  about_us_36: 'مكاتبنا',
  about_us_37:
    'تبذل شركة 4Service ™ جهودًا لإنشاء بيئة عمل مريحة لموظفيها. يعمل موظفونا في المكاتب أو عن بُعد أو بنظام هجين وفقًا لما يناسب راحتهم وإنتاجيتهم. غرف للاسترخاء، دعم نفسي مجاني، وبيئة مرحبة. نحن ودودون مع البشر والحيوانات الأليفة.',
  about_us_38: 'فريق يُشعل الحماس',
  about_us_39:
    'فريقنا المتعدد الجنسيات ملتزم بالاستماع وتلقي الملاحظات من عملائنا والنمو المشترك. خريطة رحلة العميل معنا مهمة لأعمالنا بقدر أهمية إطلاق منتجات جديدة أو تحقيق أهدافنا المالية. تهدف أنشطتنا إلى إحداث تأثير إيجابي على المجتمعات من حولنا وتقديم حلول مبتكرة تركز على الإنسان لعملائنا.',
  about_us_40: 'الكل',
  about_us_41: 'الإدارة',
  about_us_42: 'الفريق العالمي',
  about_us_43: 'مالكو المنتجات',
  about_us_44: 'شركاؤنا',
  about_us_45:
    'ننفذ مشاريع معقدة لزيادة المبيعات وتطوير أعمال الشركات الموجهة نحو العملاء',
  about_us_46:
    'هي واحدة من المؤسسات الرائدة في التدريب المهني "الموجهة بالتصميم"، وتمثل في 25 دولة، وتقوم بتدريب وتطوير وتيسير عمل فرق ومجتمعات متعددة التخصصات لإحداث تغيير إيجابي. يتيح التفكير التصميمي تطوير وتقديم أفكار مبتكرة وتغييرات وحلول للمشكلات المعقدة.',
  about_us_47:
    'تتمثل مهمتها في توفير المساحة والوقت للفرق والأفراد ليتم إلهامهم وتحفيزهم، والتعلم من خلال الممارسة، وتعزيز قدرتهم على حل المشكلات الإبداعي، ومساعدة المنظمات على بناء البيئة والعقلية اللازمة لبدء الابتكار الجريء.',
  about_us_48:
    'هي جمعية تجارية تمثيلية للشركات العاملة في صناعة التسوق السري. تعمل الجمعية على أساس إقليمي في جميع أنحاء العالم، مع فروع في أمريكا وأوروبا/أفريقيا وآسيا/المحيط الهادئ. تتحد الشركات الأعضاء كهيئة واحدة بهدف تعزيز صناعة التسوق السري من خلال الجهود والإجراءات المشتركة.',
  about_us_49:
    'هي منظمة عضوية غير ربحية. يشكل الأعضاء مجتمعًا مقتنعًا بإمكانات تحليلات البيانات والأبحاث والرؤى في تحسين المجتمعات والمنظمات وحياة الجميع.',
  about_us_50:
    'يقع المقر الرئيسي لـ ESOMAR في أمستردام، هولندا. وهي موجودة في أكثر من 130 دولة من خلال أعضائها منذ عام 1947.',
  about_us_51:
    '(UCCA) هي مجتمع مهني من الخبراء والشركات الخاصة المتحدة بهدف التطوير والتفاعل في مجال مراكز الاتصال وخدمة العملاء. تقوم فلسفة UCCA على رفع ثقافة صناعة مراكز الاتصال، بناءً على التقنيات الحديثة والمعايير العالية.',
  about_us_52: 'تأسست جمعية مراكز الاتصال الأوكرانية في عام 2010',
  about_us_53:
    'تدرس أفضل الخبرات العالمية في مجال التعليم لتكييفها واستخدامها في السوق الأوكرانية. لهذا السبب تتعاون أكاديمية DTEK مع مدارس الأعمال الدولية الرائدة: INSEAD وIE Business School وجامعة ستانفورد.',
  about_us_54:
    'تركز أكاديمية DTEK على تطوير ثقافة موجهة نحو العملاء ومبتكرة في مدارسها: D.Client School وID School وExecutive Education: Energy of Innovation وPower of Communications وبرنامج التحول الرقمي DX School وEffective Leader: Pre-MBA وChange Energy.',
  about_us_55: 'سيرهي باشكوفسكي',
  about_us_56: 'فيكتوريا سكوربوتا',
  about_us_57: 'أرتيم فومين',
  about_us_58: 'ماكس بابكا',
  about_us_59: 'مدير المبيعات الدولية',
  bht_1: 'صحة العلامة التجارية',
  bht_2: 'التتبع',
  bht_3: 'العلامات التجارية قوية للغاية',
  bht_4: 'اكتشف مدى أداء علامتك التجارية بشكل عام',
  bht_5: 'حول',
  bht_6: 'ما هو تتبع صحة العلامة التجارية؟',
  bht_7:
    'هو نوع من أبحاث السوق يُجرى بانتظام (كل أسبوعين، أو كل شهر، إلخ) للحصول على معلومات حول',
  bht_8:
    'حالة العلامة التجارية في السوق بناءً على مؤشرات مثل الوعي، الطلب، الصورة، خصائص المستهلكين، صحة العلامة التجارية، وغيرها.',
  bht_9: 'يشترون العلامة التجارية في أغلب الأحيان',
  bht_10: 'العملاء المخلصون',
  bht_11: 'اشتروا العلامة التجارية خلال 3 أشهر',
  bht_12: 'العملاء المنتظمون / المتكررون',
  bht_13: 'اشتروا العلامة التجارية خلال 6 أشهر',
  bht_14: 'العملاء على المدى القصير',
  bht_15: 'اشتروا العلامة التجارية لمدة عام',
  bht_16: 'العملاء على المدى الطويل',
  bht_17: 'على دراية بالعلامة التجارية ولكن لم يستخدموها / يشترونها أبدًا',
  bht_18: 'على دراية ولكنهم ليسوا عملاء',
  bht_19: 'غير مدركين: لم يسمعوا أبدًا عن العلامة التجارية',
  bht_20: 'غير مدركين',
  bht_21: 'ملف مشتري العلامة التجارية',
  bht_22:
    'تقييم مدى اتساق الجهود المبذولة على المدى الطويل لبناء العلامة التجارية',
  bht_23: 'قياس مستوى معرفة العملاء بالعلامة التجارية',
  bht_24: 'إظهار فعالية الحملات الإعلانية والإعلامية',
  bht_25:
    'تحديد تأثير فترات الإعلان المكثف على أنشطة المبيعات / التسويق للمنافسين',
  bht_26: 'توفير رقابة مستمرة لمالك العمل في فترات التغيرات المستمرة في السوق',
  bht_27: 'ما هي المهام التي يمكن حلها من خلال BHT:',
  bht_28: 'اطلب بحثًا',
  bht_29: 'المهمة المطلوب حلها',
  bht_30: 'على سبيل المثال،',
  bht_31:
    'إذا كانت الشركة تحتاج فقط إلى جلسة BHT واحدة في كل ربع سنة أثناء قياس الحصص السوقية، فيجب إجراء استطلاع للمستجيبين بشكل أكثر تكرارًا عند قياس معرفة العملاء بالعلامة التجارية من الإعلانات.',
  bht_32: 'المقابلات الهاتفية (CATI)',
  bht_33: 'وجهًا لوجه',
  bht_53: 'مقابلات',
  bht_34: 'المقابلات عبر الإنترنت (CAWI)',
  bht_35: 'المهمة المطلوب حلها',
  bht_36: 'من خلال جمع المعلومات',
  bht_37:
    'من خلال طرق مختلفة، يتم عادةً تقسيم تتبع العلامة التجارية إلى ثلاث مراحل اعتمادًا على الجمهور المستهدف ومدى صعوبة الوصول إليه:',
  bht_38: 'نستخدم طرق جمع البيانات التقليدية والمعاصرة على حد سواء:',
  bht_39:
    'نعمل باستخدام نموذجين: الأول يحتوي على مجموعة بسيطة من المؤشرات، بينما يستهدف الثاني الصناعات الأكثر تعقيدًا مثل صناعة الأغذية والخدمات. يتضمن النموذج الأكثر تعقيدًا دراسة متعمقة تحتوي على ما يصل إلى 10 مؤشرات تقديرية.',
  bht_40: 'نحن نقدم',
  bht_41: 'مراقبة البيانات الأولية',
  bht_42: 'نغطي',
  bht_43: 'في جميع أنحاء البلاد',
  bht_44: 'نحن نقدم حلاً',
  bht_45:
    'للأسواق غير الديناميكية / الأسواق ذات عدد محدود من اللاعبين (تحليل نقطة العلامة التجارية)',
  bht_46: 'لماذا نحن؟',
  bht_47: 'لماذا تختارنا؟',
  bht_50: 'نتيجة ضعيفة',
  bht_51: 'نتيجة جيدة',
  bht_52: 'نتيجة متوسطة',
  cases_1:
    'التحدي: كيف يمكن تحسين تجربة شراء السيارات الكهربائية للعملاء في صالات عرض هيونداي؟',
  cases_2: 'رسم خريطة رحلة العميل',
  cases_3: 'توليد الأفكار',
  cases_4: 'بحث نوعي',
  cases_5:
    'التحدي: ما الذي يجب تغييره في المتاجر (سواء في عملية الخدمة، أو في الديكور الداخلي، أو في تصور العلامة التجارية) لجذب اهتمام العملاء بعلامة أوبو التجارية؟',
  cases_6: 'رحلة العميل عبر الإنترنت',
  cases_7: 'اختبار واجهة المستخدم',
  cases_8: 'مقابلات',
  cases_9:
    'التحدي: ما الذي يجب تغييره في المتاجر لجذب اهتمام العملاء بعلامة أوبو التجارية؟',
  cases_10: 'الجزء النوعي',
  cases_11: 'توليد الأفكار',
  cases_12: 'الجزء الكمي',
  cases_13: 'خريطة رحلة العميل',
  cases_14: 'دراسات حالة',
  cases_15: 'الكل',
  cases_16: 'دعونا نصنع حالتك الرائعة معًا',
  csi_1: 'رضا',
  csi_2: 'العملاء',
  csi_3: 'تحديد أسباب',
  csi_4: 'رضا وعدم رضا المستهلكين',
  csi_5: 'بحث رضا العملاء',
  csi_6:
    'هو تحديد العوامل والأسباب والدوافع التي تؤثر على قرار العميل بالشراء وكذلك سلوك الجمهور المستهدف.',
  csi_7: 'استطلاع رضا العملاء',
  csi_8:
    'يُظهر مدى رضا العميل أو عدم رضاه عن جانب معين من الخدمة أو عن المنتج بشكل عام.',
  csi_9: 'يُجرى استطلاع الرضا',
  csi_10: 'بين العملاء الحاليين للشركة ومستخدمي منتجات أو خدمات معينة.',
  csi_11: 'ما هو مؤشر رضا العملاء (CSI)؟',
  csi_12:
    'يقيس رضا العملاء مدى تلبية توقعاتهم فيما يتعلق بشراء منتج أو خدمة مقدمة من شركتك.',
  csi_13: 'رجل سعيد',
  csi_14: 'حول',
  csi_15: 'تحديد أي عوامل خفية',
  csi_16: 'قد تؤثر على رضا العملاء',
  csi_17: 'تحديد الأسباب',
  csi_18: 'وراء أي زيادة أو انخفاض في الطلب على السلع والخدمات',
  csi_19: 'تحسين',
  csi_20: 'عمليات الشركة التجارية',
  csi_21: 'وتكييفها',
  csi_22: 'لتلبية احتياجات المستهلك الحديث',
  csi_23: 'تكوين رسالة إعلانية فعالة',
  csi_24: 'وتحديد موقع المنتج وفقًا لطلب العميل',
  csi_25: 'المهام التي يجب حلها',
  csi_26: 'ما هي المهام التي يمكن أن تحلها دراسات رضا العملاء',
  csi_27: 'رجل يحمل هاتفًا',
  csi_28: 'نقوم ببناء نموذج رياضي',
  csi_29: 'للعوامل التي قد تؤثر على رضا العملاء / ولائهم (تحليل الانحدار)',
  csi_30: 'تحسين',
  csi_31: 'عمليات الشركة التجارية',
  csi_32: 'نبني مؤشرًا محسوبًا لرضا العملاء',
  csi_33: '(CSI) ونقارنه بالمؤشر التصريحي',
  csi_34: 'نجري أبحاثًا',
  csi_35: 'لكل من قطاعات B2B وB2C.',
  csi_36: 'يتم إعداد استبياناتنا من قبل فريق',
  csi_37: 'من المحللين خصيصًا للمشروعات الفردية لعملائنا',
  csi_38: 'لماذا نحن',
  csi_39: 'لماذا تختارنا؟',
  csi_40: 'طرق جمع المعلومات:',
  main_1: 'من عملائنا يحسنون أداءهم المالي من خلال التعلم من تجربة عملائهم',
  main_2: 'خدمات أبحاث واستشارات تجربة العملاء (CX): رؤية شاملة °360 لأعمالك',
  main_3: 'اكتشف مجموعتنا من الحلول والأدوات لدعم عملك',
  main_4: 'المنتجات',
  main_5:
    'البحث النوعي هو جمع وتحليل البيانات غير الرقمية لفهم المفاهيم أو الآراء أو التجارب',
  main_6:
    'طرق البحث الكمي هي قياس موضوعي وتحليل رقمي للبيانات التي تم جمعها من خلال الاستطلاعات والاستبيانات والمسوحات',
  main_7:
    'التسوق الخفي هو تقنية بحث سوقية لقياس ومراقبة التفاعلات بين العميل والشركة أو المؤسسة أثناء سيناريو محدد مسبقًا',
  main_8: 'نظام إدارة الملاحظات. صوت عميلك في نظام واحد لإدارة ملاحظات العملاء',
  main_9: 'منصة ذكاء محتوى مدعومة بالذكاء الاصطناعي توفر رؤى من الجمهور',
  main_10: 'برنامج إدارة الأداء. تطبيق يعتمد على التفاعل لزيادة المبيعات',
  main_11: 'مراقبة الأسعار هي عملية جمع ومعالجة وتحليل أسعار المنافسين',
  main_12:
    'هو تصميم الخدمات والمنتجات الموجهة نحو العميل. تتضمن العملية حركة متوازنة من احتياجات وتوقعات العملاء إلى طريقة عملهم',
  main_13:
    'يطبق فريقنا التحليلي أحدث وأهم الأساليب التي أثبتنا نجاحها مع العديد من العملاء',
  main_14: 'المنهجيات',
  main_15: 'خريطة رحلة العميل',
  main_16:
    'رسم خريطة رحلة العميل (CJM) يتعلق بتحديد الجمهور المستهدف، وفهم احتياجاته وبيئته، ثم إنشاء خطة لتقديم تجربة تفاعلية',
  main_17: 'CJM',
  main_18: 'مؤشر الترويج الصافي',
  main_19:
    'مؤشر الترويج الصافي (NPS) هو المعيار الذهبي لمقاييس تجربة العملاء، ويعتمد على سؤال واحد: ما مدى احتمالية أن توصي بالمؤسسة / المنتج / الخدمة؟',
  main_20: 'NPS',
  main_21: 'تتبع صحة العلامة التجارية',
  main_22:
    'يمكن أن يقيس بحث تتبع صحة العلامة التجارية (BHT) مدى أداء علامتك التجارية من حيث الوعي والاستخدام، وتحديد موقع العلامة التجارية، وأدائها',
  main_23: 'BHT',
  main_24: 'أبحاث الموارد البشرية',
  main_25:
    'تُستخدم أبحاث الموارد البشرية لتقييم ممارسات وأداء الموارد البشرية وتقدم تحليلًا تفصيليًا للتطوير والإدارة الحالية',
  main_26: 'أبحاث الموارد البشرية',
  main_27: 'مؤشر رضا العملاء',
  main_28:
    'مؤشر رضا العملاء (CSI) هو مقياس يشير إلى مدى رضا عملائك عن منتجات الشركة أو خدماتها.',
  main_29: 'CSI',
  main_30: 'اختبار تجربة المستخدم (UX)',
  main_31:
    'اختبار سهولة الاستخدام (UX) هو الطريقة التي يتفاعل بها الأشخاص الحقيقيون مع موقع ويب أو تطبيق أو منتج آخر وملاحظة سلوكهم وردود أفعالهم تجاهه',
  main_32: 'لماذا نحن',
  main_33: 'مهمتنا هي مساعدة الشركات على تقديم تجربة عملاء فعالة للغاية',
  main_34: 'التركيز على الجودة',
  main_35: 'نحن نخضع لمراقبة الجودة',
  main_36:
    'عندما يتعلق الأمر ببيانات البحث. نحن نجعل جميع مجموعات البيانات متاحة للعملاء',
  main_37: 'فعّالة من حيث التكلفة',
  main_38: 'خبرتنا ومواردنا وعملياتنا المبسطة',
  main_39: 'تسمح لنا بتوفير المال والوقت لك',
  main_40: 'حلول ذكية',
  main_41: 'نستخدم مجموعة متنوعة من التقنيات',
  main_42: 'ومجموعات الأدوات لحل مشاكلك الخاصة',
  main_43: 'التركيز على الجودة',
  main_44: 'نحن نخضع لمراقبة الجودة',
  main_45:
    'عندما يتعلق الأمر ببيانات البحث. نحن نجعل جميع مجموعات البيانات متاحة للعملاء',
  main_46: 'فعّالة من حيث التكلفة',
  main_47: 'خبرتنا ومواردنا وعملياتنا المبسطة',
  main_48: 'تسمح لنا بتوفير المال والوقت لك',
  main_49: 'حلول ذكية',
  main_50: 'نستخدم مجموعة متنوعة من التقنيات',
  main_51: 'ومجموعات الأدوات لحل مشاكلك الخاصة',
  main_52: 'البيع بالجملة (نقدًا واحمل)',
  main_53: 'الإلكترونيات',
  main_54: 'الفخامة / المتميزة',
  main_55: 'المطاعم والضيافة',
  main_56: 'التجزئة',
  main_57: 'السيارات',
  main_58: 'الأزياء',
  main_59: 'البنوك',
  main_60: 'السفر والترفيه',
  main_61: 'الساعات والمجوهرات',
  main_62: 'الأجهزة المنزلية',
  main_63: 'المدونة',
  main_64: 'اذهب إلى المدونة لقراءة المزيد من المنشورات الشيقة',
  main_65: 'تدقيق التجزئة',
  main_66:
    'اجمع بيانات تفصيلية حول متجرك أو علامتك التجارية، وحلل عوائق النمو، وأنشئ استراتيجيات فعّالة لتجاوزها',
  main_73: 'دراسة اليوميات',
  main_74:
    'تعد دراسات اليوميات مفيدة لاستكشاف التجارب طويلة المدى والأنشطة المتكررة. تتبع واكتسب رؤى حول تطور تجارب المستخدمين وأنماط حياتهم في بيئاتهم اليومية مع مرور الوقت.',
  main_75: 'تجربة الموظف (EX)',
  main_76:
    'منهجية تجربة الموظف (EX) هي نهج استراتيجي يساعد المؤسسات على تصميم عمليات وثقافات وبيئات أفضل تتماشى مع توقعات الموظفين وأهداف العمل، مما يعزز رفاهية الموظفين وأداء الشركة في النهاية',
  main_77: 'المقابلات الهاتفية بمساعدة الحاسوب (CATI)',
  main_78: 'المقابلات الهاتفية بمساعدة الحاسوب (CATI)',
  main_79:
    'CATI هي منهجية بحث مرنة وفعالة تمكن من جمع بيانات عالية الجودة مصممة لتلبية احتياجات الأعمال المتنوعة — من رضا العملاء ومشاركة الموظفين إلى أبحاث السوق والاجتماعية — مما يضمن رؤى دقيقة وفي الوقت المناسب وقابلة للتنفيذ',
  cjm_1: 'العميل',
  cjm_2: 'خريطة رحلة العميل',
  cjm_3: 'ادخل إلى عالم العملاء وشاركهم تجربتهم',
  cjm_4: 'ما هي خريطة رحلة العميل؟',
  cjm_5:
    'توفر خريطة رحلة العميل عرضًا مرئيًا لتاريخ تفاعل المستهلك مع منتج أو خدمة أو شركة أو علامة تجارية من خلال قنوات مختلفة وخلال فترة زمنية معينة.',
  cjm_6:
    'يتيح ذلك للشركات تحليل تجربة تفاعل العملاء بموضوعية، وتحديد وإزالة أي عوائق قد تنشأ، وتقديم توصيات لتحسين المنتج.',
  cjm_7: 'تحديد الجمهور المستهدف، التقسيم',
  cjm_8: 'تحديد مراحل تفاعل العميل',
  cjm_9: 'تحديد القنوات الأساسية لتفاعل العميل',
  cjm_10: 'بحث تجربة العميل',
  cjm_11: 'تحليل العوائق ووضع الفرضيات حول التحسين',
  cjm_12: 'تنفيذ واختبار الفرضيات',
  cjm_13: 'يتكون تصميم خريطة رحلة العميل من الخطوات التالية:',
  cjm_14: 'ستُظهر خريطة رحلة العميل:',
  cjm_15:
    'توفر خريطة رحلة العميل عرضًا مرئيًا لتاريخ تفاعل المستهلك مع منتج أو خدمة أو شركة أو علامة تجارية من خلال قنوات مختلفة وخلال فترة زمنية معينة.',
  cjm_16: 'نضمن العمل الجماعي',
  cjm_17: 'بين المحللين والمصممين',
  cjm_18: 'نقدم نهجًا فرديًا',
  cjm_19: 'لكل عميل',
  cjm_20: 'يمكننا زيادة مستوى',
  cjm_21: 'رضا العملاء عن الخدمة/المنتج وفي النهاية زيادة ولائهم للشركة',
  cjm_22: 'نضمن',
  cjm_23: 'تحسين مسار المستهلك مع مراعاة عمليات الشركة التجارية',
  cjm_24: 'نقدم لعملائنا',
  cjm_25:
    'فرصة لاستخدام أساليب مدمجة: CATI وCAWI ومجموعات التركيز والمقابلات المتعمقة والمقابلات مع الخبراء والإثنوغرافيا وغيرها.',
  cjm_26: 'لماذا تختارنا؟',
  methods_hr_1: 'أبحاث الموارد البشرية',
  methods_hr_2:
    'احصل على رؤى موضوعية حول فريقك واكتشف كيفية تحسين أداء الموارد البشرية',
  methods_hr_3: 'بعض الأسباب التي قد تحتاج فيها إلى أبحاث الموارد البشرية',
  methods_hr_4: 'من الموظفين الذين تمت مقابلتهم',
  methods_hr_5: 'مشاريع الموارد البشرية المنفذة',
  methods_hr_6: 'عُقدت جلسات تدريب للموظفين',
  methods_hr_7: 'شركة أوروبية رائدة في أبحاث تجربة العملاء والموظفين',
  methods_hr_8: 'أبحاث الموارد البشرية من 4service بالأرقام',
  methods_hr_9:
    'لتحديد المشكلات ونقاط الضعف في كل مرحلة من مراحل حياة موظفي شركتك: البحث/التوظيف/الدمج/تطوير المسار المهني/إعادة الاعتماد',
  methods_hr_10: 'لمعرفة المناسبات التي تستحق الزيادات والمكافآت',
  methods_hr_11: 'تحتاج إلى التنبؤ أو تقديم حلول لعدم رضا الموظفين',
  methods_hr_12:
    'من خلال أبحاث الموارد البشرية يمكن تطوير طرق جديدة وحالية لتقييم سياسات وبرامج وممارسات الموارد البشرية',
  methods_hr_13: 'لتحسين الصحة النفسية لموظفي الشركة',
  methods_hr_14: 'إذا كنت ترغب في تحسين الإنتاجية من خلال نهج قائم على الأهداف',
  methods_hr_15: 'إذا كان لديك فريق دولي و/أو يعمل عن بُعد وتحتاج إلى إدارته',
  methods_hr_16: 'لفهم مدى جاذبية علامتك التجارية كصاحب عمل للموظفين المحتملين',
  methods_hr_17: 'رضا الموظفين',
  methods_hr_18: 'أبحاث العلامة التجارية لصاحب العمل',
  methods_hr_19: 'التنوع الثقافي',
  methods_hr_20: 'خطط التعويض والرواتب',
  methods_hr_21: 'مشاركة الفريق والولاء',
  methods_hr_22: 'الموظفون من الفئات المحمية',
  methods_hr_23: 'مجالات البحث',
  methods_hr_24: 'الحل 1',
  methods_hr_25: 'eNPS، رضا الموظفين، ولاء الموظفين',
  methods_hr_26: 'ما الذي نقيسه:',
  methods_hr_27: 'الولاء:',
  methods_hr_28:
    'ولاء الموظفين، التنبؤ بالسلوك المستقبلي، تحديد وزن العوامل التي تؤثر على الولاء',
  methods_hr_29: 'المشاركة:',
  methods_hr_30: 'مشاركة الموظفين في العمل، الاهتمام بالنتائج والإنجازات',
  methods_hr_31: 'المشاركة:',
  methods_hr_32: 'تحديد قيم الموظفين وقيم الشركة',
  methods_hr_33: 'الثقة 360:',
  methods_hr_34:
    'الثقة في الإدارة، والزملاء، والمرؤوسين، والثقة في استراتيجيات وسياسات صاحب العمل',
  methods_hr_35: 'الرضا:',
  methods_hr_36:
    'تحديد العوامل الفريدة لكل شركة، وتقييم الرضا عن كل عامل رئيسي يؤثر على الولاء',
  methods_hr_37: 'الحل 2',
  methods_hr_38: 'العلامة التجارية لصاحب العمل',
  methods_hr_39: 'صاحب العمل الداخلي',
  methods_hr_40:
    'تحليل العلامة التجارية (استطلاع الموظفين وأصحاب المصلحة والمجندين الداخليين وأخصائيي الموارد البشرية)',
  methods_hr_41: 'تحليل صاحب العمل الخارجي',
  methods_hr_42:
    '(تحليل عرض القيمة لصاحب العمل للمنافسين، استطلاع المجندين الخارجيين، استطلاع الباحثين عن عمل)',
  methods_hr_43: 'الوعي بالعلامة التجارية والسمعة',
  methods_hr_44: 'التحليل',
  methods_hr_45: 'وجود صاحب العمل',
  methods_hr_47: 'مرجعية صاحب العمل',
  methods_hr_48: 'جمع البيانات',
  methods_hr_49: 'المقارنة التنافسية',
  methods_hr_50: 'في العوامل الرئيسية مثل',
  methods_hr_51: 'الراتب،',
  methods_hr_52: 'بيئة العمل، الأجواء، طبيعة العمل',
  methods_hr_53: 'تحليل الاحتياجات والتوقعات',
  methods_hr_54: 'للباحثين عن عمل',
  methods_hr_55: 'مقابلات متعمقة،',
  methods_hr_56: 'تُستخدم البحوث المكتبية والبحوث الكمية',
  methods_hr_57: 'الحل 3',
  methods_hr_58: 'خريطة رحلة الموظف / الموظف السري',
  methods_hr_59: 'بناء رحلة الباحث عن عمل من خلال تحديد',
  methods_hr_60:
    'المراحل الرئيسية للبحث، وقنوات الاتصال، ومعايير الاختيار وتقييم الباحثين عن عمل',
  methods_hr_61: 'مراقبة جميع المراحل',
  methods_hr_62:
    'وقنوات الاتصال مع الباحثين السريين عن عمل (مثل تحديد موعد للمقابلة، أو إجراء مقابلة، أو التدريب الداخلي في الشركة)',
  methods_hr_63: 'تحديد',
  methods_hr_64: 'نقاط الضعف في عمليات التوظيف والدمج',
  methods_hr_65: 'توصيات للتحسين،',
  methods_hr_66: 'المقارنة مع قادة الصناعة',
  mystery_shopping_1: 'العميل السري',
  mystery_shopping_2: 'التسوق',
  mystery_shopping_3: 'قيّم خدمتك مع عملاء حقيقيين',
  mystery_shopping_4: 'تحقق من المعايير، قيّم موظفيك، وكن أقرب إلى عملائك',
  mystery_shopping_5:
    'نحن عضو نخبة في جمعية مقدمي خدمات التسوق السري الرائدة MSPA Europe',
  mystery_shopping_6: 'من الخبرة',
  mystery_shopping_7: 'زيارات شهرية',
  mystery_shopping_8: 'متسوقون سريون حول العالم',
  mystery_shopping_9: 'مشاريع نشطة',
  mystery_shopping_10: 'مكاتب، المقر الرئيسي في النمسا',
  mystery_shopping_11: 'مقدمو خدمات التسوق السري الأوروبيون',
  mystery_shopping_12: 'تصنيفات جودة الخدمة',
  mystery_shopping_13: 'الاستبيان',
  mystery_shopping_14: 'البرمجيات',
  mystery_shopping_15: 'ملف المتسوق',
  mystery_shopping_16: 'التحقق والاعتراض',
  mystery_shopping_17: 'التحليلات',
  mystery_shopping_18:
    'من خلال هذه الخطوات الخمس، تضمن شركتنا 4Service جودة خدمة المتسوق السري',
  mystery_shopping_19: 'البرنامج',
  mystery_shopping_20: 'العناصر الخمسة لبرنامج التسوق السري من 4Service',
  mystery_shopping_21: 'الاستبيان:',
  mystery_shopping_22: 'الجوهر الأساسي لبرنامجك',
  mystery_shopping_23: 'يُعرض هذا الجزء من البرنامج على جميع أصحاب المصلحة',
  mystery_shopping_24: 'للمدراء التنفيذيين.',
  mystery_shopping_25: 'اعرض جميع الخطوات والتفاصيل المهمة في العملية',
  mystery_shopping_26: 'للموظفين.',
  mystery_shopping_27: 'عكس ما يتوقعه أصحاب العمل منهم',
  mystery_shopping_28: 'للمتسوقين السريين.',
  mystery_shopping_29: 'منظم وواضح لتجنب الالتباس والتحيز',
  mystery_shopping_30: 'برنامج Shopmetrics:',
  mystery_shopping_31: 'سهل الاستخدام ومبتكر',
  mystery_shopping_32: 'الفوائد:',
  mystery_shopping_33: 'يتكامل',
  mystery_shopping_34: 'مع عملياتك التجارية وبرامجك',
  mystery_shopping_35: 'مدفوع باللائحة العامة لحماية البيانات (GDPR)',
  mystery_shopping_36: 'أداة إدارة الخصوصية',
  mystery_shopping_37: 'حزمة',
  mystery_shopping_38: 'الامتثال القانوني المفصل',
  mystery_shopping_39: 'منشئ',
  mystery_shopping_40: 'التقارير',
  mystery_shopping_41: 'إدارة',
  mystery_shopping_42: 'مستويات الوصول',
  mystery_shopping_43: 'معظم الاستبيانات',
  mystery_shopping_44: 'تُستكمل خلال ساعة واحدة',
  mystery_shopping_45: 'ملف المتسوقين:',
  mystery_shopping_46: 'أكثر من 200,000 متسوق سري حول العالم',
  mystery_shopping_47:
    'المعيار الرئيسي: أقصى تقارب مع جمهورك المستهدف، مع خبرة سابقة مع شركتك أو منافسيك',
  mystery_shopping_48: 'تدريب المتسوقين:',
  mystery_shopping_49: 'اختبار التدريب التمهيدي',
  mystery_shopping_50: 'مكالمة Skype / هاتفية',
  mystery_shopping_51: 'اختبار التقييم (اختياري)',
  mystery_shopping_52: 'التحقق والاعتراضات',
  mystery_shopping_53: 'التحقق',
  mystery_shopping_54: 'النظام',
  mystery_shopping_55: '100٪ من التقارير',
  mystery_shopping_56: 'يتم مراجعتها من قبل فريق التحقق',
  mystery_shopping_57: 'مكالمات إضافية',
  mystery_shopping_58: 'للتوضيح',
  mystery_shopping_59: 'تسجيلات صوتية',
  mystery_shopping_60: 'بعد الزيارة لتسجيل أهم النقاط',
  mystery_shopping_61: 'احتيال الموظفين',
  mystery_shopping_62: 'نظام الوقاية',
  mystery_shopping_63: 'الاعتراض',
  mystery_shopping_64: 'النظام',
  mystery_shopping_65: 'أي تقييم من المتسوق',
  mystery_shopping_66:
    'يمكن الاعتراض عليه من قبل الموظف مباشرة على الموقع الإلكتروني',
  mystery_shopping_67: 'يتم النظر في كل اعتراض',
  mystery_shopping_68: 'والرد عليه من قبل فريق التحقق المحلي',
  mystery_shopping_69: 'يمكنك رؤية الإحصائيات',
  mystery_shopping_70: 'للاعتراضات',
  mystery_shopping_71: 'التحليلات.',
  mystery_shopping_72: 'يتم تقديم التقرير شخصياً ويحتوي على:',
  mystery_shopping_73: 'نقاط الألم والمخاوف الخاصة بالشركة',
  mystery_shopping_74: 'النقاط الحرجة والاهتمامات',
  mystery_shopping_75: 'الديناميكيات',
  mystery_shopping_76: 'حسب الأقسام والفروع',
  mystery_shopping_77: 'الارتباط',
  mystery_shopping_78: 'بين الالتزام بالمعايير ورضا العملاء',
  mystery_shopping_79: 'المقارنة المعيارية',
  mystery_shopping_80: 'مقارنة بالمنافسين',
  mystery_shopping_81: 'توصيات',
  mystery_shopping_82: 'عملية لتحسين الخدمة',
  mystery_shopping_83: 'ما الذي يجعلنا مختلفين؟',
  mystery_shopping_84: 'نُجري جلسات توليد الأفكار',
  mystery_shopping_85:
    'نحن لا نوصي فقط بما يجب فعله، بل نبحث معك عن طرق عملية لحل مشاكل الخدمة.',
  mystery_shopping_86: 'جلسات توليد الأفكار هي أداة قوية تساعدنا على:',
  mystery_shopping_87: 'تطوير اتجاهات لتحسين المنتجات أو الخدمات',
  mystery_shopping_88:
    'استكشاف فرص تدفقات الإيرادات الجديدة واستراتيجيات الأعمال',
  mystery_shopping_89: 'إيجاد حلول للتحديات المعقدة التي تركز على العملاء',
  mystery_shopping_90: 'تحويل نقاط ألم العملاء إلى تجارب إيجابية',
  mystery_shopping_91: 'نُجري مقابلات بالفيديو',
  mystery_shopping_92:
    'نحن لا نجمع الاستبيانات فقط - بل نحصل أيضًا على تعليقات مباشرة من المتسوقين',
  mystery_shopping_93: 'نقوم بذلك من أجل:',
  mystery_shopping_94:
    'سيتولى الميسّرون لدينا إجراء مقابلات متعمقة وتقديم ملاحظات فعالة',
  mystery_shopping_95: 'رؤية التجربة من منظور العميل',
  mystery_shopping_96: 'تعزيز استراتيجية تسويق المحتوى الخاصة بك',
  mystery_shopping_97: 'التنبؤ بسلوك العميل',
  mystery_shopping_98: 'نصمم خريطة رحلة العميل',
  mystery_shopping_99:
    'تساعدنا خريطة رحلة العميل على وضع أنفسنا مكان العملاء لفهم احتياجاتهم وتحدياتهم.',
  mystery_shopping_100: 'إن إنشاء رحلة العميل هو أفضل طريقة من أجل:',
  mystery_shopping_101: 'رؤية التجربة من منظور العميل',
  mystery_shopping_102: 'تعزيز استراتيجية تسويق المحتوى الخاصة بك',
  mystery_shopping_103: 'التنبؤ بسلوك العميل',
  mystery_shopping_104: 'تحديد الثغرات في الخدمة أو الاتصالات',
  mystery_shopping_105: 'نحن نقدم أنواعًا مختلفة من التسوق الغامض',
  mystery_shopping_106: 'أنواع التسوق الغامض',
  mystery_shopping_107: 'المتسوق الغامض عبر الهاتف',
  mystery_shopping_108:
    'يتصل بمديريك و/أو مركز الاتصال لتحديد جودة الخدمة المقدمة عبر الهاتف',
  mystery_shopping_109: 'التسوق الغامض الفاخر',
  mystery_shopping_110:
    'فحص الخدمة في المواقع الفاخرة من قبل فئة خاصة من المتسوقين الغامضين',
  mystery_shopping_111: 'زيارات المنافسين',
  mystery_shopping_112: 'الطريقة الأسهل لفهم كيفية عمل منافسك',
  mystery_shopping_113: 'الموظف الغامض',
  mystery_shopping_114:
    'سيساعدك على فهم رحلة موظفك بأكملها (التوظيف، التكيف، العمليات المكتبية، إلخ.)',
  mystery_shopping_115: 'الزيارات التحفيزية',
  mystery_shopping_116:
    'أداة مفيدة لتحفيز عرض الخدمات الإضافية و/أو المنتجات، وبيع منتجات محددة',
  mystery_shopping_117: 'المتسوق الغامض عبر الإنترنت',
  mystery_shopping_118:
    'يحاكي ويقيس تجربة العملاء في متجرك عبر الإنترنت أو موقعك أو تطبيقك',
  mystery_shopping_119: 'التحقق من المبيعات والعروض الترويجية',
  mystery_shopping_120:
    'يساعد في تحديد كيفية عرض العروض الترويجية في جميع المواقع ومدى فعاليتها',
  mystery_shopping_121: 'زيارات الشراء والإرجاع',
  mystery_shopping_122:
    'يساعد على عكس العملية الكاملة من الشراء إلى الإرجاع لتحسين تجربة العميل',
  mystery_shopping_123: '> 20 سنة',
  nps_1: 'صافي نقاط الترويج',
  nps_2: 'النتيجة',
  nps_3: 'قياس وتتبع وتحسين ولاء العملاء',
  nps_4: 'يستجيبون بنتيجة من 0 إلى 6.',
  nps_5:
    'قد يكون لديهم تجربة سيئة، ومن غير المرجح أن يشتروا منك مرة أخرى، وقد يثنون الآخرين عن الشراء منك.',
  nps_6: 'هؤلاء هم المستجيبون الذين يمنحونك درجة بين 7 و8.',
  nps_7: 'هم راضون عن خدمتك ولكنهم ليسوا سعداء بما يكفي ليُعتبروا مروجين.',
  nps_8: 'هؤلاء هم المستجيبون الذين يمنحون عملك درجة 9 أو 10.',
  nps_9: 'هذا يعني أنهم سيوصون بك لصديق أو زميل، وبالتالي يدافعون عنك.',
  nps_10: 'ما هو NPS؟',
  nps_11: 'يقيس تصور العميل بناءً على سؤال واحد بسيط:',
  nps_12:
    'ما مدى احتمالية أن توصي بـ [المنظمة / المنتج / الخدمة] لصديق أو زميل؟',
  nps_13: 'هل تحتاج شركتي إلى ذلك؟',
  nps_14: 'NPS هو نموك المستدام',
  nps_15: 'فهم ديناميكيات ولاء العملاء',
  nps_16: 'تحفيز موظفيك',
  nps_17: 'فهم العلاقة مع المنتجات المختلفة',
  nps_18: 'مقارنة كيفية تعامل العملاء معك ومع منافسيك',
  nps_19: 'ماذا يمكنني أن أفعل بـ NPS؟',
  nps_20: 'لأي نوع من الأعمال يكون NPS ذا صلة؟',
  nps_21: 'طرق جمع المعلومات:',
  nps_22: 'توصياتنا عند العمل مع NPS',
  nps_23: 'هذا يعني أننا نطور إرشادات للمساعدة في تحويل المنتقدين إلى مروجين',
  nps_24: 'نحن نعمل بطريقة "الحلقة المغلقة"',
  nps_25: 'NPS هو بحث تتبعي نتابع فيه التغيرات في ولاء العملاء',
  nps_26: 'نراقب الديناميكيات',
  nps_27: 'نقترح دائمًا تقييم المنافسين في مجالك لتحليل أكثر عمقًا',
  nps_28: 'تقييم المنافسين',
  price_monitoring_1: 'مراقبة الأسعار',
  price_monitoring_2: 'مراقبة البيع بالتجزئة',
  price_monitoring_3:
    'زيادة إمكانات المبيعات وتحسين سياسة التسعير الخاصة بك من خلال مراقبة أسعار المنافسين',
  price_monitoring_4:
    'تقدم شركة 4Service خدمات مراقبة الأسعار في جميع أنحاء العالم منذ أكثر من 20 عامًا',
  price_monitoring_5:
    'تُراقب الأسعار في وقت قصير من قبل فريقنا من المدققين المؤهلين داخليًا، مما يتيح لنا الاستجابة بسرعة لتغيرات أسعار المنافسين',
  price_monitoring_6:
    'التحديات التي يمكن لشركتنا مساعدتك في حلها من خلال مراقبة الأسعار',
  price_monitoring_7: 'تقييم أسعار المنافسين',
  price_monitoring_8: 'وسياسات المنتجات',
  price_monitoring_9: 'مراقبة العروض الترويجية',
  price_monitoring_10: 'والعروض الخاصة',
  price_monitoring_11: 'مراقبة ظروف السوق',
  price_monitoring_12: 'وبيئة السوق',
  price_monitoring_13: 'التحقق من منافذ البيع والسيطرة عليها',
  price_monitoring_14: 'للمعدات والسلع الخاصة',
  price_monitoring_15: 'إدارة تدفق المنتج',
  price_monitoring_16: 'داخل التجارة',
  price_monitoring_17: 'تحسين الشروط',
  price_monitoring_18: 'لتحسين التعاون مع الموردين والوكلاء',
  price_monitoring_19: 'قياس مساحة الرف،',
  price_monitoring_20: 'تقييم وضع السلع وتوافر المخزون',
  price_monitoring_21: 'المؤشرات الرئيسية ومعايير المراقبة',
  price_monitoring_22: 'تُجمع جميع البيانات في واجهة واحدة تشمل:',
  price_monitoring_23: 'اسم',
  price_monitoring_24: 'المنتج وفئة العلامة التجارية',
  price_monitoring_25: 'توفر',
  price_monitoring_26: 'المواد الترويجية',
  price_monitoring_27: 'السعر',
  price_monitoring_28: 'وتوافر أي عروض ترويجية',
  price_monitoring_29: 'الرف',
  price_monitoring_30: 'الحجم',
  price_monitoring_31: 'المنتج',
  price_monitoring_32: 'العرض',
  price_monitoring_33: 'رمز الصنف (SKU)',
  price_monitoring_34: 'الواجهة الأمامية',
  price_monitoring_35: 'النوع',
  price_monitoring_36: 'من التغليف',
  price_monitoring_37: 'أي معلومات أخرى',
  price_monitoring_38: 'عامة',
  price_monitoring_39: 'تحليل ما قبل المشروع:',
  price_monitoring_40: 'نقوم بدراسة',
  price_monitoring_41:
    'سياسة التسعير والمنتجات في شركتك، والممارسات التجارية والصناعية',
  price_monitoring_42: 'نقوم بتوفير',
  price_monitoring_43: 'تدريب واختبار وشهادات سريعة للمراجعين',
  price_monitoring_44: 'نقوم بتخصيص',
  price_monitoring_45: 'وتكوين البرنامج',
  price_monitoring_46: 'العمل الميداني:',
  price_monitoring_47: 'زيارات إلى متاجر البيع بالتجزئة',
  price_monitoring_48: 'ومنافذ البيع',
  price_monitoring_49: 'إعداد التقارير:',
  price_monitoring_50: 'يقوم فريقنا التحليلي',
  price_monitoring_51: 'بإعداد تقارير عبر الإنترنت في الحسابات الشخصية للشركة',
  price_monitoring_52: 'نحن نقدم',
  price_monitoring_53:
    'تقريرًا مصورًا كاملًا، وتقرير PowerPoint، وتقرير Excel حسب نوع المنطقة، واسم السلسلة، وعنوان المتجر',
  price_monitoring_54: 'كيف',
  price_monitoring_55: 'يعمل',
  price_monitoring_56: 'حجم الخصومات الفردية',
  price_monitoring_57: 'حساب التكلفة',
  price_monitoring_58: 'حجم المكافآت الفردية',
  price_monitoring_59: 'برامج الولاء',
  price_monitoring_60: 'إلخ.',
  price_monitoring_61: 'نستخدم برامج متخصصة:',
  price_monitoring_62: 'PRADATA وShopmetrics ونقدم دعمًا فنيًا شاملًا',
  price_monitoring_63: 'نشر سريع',
  price_monitoring_64: 'وتوسيع النطاق (من اليوم الأول)',
  price_monitoring_65: 'جميع البيانات مؤكدة',
  price_monitoring_66: 'من خلال الصور ووضع العلامات بنظام GPS',
  price_monitoring_67: 'لدينا العدد اللازم',
  price_monitoring_68: 'من العملاء الميدانيين في أي بلد',
  price_monitoring_69: 'يمكننا التعامل مع كميات كبيرة',
  price_monitoring_70: 'من البيانات',
  price_monitoring_71: 'مراقبة الأسعار الفردية',
  price_monitoring_72:
    'إذا كانت لديك منتجات معقدة - يمكننا مساعدتك في تحديد استراتيجية التسعير الخاصة بك',
  price_monitoring_73:
    'يمكننا مراقبة أسعار المنافسين الفرديين، على سبيل المثال:',
  price_monitoring_74: 'منخفضة',
  price_monitoring_75: 'التكلفة',
  price_monitoring_76: 'عالية',
  price_monitoring_77: 'الكفاءة',
  price_monitoring_78: 'تقرير Excel',
  price_monitoring_79: 'تقرير PowerPoint',
  price_monitoring_80: 'تقرير BI',
  price_monitoring_81:
    'تساعدك بيانات تسعير المنافسين على اتخاذ أفضل قرارات التسعير',
  price_monitoring_82:
    'نحن نقدم تقريرًا مصورًا كاملًا، وتقرير PowerPoint، وتقرير Excel حسب نوع المنطقة',
  qualitative_research_1: 'البحوث',
  qualitative_research_2: 'النوعية',
  qualitative_research_3:
    'جمع وتحليل وتفسير البيانات من خلال ملاحظة أفعال وكلمات عملائك',
  qualitative_research_4: 'القيم',
  qualitative_research_5: 'السلوك',
  qualitative_research_6: 'الخلفية',
  qualitative_research_7: 'التوقعات',
  qualitative_research_8: 'البيئة',
  qualitative_research_9: 'المخاوف / العوائق',
  qualitative_research_10: 'ما هو الغرض من اختيار العميل؟',
  qualitative_research_11: 'رجل مع هاتف',
  qualitative_research_12: 'العلامة التجارية',
  qualitative_research_13: 'الفئة',
  qualitative_research_14: 'الإعلان',
  qualitative_research_15: 'المنتج',
  qualitative_research_16:
    'تكمن خصوصية الأساليب النوعية في أنها تتيح لنا فهم الأسباب والدوافع وراء سلوك المستهلكين',
  qualitative_research_17: 'تحليل موقف المستهلك تجاه ظاهرة معينة',
  qualitative_research_18: 'وجهات نظر وتجارب فردية',
  qualitative_research_19: 'الموضوعات التي لا يمكن دراستها من خلال الاستطلاعات',
  qualitative_research_20: 'الموضوعات الحساسة',
  qualitative_research_21: 'جمهور يصعب الوصول إليه',
  qualitative_research_22: 'جغرافيا معقدة',
  qualitative_research_23: 'المقابلات المتعمقة مفيدة من أجل:',
  qualitative_research_24: 'المقابلات المتعمقة',
  qualitative_research_25:
    'المقابلة المتعمقة هي تقنية بحث نوعي تتضمن إجراء مقابلات فردية مع المستجيبين لاستكشاف وجهات نظرهم حول فكرة أو برنامج أو موقف معين. تستكشف المقابلة المتعمقة التجارب الفردية / التصورات / الممارسات بتفصيل غني.',
  qualitative_research_26: 'الأهداف:',
  qualitative_research_27: 'توصيف المعايير الاجتماعية والثقافية',
  qualitative_research_28: 'جمهور يصعب الوصول إليه',
  qualitative_research_29:
    'المشاركة والمقارنة (مورغان) التي يتم التحقيق فيها من خلال الاستطلاعات',
  qualitative_research_30: 'الموضوعات التي لا يمكن دراستها من خلال الاستطلاعات',
  qualitative_research_31: 'مجموعات التركيز المتعمقة مفيدة من أجل:',
  qualitative_research_32: 'مجموعات التركيز',
  qualitative_research_33:
    'استكشاف عميق للاجتماعات الفردية والنقاشات الناشئة والمناقشات بين المشاركين تحت تأثير منسق المجموعة.',
  qualitative_research_34:
    'توليد رؤى حول التجارب المشتركة والمعايير الاجتماعية من خلال المناقشة الجماعية، والبيانات السردية في نقاش مركز.',
  qualitative_research_36: 'الفوائد:',
  qualitative_research_37:
    'دراسة نمط الحياة وسلوك المستهلك في ظروف واقعية مختلفة (في المنزل، في نقطة البيع، في العمل، إلخ.)',
  qualitative_research_38:
    'البحث عن رؤى لتطوير منتجات جديدة، التغليف، تحسين الخدمات، إلخ.',
  qualitative_research_39: 'البحث الإثنوغرافي المتعمق مفيد من أجل:',
  qualitative_research_40: 'البحث الإثنوغرافي',
  qualitative_research_41:
    'الإثنوغرافيا هي نوع من البحث النوعي يتضمن الانغماس في مجتمع أو منظمة معينة لمراقبة سلوكهم وتفاعلاتهم عن قرب.',
  qualitative_research_42:
    'الإثنوغرافيا هي منهج بحث مرن يسمح لك بفهم عميق للثقافة المشتركة والعادات والديناميكيات الاجتماعية للمجموعة. ومع ذلك، فإنه يتضمن أيضًا بعض التحديات العملية والأخلاقية.',
  qualitative_research_43: 'الطرق:',
  qualitative_research_44:
    'الإثنوغرافيا هي دراسة للمستهلك في ظروف الحياة الواقعية وتفاعله مع المنتج / الخدمة',
  qualitative_research_45: 'مزايا العمل معنا',
  qualitative_research_46:
    'يمكننا إيجاد المستجيبين من أي جمهور مستهدف. ونحن نتحكم في جودة عملية التوظيف',
  qualitative_research_47: 'توظيف من أي درجة من التعقيد',
  qualitative_research_48: 'منسقونا متعددو اللغات ولديهم مهارات التيسير',
  qualitative_research_49: 'منسقون خبراء',
  qualitative_research_50: 'العمل عبر الإنترنت / دون اتصال',
  qualitative_research_51: 'نحن نوفر تسجيلات',
  qualitative_research_52: 'صوتية / مرئية',
  qualitative_research_53: 'يمكننا إجراء بحث نوعي في أي منطقة',
  quantitative_research_1: 'دراسة رضا العملاء',
  quantitative_research_2: 'عن منتج أو خدمة معينة (SCI, NPS)',
  quantitative_research_3: 'إجراء تقسيم السوق',
  quantitative_research_4: 'واستطلاعات الأسواق المختلفة',
  quantitative_research_5: 'أبحاث السوق',
  quantitative_research_6: 'إدارة مؤشر NPS',
  quantitative_research_7: 'تحليل المنافسين',
  quantitative_research_8: 'الأبحاث',
  quantitative_research_9: 'الكمية',
  quantitative_research_10:
    'منهجية بحث تُستخدم لاختبار النظريات حول مواقف الناس وسلوكياتهم استنادًا إلى بيانات موضوعية رقمية وإحصائية',
  quantitative_research_11: 'سنوات',
  quantitative_research_12: 'من خبرة تجربة العملاء في جميع أنحاء العالم',
  quantitative_research_13: 'لوحة',
  quantitative_research_14: 'من المستجيبين',
  quantitative_research_15: 'بلدان',
  quantitative_research_16: 'ندير المشاريع في جميع أنحاء العالم',
  quantitative_research_17: 'من نحن',
  quantitative_research_18:
    'تُعد 4Service شركة عالمية لأبحاث التسويق وتجربة العملاء. نحن نقدم خدمات جمع البيانات المتخصصة لمجموعة واسعة من الأعمال',
  quantitative_research_19: '4Service بالأرقام',
  quantitative_research_20: 'المقابلات عبر الإنترنت بمساعدة الحاسوب',
  quantitative_research_21: 'استطلاعات الويب',
  quantitative_research_22:
    'تقنية استبيان عبر الإنترنت، يقوم المستجيب بإكمال الاستبيان الإلكتروني دون مساعدة من المحاور. يمكن إرسال الاستبيان إلكترونيًا أو نشره على الموقع الإلكتروني.',
  quantitative_research_23: 'المقابلات عبر الإنترنت بمساعدة الحاسوب',
  quantitative_research_24: 'في معظم الحالات',
  quantitative_research_25:
    'تُعد هذه الطريقة الأكثر فعالية من حيث التكلفة المادية والوقت',
  quantitative_research_26: 'يوفر هذا الاستطلاع',
  quantitative_research_27: 'فرصة لإجراء مقابلات مع جمهور يصعب الوصول إليه',
  quantitative_research_28: 'يوفر إمكانيات واسعة',
  quantitative_research_29: 'لعرض المواد المرئية والصوتية وكذلك الصور',
  quantitative_research_30: 'يمكن أن يكون المستجيبون',
  quantitative_research_31: 'في أي مكان في العالم',
  quantitative_research_32: 'يسمح هذا الأسلوب بدراسة',
  quantitative_research_33:
    'السلوك المحدد لجمهور الإنترنت. يمكن للعميل الوصول إلى النتائج الرئيسية في الوقت الفعلي عبر واجهة الويب',
  quantitative_research_34: 'مناسب لأي موضوع سري،',
  quantitative_research_35:
    'حساس أو شخصي قد يتردد المستجيبون في الإجابة عليه عند التحدث إلى المحاور',
  quantitative_research_36: 'أكثر من 150,000 لوحة',
  quantitative_research_37: 'لدينا لوحة خاصة بنا من المستجيبين حول العالم',
  quantitative_research_38: 'نحن نعمل مع الطلبات الصعبة',
  quantitative_research_39:
    'باستخدام أدوات تكميلية (وسائل التواصل الاجتماعي، الإعلانات)، يمكننا العثور على جمهور محدد وملف تعريف معقد للمستجيب',
  quantitative_research_40: 'نحفز مستجيبينا',
  quantitative_research_41:
    'لقد صممنا إطار عمل لتشجيع إكمال الاستطلاعات الطويلة من خلال تقديم حوافز مادية',
  quantitative_research_42: 'المقابلات المباشرة وجهًا لوجه',
  quantitative_research_43: 'تُجرى باستخدام جهاز لوحي',
  quantitative_research_44:
    'يُعد هذا أحد الأساليب الرئيسية لجمع البيانات الكمية، حيث يتواصل المحاور مباشرة مع المستجيب من خلال استبيان منظم بدقة.',
  quantitative_research_45:
    'يمكن إجراء المقابلات وجهًا لوجه في مكان عمل المستجيبين أو في منازلهم أو في الشوارع أو في نقاط البيع المحددة باستخدام الجهاز اللوحي',
  quantitative_research_46:
    'المقابلات وجهًا لوجه التي تُجرى باستخدام الجهاز اللوحي',
  quantitative_research_47: 'تحديد مستوى',
  quantitative_research_48: 'الشعبية والتعرف على العلامة التجارية',
  quantitative_research_49: 'تقسيم المستهلكين',
  quantitative_research_50: 'استنادًا إلى سلوكهم الشرائي',
  quantitative_research_51: 'تحليل فعالية',
  quantitative_research_52: 'الحملة الإعلانية',
  quantitative_research_53: 'رضا العملاء',
  quantitative_research_54: 'القياس',
  quantitative_research_55: 'تحديد أفضل سعر',
  quantitative_research_56: 'للمنتج أو الخدمة',
  quantitative_research_57: 'التحليل',
  quantitative_research_58: 'لتفضيلات المستهلكين',
  quantitative_research_59: 'دراسة',
  quantitative_research_60: 'كيفية شراء المستهلكين',
  quantitative_research_61: 'التقييم',
  quantitative_research_62: 'لسعة السوق',
  quantitative_research_63: 'برنامج DigSee',
  quantitative_research_64:
    'نستخدم برنامجًا خاصًا بالتسجيل الصوتي ونظام تحديد المواقع GPS',
  quantitative_research_65: 'المحاورون والمشرفون',
  quantitative_research_66:
    'يمكننا إجراء المقابلات بأي لغة وترجمتها إلى اللغة المفضلة للعميل',
  quantitative_research_67: 'اختيار العينة',
  quantitative_research_68:
    'يقوم القسم التحليلي بتطوير نظام لتجنيد المستجيبين من أجل الحصول على أفضل نتيجة ممكنة',
  quantitative_research_69: 'المقابلات الهاتفية بمساعدة الحاسوب',
  quantitative_research_70: 'استطلاعات الهاتف',
  quantitative_research_71:
    'منهجية لجمع المعلومات الكمية من خلال المقابلات الهاتفية باستخدام استبيان منظم بوضوح.',
  quantitative_research_72: 'المقابلات الهاتفية بمساعدة الحاسوب',
  quantitative_research_73: 'لدينا مراكز اتصال خاصة بنا',
  quantitative_research_74:
    'نستخدم برنامجًا خاصًا بالتسجيل الصوتي ونظام تحديد المواقع GPS',
  quantitative_research_75: 'المشغلون المؤهلون',
  quantitative_research_76:
    'يتحدث مشغلونا لغات مختلفة، وهم مدربون جيدًا ويتم اختبارهم باستمرار لتحسين مهاراتهم',
  quantitative_research_77: 'قواعد البيانات',
  quantitative_research_78:
    'نحن نعمل مع قواعد بياناتنا الخاصة وكذلك مع قواعد بيانات عملائك',
  quantitative_research_79: 'اتفاقية مستوى الخدمة (SLA)',
  quantitative_research_80: 'نضمن الجودة ونوقع اتفاقية مستوى الخدمة (SLA)',
  quantitative_research_81: 'تحديد الأهداف',
  quantitative_research_82: 'تحديد المنهجية',
  quantitative_research_83: 'التقسيم واختيار العينة',
  quantitative_research_84: 'تحديد قنوات جمع البيانات',
  quantitative_research_85: 'إنشاء استبيان منطقي للمستجيب',
  quantitative_research_86: 'عملية جمع البيانات',
  quantitative_research_87: 'ضمان الجودة',
  quantitative_research_88: 'تقنيات التحليل',
  quantitative_research_89: 'معالجة البيانات',
  quantitative_research_90: 'تصميم الاستبيان',
  quantitative_research_91:
    'تتبع موقع المحاورين باستخدام نظام تحديد المواقع GPS',
  quantitative_research_92: 'التحقق من البيانات',
  quantitative_research_93: 'برمجة واختبار الاستبيان',
  quantitative_research_94: 'التحقق من صحة البيانات',
  quantitative_research_95:
    'تسجيلات صوتية مع الالتزام بمتطلبات اللائحة العامة لحماية البيانات (GDPR)',
  quantitative_research_96: 'تدريب وكفاءة فريق البحث',
  quantitative_research_97: 'ضمان الجودة',
  quantitative_research_98: 'التحليل العاملي',
  quantitative_research_99: 'التقسيم',
  quantitative_research_100: 'الخرائط الإدراكية',
  quantitative_research_101: 'الارتباط',
  quantitative_research_102: 'نموذج التحويل',
  quantitative_research_103: 'جاكارد',
  quantitative_research_104: 'التحليل العنقودي',
  quantitative_research_105: 'إلخ.',
  quantitative_research_106: 'التقارير التحليلية',
  quantitative_research_107:
    'نستخدم برنامج SPSS® وأدوات أخرى لبناء تقارير تحليلية باستخدام مناهج مختلفة',
  quantitative_research_108: 'ما التحديات التجارية التي يمكن حلها:',
  quantitative_research_109: 'ما التحديات التجارية التي يمكن حلها:',
  social_responsibility_1: 'المسؤولية الاجتماعية لشركة 4Service',
  social_responsibility_2:
    'من قلب وروح كل عضو في فريقنا، نحاول الحفاظ على شرارة اللطف داخل كل موظف وجعل العالم من حولنا أفضل قليلاً',
  social_responsibility_3: 'الأنشطة التعليمية / دعم الشباب',
  social_responsibility_4: 'مبادراتنا التوعوية للأطفال والطلاب',
  social_responsibility_5: 'لعبة الأعمال "هوس الخدمة"',
  social_responsibility_6:
    'جزء مهم من أنشطتنا التدريبية هو لعبة الأعمال "هوس الخدمة".',
  social_responsibility_7:
    'تدفعك لعبة "هوس الخدمة" إلى التفكير الاستراتيجي في كيفية التعامل مع المواقف غير المعتادة.',
  social_responsibility_8: 'عرض بحثي / Diiya. الأعمال',
  social_responsibility_9:
    'وجهة نظر الأعمال والعملاء حول وضع الخدمة: عرض نتائج أبحاث 4Service من قبل فيكتوريا سكوربوتا، مديرة التطوير في 4Service أوكرانيا',
  social_responsibility_10: 'جلسات تصميم الخدمة',
  social_responsibility_11:
    'تُعد منهجية تصميم الخدمة جزءًا مهمًا من 4Service. قبل بضع سنوات أصبحنا شريكًا لأكاديمية DesignThinkers ونحن لا نستخدم أفضل الممارسات فحسب، بل نقدم أيضًا تدريبات للشركات الرائدة',
  social_responsibility_12: 'الأعمال الخيرية / التطوع',
  social_responsibility_13:
    'دور الأيتام، ودور رعاية المسنين، والتطوع لدعم الجيش الأوكراني. هذا هو الجزء الأكثر تأثيرًا في أنشطتنا',
  social_responsibility_14: '#HelpEasyWith4ServiceGroup',
  social_responsibility_15:
    'نحن نعمل بالشراكة مع مؤسسة "بلاغومَي" الخيرية ونسعى لإدخال الفرح وتقديم المساعدة لأولئك الذين هم في أمس الحاجة',
  social_responsibility_16: 'جمع التبرعات لدور الأيتام ودور التقاعد',
  social_responsibility_17:
    'قمنا في 4Service بإطلاق عدة حملات لجمع التبرعات لدور التقاعد ودور الأيتام لشراء الاحتياجات الأساسية',
  social_responsibility_18: '#SaveUkraine',
  social_responsibility_19:
    'أثرت الحرب على العديد من موظفينا وأصدقائنا المقربين. كل واحد منا يساعد قدر استطاعته',
  social_responsibility_20: 'رعاية الحيوان',
  social_responsibility_21:
    'يمكن لأي شخص القدوم إلى مكتبنا مع حيوانه الأليف. نحن نساعد الملاجئ ونجمع التبرعات للطعام وأحيانًا نبحث عن منازل للحيوانات المشردة',
  social_responsibility_22: 'دعم ملاجئ الحيوانات',
  social_responsibility_23:
    'تحتاج الحيوانات المشردة إلى المساعدة بقدر ما يحتاجها جميع أفراد مجتمعنا الضعفاء.',
  social_responsibility_24:
    'لقد تبنت شركتنا مأوى الحيوانات الضالة "سيريوس" (منطقة كييف، أوكرانيا).',
  social_responsibility_25: 'مبادرات إبداعية لمساعدة الحيوانات المشردة',
  social_responsibility_26:
    'كيف يمكننا جذب انتباه عملائنا وشركائنا إلى قضية ملاجئ الحيوانات الملحّة؟',
  social_responsibility_27: 'مكتب صديق للحيوانات الأليفة',
  social_responsibility_28:
    'يمتلك العديد من أعضاء فريقنا حيوانات أليفة. لقد أنشأنا بيئة صحية يمكن للجميع القدوم فيها إلى المكتب مع حيواناتهم الأليفة والشعور بالراحة',
  ux_testing_1: 'اختبار تجربة المستخدم (UX)',
  ux_testing_1_1: 'اختبار تجربة المستخدم (UX)',
  ux_testing_2:
    'منهج يجمع بين الإنسان والذكاء الاصطناعي لاختبار وتحسين مواقعك الإلكترونية وتطبيقاتك',
  ux_testing_3: 'ما هو اختبار تجربة المستخدم',
  ux_testing_4:
    'يساعدك اختبار تجربة المستخدم على فهم كيفية تفاعل الأشخاص مع منتجك أو تطبيقك أو موقعك الإلكتروني',
  ux_testing_5: 'التنقل غير واضح بدرجة كافية',
  ux_testing_6: 'ليس لدي أي فكرة عن كيفية تقديم الطلب',
  ux_testing_7: 'لا توجد صور كافية في الكتالوج',
  ux_testing_8: 'ستقوم بـ:',
  ux_testing_9: 'اكتشاف فرص التحسين',
  ux_testing_10: 'تحديد المشكلات في التصميم وتفاعل العميل',
  ux_testing_11: 'معرفة الصعوبات التي يواجهها المستخدم أثناء تفاعله مع الموقع',
  ux_testing_12: 'مراقبة رحلة العميل',
  ux_testing_13: 'التعرف على متى ولماذا يغادر جمهورك المستهدف الموقع',
  ux_testing_14: 'تحديد الأقسام التي تثير أقل أو أكثر قدر من الاهتمام والمشاعر',
  ux_testing_15: 'اختبار تجربة المستخدم القائم على المستخدمين',
  ux_testing_16:
    'توفر لك 4Service الرؤى البشرية الحقيقية التي تحتاجها لإنشاء مواقع وتطبيقات تركز على العملاء باستخدام الطرق الكمية والنوعية',
  ux_testing_17: 'لا أفهم كيفية استخدام الموقع. أين القائمة المخفية؟',
  ux_testing_18: 'أعتقد أن هناك مسافة كبيرة جدًا بين الحروف، والنص غير مقروء',
  ux_testing_19: 'الصور تتداخل مع بعضها البعض، هل هذا من المفترض أن يكون هكذا؟',
  ux_testing_20:
    'يساعدك اختبار تجربة المستخدم على فهم كيفية تفاعل الأشخاص مع منتجك أو تطبيقك أو موقعك الإلكتروني',
  ux_testing_21: 'تصميم البحث لاختبار تجربة المستخدم القائم على المستخدمين:',
  ux_testing_22: 'اكتشف فرص التحسين',
  ux_testing_23: 'تحديد نوع وطريقة الاختبار (نوعي / كمي)',
  ux_testing_24: 'صياغة الفرضيات وسيناريوهات المستخدم',
  ux_testing_25: 'تحليل وتقرير نتائج الاختبار',
  ux_testing_26: 'حلّان',
  ux_testing_27: 'نحن نقدم نهجين لاختبار UX ناجح',
  ux_testing_28: 'اختبار UX يعتمد على المستخدم',
  ux_testing_29: 'اختبار UX يعتمد على الذكاء الاصطناعي والبشر',
  ux_testing_30: 'نقاط قوتنا:',
  ux_testing_31: 'يمكننا تحليل المشهد التنافسي',
  ux_testing_32: 'يمكننا إشراك خبراء متخصصين لإجراء المقابلات والمشاركة فيها',
  ux_testing_33:
    'يمكننا إجراء مقابلات بلغات مختلفة وترجمتها إلى اللغة المطلوبة',
  ux_testing_34: 'مع قابلية الاستخدام الحالية',
  ux_testing_35: 'المقاييس أو المعايير',
  ux_testing_36: 'أداؤك',
  ux_testing_37: 'مقارنةً بمنافسك',
  ux_testing_38: 'الإصدارات',
  ux_testing_39: 'من نفس المنتج',
  ux_testing_40: 'تقييم الرضا',
  ux_testing_41: 'مؤشر NPS',
  ux_testing_42: 'معدلات النجاح',
  ux_testing_43: 'معدل الخطأ',
  ux_testing_44: 'وقت إكمال المهمة',
  ux_testing_45: 'اختبار UX يعتمد على المستخدم',
  ux_testing_46: 'المنهج الكمي',
  ux_testing_47:
    'نستخدم ما لا يقل عن 100 شخص للمشاركة في اختبار UX في هذه المرحلة',
  ux_testing_48: 'مناسب عندما تحتاج إلى مقارنة موقعك الإلكتروني أو تطبيقك:',
  ux_testing_49: 'يقيس المنهج الكمي:',
  ux_testing_50: 'الملاحظة',
  ux_testing_51:
    'قضاء الوقت مع مستخدم أو مجموعة من المستخدمين وملاحظة سلوكهم مع المنتج أثناء استخدامه في الحياة اليومية',
  ux_testing_52: 'المقابلة المتعمقة',
  ux_testing_53:
    'تتيح لك معرفة مواقف ومعتقدات ورغبات وتجارب المستخدمين الذين يزورون موقعك. نوصي بإجراء 15-20 مقابلة',
  ux_testing_54: 'البحث الإثنوغرافي',
  ux_testing_55:
    'يُجرى في بيئة المستجيبين حيث سيستخدمون المنتج. من خلال الملاحظة، تبدأ في فهم جيد لعلم نفس المستخدم والتحديات العاطفية التي يواجهها.',
  ux_testing_56: 'اختبار UX يعتمد على المستخدم',
  ux_testing_57: 'المنهج النوعي',
  ux_testing_58: 'تساعد هذه الطريقة على فهم دوافع وسلوك المستخدمين ومنطقهم',
  ux_testing_59: 'نحن نستخدم:',
  ux_testing_60: 'نحن نطور خريطة رحلة العميل لتوضيح نتائج أبحاثنا',
  ux_testing_61: '30 مشاركًا (ذكور/إناث)',
  ux_testing_62: 'يتم فحص المستجيبين مسبقًا ودعوتهم للمشاركة في الاستطلاع',
  ux_testing_63: 'مقابلات عبر الإنترنت عن بُعد على منصة Wantent',
  ux_testing_64: 'يعتمد على الذكاء الاصطناعي والبشر',
  ux_testing_65: 'اختبار UX يعتمد على الذكاء الاصطناعي والبشر',
  ux_testing_66:
    'مزيج من تقنية الذكاء الاصطناعي الفريدة Wantent والمستخدمين الحقيقيين',
  ux_testing_67: 'الخط الكبير في العنوان جذب الانتباه',
  ux_testing_68:
    "ينظر المستخدمون إلى الأرقام 'البارزة' ولكنهم لا يقرؤون المعلومات المجاورة لها",
  ux_testing_69:
    'يساعد اختبار UX على فهم كيفية تفاعل الأشخاص مع منتجك أو تطبيقك أو موقعك الإلكتروني',
  ux_testing_70: 'تصميم أبحاث الاختبار القائم على الذكاء الاصطناعي والبشر',
  ux_testing_71: 'كيف يعمل',
  ux_testing_72:
    'Wantent هو حل يعتمد على الذكاء الاصطناعي لتناسب المحتوى مع السوق.',
  ux_testing_73:
    'تُقدّر Wantent كفاءة المواقع والتطبيقات من خلال تطبيق تقنيات التعلم الآلي لتحليل ردود الفعل العاطفية ومشاركة الجمهور.',
  ux_testing_74:
    'لتفسير النتائج، نستخدم تقنيات سرد القصص والتنوع والتعاطف لتعزيز الأداء والنمو.',
  ux_testing_75: 'انتباه المستخدم ومشاعره أثناء التنقل بين الأقسام',
  ux_testing_76: 'إحصاءات حسب مجموعة المشاركين (الانتباه والتركيز طوال الجلسة)',
  ux_testing_77: 'تحليل تحويل الصفحات',
  ux_testing_78: 'الانتباه والمشاعر أثناء أداء المهام',
  ux_testing_79: 'النتائج المتعلقة بالإدراك',
  ux_testing_80: 'لموقع الويب من قبل مجموعات مختلفة من المشاركين',
  ux_testing_81: 'تحليل سهولة',
  ux_testing_82: 'التنقل بين الصفحات وسهولة العثور على العناصر المهمة',
  ux_testing_83: 'تحليل الإدراك',
  ux_testing_84: 'للمعلومات المقدمة على الموقع الإلكتروني',
  ux_testing_85: 'تحديد المجالات',
  ux_testing_86:
    'التي تحتاج إلى تحسين داخل الصفحات الفردية (التنقل، كتل المعلومات، إلخ.)',
  ux_testing_87: 'نحن نحلل بالتفصيل',
  ux_testing_88: 'النتائج الرئيسية للبحث',
  ux_testing_89: 'توصيات لتحسين هيكل الموقع وصفحات محددة',
  ux_testing_90: 'نحن نختار بعناية الجمهور المستهدف لاختبار سهولة الاستخدام.',
  ux_testing_91:
    'نجري أبحاثًا في بلدان مختلفة، وبغات مختلفة، وبين مجموعات مستخدمين متنوعة',
  ux_testing_92: 'يمكننا إجراء الاختبارات في التطبيقات',
  ux_testing_93: 'وعلى مواقع المنافسين الإلكترونية وتقديم تحليل مقارن',
  ux_testing_94: 'نحن نجمع بين أساليب بحث مختلفة.',
  ux_testing_95: 'يساعد الميسّرون المؤهلون لدينا المشاركين في عملية الاختبار.',
  ux_testing_96: 'نقوم بإجراء الاختبارات',
  ux_testing_97: 'على مجموعة متنوعة من الأجهزة وإصدارات البرامج',
  ux_testing_98: 'لماذا تختارنا؟',
  wantent_1: '4Service ×',
  wantent_2: 'Wantent',
  wantent_3:
    'مشروع شراكة فريد بين 4Service وWantent © مزيج من الذكاء الاصطناعي ونهج قائم على الإنسان لتحليل المحتوى',
  wantent_4: 'قياس النجاح قبل عرض المحتوى',
  wantent_5: 'التقليل من مخاطر قضايا التنوع',
  wantent_6: 'رؤى متعمقة وتوصيات لتحسين المحتوى',
  wantent_7: 'قرارات موضوعية بشأن المحتوى واستراتيجية التسويق',
  wantent_8:
    'Wantent هو حل يعتمد على الذكاء الاصطناعي لتوافق المحتوى مع السوق.',
  wantent_9:
    'Wantent هو حل يعتمد على الذكاء الاصطناعي لمطابقة المحتوى مع السوق. تقوم Wantent بتقييم فعالية المحتوى المرئي باستخدام تقنيات التعلم الآلي لتحليل الاستجابة العاطفية ومشاركة الجمهور.',
  wantent_10:
    'تساعد Wantent على تحديد مدى توافق المحتوى مع السوق وتعظيم كفاءته من خلال',
  wantent_11: 'إعداد السيناريو وتجنيد المشاركين',
  wantent_12: 'تصميم مشروع مخصص وجمهور على مستوى العالم',
  wantent_13: 'جمع ردود فعل المشاهدين',
  wantent_14: 'ملاحظات مفصلة وواضحة من الجمهور',
  wantent_15: 'تحليل إدراك المحتوى',
  wantent_16: 'تحليل السلوك وردود الفعل العاطفية عبر الذكاء الاصطناعي',
  wantent_17: 'تقديم الرؤى للمرحلة النهائية',
  wantent_18: 'توصيات للتحسين',
  wantent_19: 'Wantent تزيد من كفاءة المحتوى الخاص بك إلى أقصى حد',
  wantent_20: 'اختبار مفهوم الإعلان مسبقًا',
  wantent_21: 'اختبار المفهوم الإبداعي',
  wantent_22:
    'التحقق من توافق الإبداع المستقبلي مع الاستراتيجية المطورة وفهم ردود فعل الجمهور المستهدف لإجراء التعديلات الممكنة على المفاهيم أو الرسائل الإبداعية',
  wantent_23: 'اختبار إمكانية رؤية عناصر العلامة التجارية (ما بعد الإنتاج)',
  wantent_24: 'تأكيد فعالية الاستثمار في الإعلان أو الرعاية',
  wantent_25: 'اختبار الإعلان',
  wantent_26: 'اختبار A/B',
  wantent_27:
    'مقارنة فعالية المواد الإبداعية وزيادة التفاعل والانتباه خلال مرحلة الإنتاج',
  wantent_28: 'اختبار الإعلانات المنشورة',
  wantent_29: 'تحديد أداء الرسائل وإنشاء توصيات لتحسين الصوت والصورة',
  wantent_30: 'حلول للتلفزيون',
  wantent_31:
    'الطيارون، العروض الترويجية، التنسيقات الجديدة، اختبار مقدمي البرامج',
  wantent_32: 'إجراء تحليل مقارن لتحديد الأكثر جاذبية وتعزيزه',
  wantent_33: 'اختبار البرامج التلفزيونية والأفلام الطويلة',
  wantent_34:
    'تحليل تفاعل المشاهدين ومستوى الانتباه والاستجابة العاطفية أثناء مشاهدة المحتوى الطويل في ظروف طبيعية. نقوم تلقائيًا بتحديد ذروة الانخفاض في تفاعل الجمهور ولحظات التشتت لتقييم وتحسين عملية المونتاج.',
  wantent_35: 'اختبار واجهات المستخدم وتجربة المستخدم (UI/UX)',
  wantent_36: 'اختبار نماذج المواقع الإلكترونية وتطبيقات الهواتف المحمولة',
  wantent_37: 'تحليل رد فعل المستخدمين ومشاعرهم باستخدام تقنية Wantent:',
  wantent_38: 'مستوى الانتباه',
  wantent_39: 'الاستجابات العاطفية',
  wantent_40: 'خرائط الحرارة لاتجاه نظر المشاركين',
  wantent_41:
    'تحليل سهولة استخدام المواقع والتطبيقات بناءً على ملاحظات المشاركين:',
  wantent_42: 'مقياس سهولة الاستخدام للنظام (SUS)',
  wantent_43: 'مؤشر جهد العميل (سهولة التفاعل)',
  wantent_44: 'مؤشر الترويج الصافي (NPS)',
  wantent_45: 'الامتثال للـGDPR وخصوصية المستخدمين',
  wantent_46:
    'Wantent متوافقة تمامًا مع سياسات GDPR وCCPA وتفي بمبادئ جمع وتخزين ومعالجة وحماية البيانات الشخصية للمشاركين',
  wantent_47: 'نيكيتا لوبيانتسيف',
  wantent_48: 'مدير قسم التصميم الرقمي، Reface (الوسائط والترفيه)',
  wantent_49:
    'نحن نجرب يوميًا العديد من أفكار المحتوى الجديدة باستخدام تقنيات التعلم الآلي. تساعدنا Wantent على فهم وتقييم المخاطر والمزايا، واكتشاف ملاحظات المستخدمين وسلوكهم وإدراكهم لفهم العلاقة السببية بين الجوانب المختلفة لحلولنا.',
  wantent_50: 'ألكسندر سميرنوف',
  wantent_51: 'شريك مالك في TABASCO (الإعلان)',
  wantent_52:
    'تقدم Wantent خدمة فريدة حقًا تساعدنا على معرفة التفاصيل الدقيقة لما يحبه ويكرهه المستهلكون. لا يمكن الغش، ولا يمكن الكذب — Wantent تعرف الحقيقة دائمًا، ومن خلال ذلك نحصل نحن، كخبراء تسويق، على إرشادات لا تقدر بثمن (هههه — نحن نعرف السعر بالضبط وهو في المتناول) حول كيفية تحسين اتصالاتنا.',
  wantent_53: 'التقييمات',
  terms_1: 'الشروط والأحكام',
  terms_2: 'اتفاقية شروط الاستخدام',
  terms_3:
    'يرجى قراءة اتفاقية شروط الاستخدام ("شروط الاستخدام"، "الاتفاقية") بعناية قبل استخدام الموقع الإلكتروني',
  terms_4:
    '("الموقع الإلكتروني") الذي تديره شركة 4Service Holdings GmbH ("4Service"، "نحن"، "نا"، "خاصتنا").',
  terms_5:
    'شروط الاستخدام: باستخدامك هذا الموقع الإلكتروني، فإنك تقر بأنك قد قرأت وراجعت هذه الاتفاقية وتوافق على الالتزام بشروطها. إذا كنت لا ترغب في الالتزام بشروط هذه الاتفاقية، يُنصح بمغادرة الموقع الإلكتروني. تمنح 4Service فقط حق استخدام هذا الموقع الإلكتروني ومنتجاته وخدماته لأولئك الذين قبلوا شروطه.',
  terms_6: 'سياسة الخصوصية',
  terms_7:
    'قبل أن تواصل استخدام موقعنا الإلكتروني، ننصحك بقراءة سياسة الخصوصية الخاصة بنا فيما يتعلق بجمع بيانات المستخدم. سيساعدك ذلك على فهم ممارساتنا بشكل أفضل.',
  terms_8: 'قيود العمر',
  terms_9:
    'يجب ألا يقل عمرك عن 16 (ستة عشر) عامًا قبل أن تتمكن من استخدام هذا الموقع الإلكتروني. باستخدامك هذا الموقع، فإنك تضمن أنك تبلغ من العمر 16 عامًا على الأقل ويمكنك قانونيًا الالتزام بهذه الاتفاقية. لا تتحمل 4Service أي مسؤولية عن الالتزامات المتعلقة بتضليل العمر.',
  terms_10: 'الملكية الفكرية',
  terms_11:
    'توافق على أن جميع المواد والمنتجات والخدمات المقدمة على هذا الموقع الإلكتروني هي ملكية لشركة 4Service أو الشركات التابعة لها أو المدراء أو الموظفين أو الوكلاء أو الموردين أو المرخصين، بما في ذلك جميع حقوق الطبع والنشر والأسرار التجارية والعلامات التجارية وبراءات الاختراع وغيرها من حقوق الملكية الفكرية. كما توافق على أنك لن تقوم بنسخ أو إعادة توزيع الملكية الفكرية الخاصة بـ 4Service بأي شكل، بما في ذلك التسجيلات الإلكترونية أو الرقمية أو العلامات التجارية الجديدة.',
  terms_12: 'الوصول إلى موقعنا الإلكتروني',
  terms_13:
    'يُسمح بالوصول إلى موقعنا على أساس مؤقت، ونحتفظ بالحق في سحب أو تعديل الخدمة التي نقدمها على موقعنا دون إشعار مسبق. لن نكون مسؤولين إذا كان موقعنا غير متاح لأي سبب في أي وقت أو خلال أي فترة. من حين لآخر، قد نقيد الوصول إلى بعض أجزاء موقعنا أو إلى الموقع بأكمله للمستخدمين المسجلين لدينا. أنت مسؤول عن اتخاذ جميع الترتيبات اللازمة للوصول إلى موقعنا، بما في ذلك استخدام المعدات المتوافقة مع موقعنا. كما أنك مسؤول أيضًا عن ضمان أن جميع الأشخاص الذين يصلون إلى موقعنا من خلال اتصال الإنترنت الخاص بك على دراية بهذه الشروط وأنهم يلتزمون بها.',
  terms_14: 'القانون الواجب التطبيق',
  terms_15:
    'من خلال زيارة هذا الموقع، فإنك توافق على أن قوانين جمهورية النمسا، بغض النظر عن مبادئ تعارض القوانين، ستحكم هذه الشروط والأحكام أو أي نزاع قد ينشأ بينك وبين شركة 4Service.',
  terms_16: 'النزاعات',
  terms_17:
    'يتم الفصل في أي نزاع يتعلق بأي شكل من الأشكال بزيارتك لهذا الموقع من قبل المحكمة التجارية في فيينا.',
  terms_18: 'التعويض',
  terms_19:
    'أنت توافق على تعويض شركة 4Service وشركاتها التابعة وإعفائها من أي مطالبات أو دعاوى قانونية قد تنشأ نتيجة لاستخدامك أو إساءة استخدامك لموقعنا الإلكتروني. نحتفظ بالحق في اختيار مستشارينا القانونيين بأنفسنا.',
  terms_20: 'فترة التخزين',
  terms_21:
    'مع الأخذ في الاعتبار أغراض المعالجة، فإن فترة تخزين البيانات الشخصية للمستخدمين (فترة التخزين) هي 24 شهرًا من تاريخ الحصول بشكل صحيح على موافقتك على معالجة البيانات.',
  terms_22: 'تحديد المسؤولية',
  terms_23:
    'لا تتحمل شركة 4Service أي مسؤولية عن أي أضرار قد تلحق بك نتيجة سوء استخدامك لموقعنا الإلكتروني. تحتفظ شركة 4Service بالحق، دون إشعار مسبق، في تعديل هذه الاتفاقية أو تغييرها أو تحديثها في أي وقت من خلال تحديث هذا المنشور. استمرارك في استخدام الموقع الآن أو بعد نشر أي تغييرات أو تعديلات يعني موافقتك على تلك التغييرات أو التعديلات. إذا تم إعلان أي جزء من هذه الاتفاقية غير قانوني أو باطل أو غير قابل للتنفيذ، فسيُعتبر هذا الجزء قابلاً للفصل ولن يؤثر على صلاحية وتنفيذ البنود المتبقية. سيتم تقديم أي دليل محتمل على استخدام الموقع لأغراض غير قانونية إلى السلطات المختصة. تشكل هذه الاتفاقية تفاهمًا بين شركة 4Service والمستخدم.',
  terms_24:
    'يرجى توجيه جميع الأسئلة والمخاوف المتعلقة بالخصوصية/الاستخدام إلى العنوان التالي:',
  terms_25: 'شركة 4Service Holdings GmbH',
  terms_26: 'Tegetthoffstrasse 7',
  terms_27: '1010 فيينا',
  terms_28: 'النمسا',
  terms_29: 'مراجعة',
  terms_30:
    'عندما تكون البيانات الشخصية التي زودتنا بها غير غير دقيقة، يحق لك أن تطلب منا تصحيحها بالفعل (المادة 16 من اللائحة العامة لحماية البيانات GDPR).',
  thank_you_1: 'شكرًا لك!',
  thank_you_2: 'سوف نعاود الاتصال بك خلال 24 ساعة.',
  thank_you_3: 'ملاحظة: مديرونا يراجعون بالفعل طلبك من أجل إعداد عرض أفضل.',
  thank_you_4: 'القائمة',
  thank_you_5: 'امرأة تكتب',
  privacy_policy_1:
    'نموذج إشعار الخصوصية لأصحاب البيانات (مستخدمي الموقع الإلكتروني)',
  privacy_policy_2:
    'يُقصد من نموذج إشعار الخصوصية هذا (إشعار الخصوصية) أن يُطبّق على الأفراد الطبيعيين (أصحاب البيانات) الذين يتم جمع بياناتهم الشخصية من قبل شركة 4Service Holdings GmbH، بما يتماشى مع متطلبات اللائحة العامة لحماية البيانات (GDPR) في إطار زيارة الموقع الإلكتروني.',
  privacy_policy_3:
    '(يُشار فيما بعد إلى الموقع الإلكتروني والمستخدمين على التوالي).',
  privacy_policy_4:
    'يُطبق نموذج إشعار الخصوصية لأصحاب البيانات (مستخدمي الموقع الإلكتروني) الخاص بشركة 4Service Holdings GmbH في جميع شركات مجموعة 4Service الخاضعة للسلطة القانونية أو الإشراف أو السيطرة من قبل 4Service Holdings GmbH.',
  privacy_policy_5: 'جهات الاتصال',
  privacy_policy_6: 'شركة 4Service Holdings GmbH',
  privacy_policy_7: '(الشركة / نحن / لنا),',
  privacy_policy_8: 'العنوان:',
  privacy_policy_9: 'Tegetthoffstraße 7، 1010 فيينا، النمسا.',
  privacy_policy_10: 'البريد الإلكتروني:',
  privacy_policy_12: 'من نحن؟',
  privacy_policy_13:
    'فرد (أنت) يزور الموقع لأي غرض كان. ولأغراض هذا المستند، يُشار إليك أيضًا بالمستخدم.',
  privacy_policy_14: 'البيانات الشخصية التي نجمعها منك',
  privacy_policy_15:
    'عند دخولك إلى موقعنا الإلكتروني، نرسل إليك إشعار الخصوصية الذي نطلب فيه منك منحنا موافقتك على معالجة المعلومات التالية:',
  privacy_policy_16:
    'عنوان بروتوكول الإنترنت (IP)، اسم المستخدم، اللقب، العنوان، رقم الهاتف (الأرضي أو المحمول)، عنوان البريد الإلكتروني، اسم الشركة، الدولة، الاسم الأول، الاسم الأخير، رقم الهاتف، المقاطعة، الولاية والرمز البريدي، بيانات الاستخدام، بيانات التفاعل مع الشبكات الاجتماعية أو المنصات الخارجية، معلومات التسجيل والمصادقة على الموقع الإلكتروني.',
  privacy_policy_17: 'الموقع الجغرافي.',
  privacy_policy_18:
    'في حال عبّرت عن رغبتك ومنحتنا هذه الموافقة، نبدأ في معالجة هذه المعلومات منك.',
  privacy_policy_19: 'المشروعية (الموافقة)',
  privacy_policy_20:
    'عند دخولك إلى موقعنا الإلكتروني، نرسل إليك إشعار الخصوصية الذي نطلب فيه منك منحنا موافقتك على معالجة المعلومات التالية:',
  privacy_policy_21:
    'الأساس القانوني لمعالجة البيانات الشخصية هو الموافقة، والتي نحصل عليها منك من خلال تعبئة نموذج الموافقة على الرابط التالي:',
  privacy_policy_22:
    'إذا قمت بملء نموذج الموافقة، فهذا يعني أنك تفهم وتقبل جميع الشروط المحددة في إشعار الخصوصية هذا.',
  privacy_policy_23: 'سحب الموافقة',
  privacy_policy_24:
    'لديك الحق في سحب الموافقة التي منحتنا إياها سابقًا في أي وقت. لا يؤثر سحب الموافقة على مشروعية المعالجة بناءً على الموافقة قبل سحبها. يمكنك سحب موافقتك عن طريق إرسال طلب مناسب إلينا على عنوان البريد الإلكتروني التالي withdraw@4service-group.com، ويُتاح نموذج الطلب على الرابط التالي:',
  privacy_policy_25: 'نموذج سحب الموافقة للمستخدم',
  privacy_policy_26: 'أغراض المعالجة',
  privacy_policy_27: 'نقوم بمعالجة بياناتك الشخصية للأغراض التالية:',
  privacy_policy_28:
    '– تحسين خدمات العملاء (يتيح استجابة أكثر فعالية لطلبات العملاء)؛ – تخصيص تجربة المستخدمين (يسمح بتحديد من هو الأكثر اهتمامًا بالخدمات)؛ – تحسين الموقع (يسمح بتحسين جودة المنتجات والخدمات وسهولة استخدامها، وتطوير خدمات جديدة وتعزيز منتجاتنا وخدماتنا)؛ – التواصل مع المستخدم عبر النشرات الإخبارية أو المواد التسويقية أو الترويجية وغيرها من المعلومات التي تتضمن أخبارنا وتحديثاتنا ومعلومات حول الخدمات مع ملاحظة توضح كيفية إلغاء الاشتراك من الرسائل اللاحقة)؛ – إجراء أبحاث وإحصاءات وتحليلات مختلفة بناءً على بيانات مجهولة الهوية؛ – تقديم خدمات مخصصة للمستخدم وتنفيذ الاتفاقيات والعقود؛ – مشاركة المستخدم في المشاريع المختلفة التي ننفذها من خلال الموقع، والاستجابة للاستفسارات المرسلة من قبل المستخدم عبر الموقع، والبحوث، وصيانة الحسابات والسجلات، والترويج للخدمات.',
  privacy_policy_29: 'الجهات التي يمكن نقل البيانات الشخصية إليها',
  privacy_policy_30:
    'أثناء معالجة بياناتك الشخصية، ننقل بياناتك الشخصية إلى الكيانات التي تعمل كمُعالجات لصالح الشركة. يعمل معالجو الشركة حصريًا بناءً على تعليمات الشركة. يمكن العثور على تفاصيل أنشطة معالجي الشركة وقائمة هؤلاء المعالجين في سياسة الخصوصية وحماية البيانات على الرابط التالي: سياسة الخصوصية وحماية البيانات.',
  privacy_policy_31: 'البلدان التي يمكن نقل البيانات الشخصية إليها',
  privacy_policy_32:
    'تنقل الشركة بياناتك الشخصية بناءً على قرار الملاءمة كما هو منصوص عليه في اللائحة العامة لحماية البيانات واللجنة الأوروبية. يمكن العثور على معلومات إضافية بشأن نقل البيانات الشخصية إلى الولايات المتحدة الأمريكية في سياسة الخصوصية وحماية البيانات على الرابط التالي: سياسة الخصوصية وحماية البيانات.',
  privacy_policy_33: 'مدة التخزين',
  privacy_policy_34:
    'مع مراعاة أغراض المعالجة، فإن مدة تخزين البيانات الشخصية للمستخدمين (فترة التخزين) هي 24 شهرًا من تاريخ الحصول على موافقتك بشكل صحيح على معالجة البيانات.',
  privacy_policy_35: 'الحق في الوصول',
  privacy_policy_36:
    'لديك الحق في معرفة ما إذا كانت البيانات الشخصية المتعلقة بك قيد المعالجة و2) إذا كان الأمر كذلك، فيمكنك الوصول إلى هذه البيانات مع جميع الشروط الإضافية المنصوص عليها في المادة 15 من اللائحة العامة لحماية البيانات.',
  privacy_policy_37: 'الحق في التصحيح',
  privacy_policy_38:
    'عندما تكون البيانات الشخصية التي تقدمها لنا غير دقيقة، يحق لك أن تطلب منا تصحيحها وفقًا للمادة 16 من اللائحة العامة لحماية البيانات.',
  privacy_policy_39: 'الحق في المحو (الحق في النسيان)',
  privacy_policy_40:
    'يحق لك أن تطلب منا حذف بياناتك الشخصية دون تأخير غير مبرر، ونحن ملزمون بحذف بياناتك الشخصية دون تأخير غير مبرر إذا كانت الأسباب المنصوص عليها في المادة 17 من اللائحة العامة لحماية البيانات تنطبق.',
  privacy_policy_41: 'الحق في تقييد المعالجة',
  privacy_policy_42:
    'يحق لك تقييد معالجة بياناتك الشخصية مع بعض الاستثناءات المنصوص عليها في اللائحة العامة لحماية البيانات، لا سيما في المادة 18.',
  privacy_policy_43:
    'نحن ملزمون بإبلاغك بما يتم جمعه من بيانات، وكيفية استخدامها، ومدة الاحتفاظ بها، وما إذا كانت ستتم مشاركتها مع أي أطراف ثالثة. يجب توصيل هذه المعلومات بطريقة موجزة وواضحة.',
  privacy_policy_44: 'الحق في نقل البيانات',
  privacy_policy_45:
    'يُسمح لك بالحصول على بياناتك الشخصية وإعادة استخدامها لأغراضك الخاصة عبر خدمات مختلفة.',
  privacy_policy_46: 'الحق في الاعتراض',
  privacy_policy_47:
    'يحق لك الاعتراض على معالجة البيانات الشخصية التي تقوم بها الشركة. يجب علينا التوقف عن معالجة البيانات الشخصية ما لم نثبت وجود أسباب مشروعة وقوية للمعالجة تتجاوز مصالح الفرد أو حقوقه أو حرياته، أو إذا كانت المعالجة ضرورية لتأسيس أو ممارسة أو الدفاع عن مطالبات قانونية.',
  privacy_policy_48: 'الحق في عدم الخضوع لقرار يعتمد فقط على المعالجة الآلية',
  privacy_policy_49:
    'يحق لك الاعتراض على أي تصنيف آلي يتم دون موافقة. كما يحق لك أن تتم معالجة بياناتك الشخصية بمشاركة بشرية.',
  privacy_policy_50: 'الشكاوى',
  privacy_policy_51:
    'في حال رغبتك في تقديم شكوى حول كيفية معالجة الشركة لبياناتك الشخصية (أو من قبل المعالجين الموضحين أعلاه)، أو حول كيفية التعامل مع شكواك، لديك الحق في تقديم شكوى مباشرة إلى السلطة الرقابية وإلى الشركة.',
  privacy_policy_52: 'تفاصيل الاتصال بكل من هؤلاء هي:',
  privacy_policy_53: 'السلطة الرقابية:',
  privacy_policy_54: 'هيئة حماية البيانات النمساوية',
  privacy_policy_55: 'Österreichische Datenschutzbehörde',
  privacy_policy_56: 'Wickenburggasse 8',
  privacy_policy_57: '1080 فيينا',
  privacy_policy_58: 'النمسا / أوروبا',
  privacy_policy_59: 'الشركة:',
  privacy_policy_60: 'شركة 4Service Holdings GmbH (الشركة / نحن)',
  privacy_policy_61: 'العنوان: Tegetthoffstraße 7، 1010 فيينا، النمسا.',
  privacy_policy_62: 'البريد الإلكتروني:',
  privacy_policy_63: 'سياسة الخصوصية وحماية البيانات',
  privacy_policy_64:
    'اقرأ المزيد حول كيفية ولماذا نستخدم بياناتك هنا: سياسة الخصوصية وحماية البيانات',
  privacy_policy_65: 'الموافقة',
  privacy_policy_66:
    'قامت الشركة بتطوير جميع الوثائق الداخلية لتحديد الأدوار بين الموظفين فيما يتعلق بمعالجة البيانات الشخصية داخل الشركة، والمسؤول عن الموافقة ومراجعة مشروعية هذا المستند هو المدير العام.',
  contacts_1: 'للعملاء',
  contacts_2:
    'لجميع أنواع الشركات، ووكالات أبحاث السوق، والشركات الكبرى، وشركاء الأعمال ووسائل الإعلام.',
  contacts_3: 'Tegetthoffstrasse 7، فيينا، النمسا',
  contacts_4: 'للمتسوقين',
  contacts_5:
    'للسكان المحليين والمسافرين والسائقين والطلاب، والمتسوقين السريين المحترفين، ومحبي البقاء في المنزل.',
  contacts_6: 'اتصل بنا من بلدك:',
  contacts_7: 'إيطاليا',
  contacts_8: 'الولايات المتحدة الأمريكية',
  contacts_9: 'المملكة المتحدة',
  contacts_10: 'سويسرا',
  contacts_11: 'هولندا',
  contacts_12: 'سلوفاكيا',
  contacts_13: 'سلوفينيا',
  contacts_14: 'رومانيا',
  contacts_15: 'أذربيجان',
  contacts_16: 'أوكرانيا',
  contacts_17: 'كازاخستان',
  contacts_18: 'بقية العالم',
  menu_1: 'رحلة العميل (CJM)',
  menu_2: 'صافي نقاط الترويج (NPS)',
  menu_3: 'مؤشر رضا العملاء (CSI)',
  menu_4: 'BHT',
  menu_5: 'اختبار تجربة المستخدم (UX)',
  menu_6: 'أبحاث الموارد البشرية',
  menu_7: 'الأبحاث النوعية',
  menu_8: 'الأبحاث الكمية',
  menu_9: 'التسوق السري',
  menu_10: 'Voicer',
  menu_11: 'Play4Sales',
  menu_12: 'Wantent',
  menu_13: 'مراقبة الأسعار',
  menu_14: 'معلومات عنا',
  menu_15: 'اتصل بنا',
  menu_16: 'مدونة',
  menu_17: 'الأساليب',
  menu_18: 'المنتجات',
  menu_19: 'منصة المتسوقين \n',
  menu_20: 'المسؤولية الاجتماعية للشركات (CSR)',
  menu_21: 'تحليل أسعار السيارات',
  menu_22: 'تدقيق فحص المرافق',
  menu_23: 'تصميم الخدمة',
  menu_24: 'تجربة العميل (CX)',
  nps_passives: 'المحايدون',
  nps_detractors: 'المنتقدون',
  nps_promoters: 'المروجون',
  nps_a_score: 'درجة',
  area: 'المنطقة',
  products_tabs_1:
    'من أجل تحقيق أقصى قدر من الكفاءة، نقوم أيضًا بتنفيذ ذلك بشكل متكامل:',
  products_tabs_2: 'المنتجات',
  products_tabs_3:
    'البحث النوعي هو جمع وتحليل البيانات غير الرقمية لفهم المفاهيم أو الآراء أو التجارب',
  products_tabs_4:
    'طرق البحث الكمي هي قياس موضوعي وتحليل عددي للبيانات التي يتم جمعها من خلال الاستطلاعات والاستبيانات والمسوح',
  our_clients_1: 'عملاؤنا',
  preview_cases_section_1: 'دراسات الحالة',
  preview_cases_section_2:
    'انتقل إلى دراسات الحالة لقراءة المزيد من المنشورات الشيقة',
  blog_1: 'مدونة محتوى ملهمة',
  blog_2: 'لا توجد منشورات متاحة لطلبك',
  about: 'نبذة',
  why_us: 'لماذا نحن',
  about_us: 'معلومات عنا',
  key_features: 'الميزات الرئيسية',
  solutions: 'الحلول',
  monitoring: 'المراقبة',
  how: 'كيف',
  how_it_works: 'كيف تعمل',
  when_to_use: 'متى يتم الاستخدام',
  mystery_shopping: 'التسوق السري',
  voicer: 'صوت العميل',
  wantent: 'اختبار محتوى الفيديو',
  play4sales: 'Play4Sales',
  price_monitoring: 'مراقبة الأسعار',
  service_design: 'تصميم الخدمة',
  qualitative_research: 'البحث النوعي',
  quantitative_research: 'البحث الكمي',
  cawi: 'CAWI',
  f2f: 'F2F',
  cati: 'CATI',
  hashtag_automotive: '#السيارات',
  hashtag_retayl: '#التجزئة',
  hashtag_all_posts: '#كل_المنشورات',
  hashtag_feedback: '#التغذية_الراجعة',
  hashtag_4Service_csr: '#4Service_CSR',
  hashtag_cases: '#دراسات_الحالة',
  hashtag_market_research: '#أبحاث_السوق',
  more: 'المزيد',
  speak_to_an_expert: 'تحدث إلى خبير',
  book_consultancy: 'احجز استشارة',
  read_all: 'اقرأ الكل',
  find_out_more: 'اكتشف المزيد',
  address: 'العنوان',
  mon_fri: 'الاثنين - الجمعة',
  phone_number: 'رقم الهاتف',
  flag: 'العلم',
  scroll_to_left: 'التمرير إلى اليسار',
  online: 'عبر الإنترنت',
  tel: 'هاتف',
  email: 'البريد الإلكتروني',
  light_it_up: 'أضئها',
  about_us_60: 'ألينا أندرييفا',
  about_us_61: 'مديرة تطوير الأعمال',
  about_us_62: 'جوليا كرافشينكو',
  about_us_63: 'مديرة مشروع أولى',
  about_us_64: 'أولغا أكسونوفا',
  about_us_65: 'مديرة تطوير الأعمال',
  about_us_66: 'جيليفسكي ديميتري',
  about_us_67: 'مدير العمليات',
  about_us_roles_1: 'الإدارة',
  about_us_roles_2: 'الفريق العالمي',
  about_us_roles_3: 'مالكو المنتجات',
  ad_testing_1: 'اختبار الإعلانات',
  ad_testing_2:
    'الحملة الإعلانية هي استثمار ضخم. تأكد من أن إعلاناتك قوية وتحقق أقصى عائد على الاستثمار',
  ad_testing_3: 'قفل',
  ad_testing_4: 'الصناعات التي نخدمها',
  ad_testing_5: '4Service هي شركة عالمية لأبحاث تجربة العملاء',
  ad_testing_6:
    '4Service هي شركة عالمية لأبحاث التسويق وتجربة العملاء (CX). نحن نقدم خدمات جمع بيانات احترافية لمجموعة واسعة من الشركات',
  ad_testing_7: 'نقدًا وحمل',
  ad_testing_8: 'تجزئة',
  ad_testing_9: 'إلكترونيات',
  ad_testing_10: 'فخامة / مميزة',
  ad_testing_11: 'المطاعم والضيافة',
  ad_testing_12: 'السيارات',
  ad_testing_13: 'السفر والترفيه',
  ad_testing_14: 'الأزياء',
  ad_testing_15: 'البنوك',
  ad_testing_16: 'الساعات والمجوهرات',
  ad_testing_17: 'الأدوات المنزلية والأجهزة',
  ad_testing_18: 'عضو في ESOMAR',
  ad_testing_19:
    'لقد أجرينا أبحاث اختبار الإعلانات لحملات ترويجية في مجالات مختلفة',
  ad_testing_20: 'تحتاج إلى اختبار الإعلانات إذا كنت',
  ad_testing_21: 'تروّج لمنتج أو خدمة جديدة',
  ad_testing_22: 'تتطرق إلى موضوع حساس',
  ad_testing_23: 'تحاول الوصول إلى فئة مستهدفة جديدة أو سوق جديد',
  ad_testing_24: 'تناقش عدة خيارات تصميم مختلفة',
  ad_testing_25: 'تحتاج إلى إثبات المفهوم أمام فرق الإدارة أو المستثمرين',
  ad_testing_26: 'ستحصل على إجابات للأسئلة التالية',
  ad_testing_27: 'ما هي القنوات الإعلانية الأنسب لهذه الإعلانات؟',
  ad_testing_28: 'هل نستخدم الصور المناسبة لإيصال الرسالة؟',
  ad_testing_29: 'هل تتوافق نصوص ورسائل إعلاناتك مع الجمهور؟',
  ad_testing_30: 'ما هي القنوات الإعلانية الأنسب لهذه الإعلانات؟',
  ad_testing_31: 'ما الذي يجذب انتباههم في المقام الأول؟',
  ad_testing_32: 'هل من السهل فهم موضع وتصميم الإعلان؟',
  ad_testing_33: 'نحن نقيم',
  ad_testing_34: 'العلامة التجارية',
  ad_testing_35: 'كيف ترتبط علامتك التجارية بالإعلان ومدى تذكرها',
  ad_testing_36: 'المقاييس الرئيسية',
  ad_testing_37: 'الاندماج',
  ad_testing_38: 'التعرف',
  ad_testing_39: 'الملاءمة',
  ad_testing_40: 'الإبداع',
  ad_testing_41: 'كيف يبرز إعلانك ويجذب انتباه الناس',
  ad_testing_42: 'المقاييس الرئيسية',
  ad_testing_43: 'التعرف',
  ad_testing_44: 'الإعجاب',
  ad_testing_45: 'MTO',
  ad_testing_46: 'التحفيز',
  ad_testing_47: 'تجربة العميل، التفاعل العاطفي',
  ad_testing_48:
    'باستخدام تقنية الذكاء الاصطناعي والمحللين الخبراء، نقوم بتحليل المشاعر الحقيقية للناس ونحصل على رؤى حول تصوراتهم للإعلانات',
  ad_testing_49: 'التقييم',
  ad_testing_50: 'ذكر',
  ad_testing_51: 'أنثى',
  ad_testing_52: 'مستوى تفاعل عالٍ',
  ad_testing_53: 'الاهتمام',
  ad_testing_54: 'ما الذي أعجب الجمهور وتذكّره؟',
  ad_testing_55: 'الممثلة',
  ad_testing_56: 'المساواة',
  ad_testing_57: 'الخلفية الموسيقية',
  ad_testing_58: 'المشاعر الإيجابية',
  ad_testing_59: 'أشخاص من أعراق ومظاهر مختلفة',
  ad_testing_60: 'لقطات خارجية',
  ad_testing_61: 'ما الذي لم يعجب الجمهور ولم يتذكره؟',
  ad_testing_62: 'صوت المتحدث لم يتطابق مع ما يحدث على الشاشة',
  ad_testing_63: 'اهتمام منخفض بالمنتج',
  ad_testing_64: 'ديناميكي جدًا',
  ad_testing_65: 'صعب الفهم',
  ad_testing_66: 'TRP',
  ad_testing_67: 'الانطباعات',
  ad_testing_68: 'العروض',
  ad_testing_69: 'التحويل',
  ad_testing_70: 'وسائل الإعلام',
  ad_testing_71:
    'نقيس فعالية الحملة الإعلانية جنبًا إلى جنب مع النشاط الإعلامي، ونحسب تأثير الاستثمارات الإعلامية في القنوات المختلفة على النتائج المراقبة.',
  ad_testing_72: 'نجري أبحاثًا إعلانية بأي تنسيق أو منصة أو قناة',
  ad_testing_73: 'محتوى الفيديو',
  ad_testing_74: 'الإعلانات الخارجية',
  ad_testing_75: 'الإعلانات التلفزيونية',
  ad_testing_76: 'الطباعة',
  ad_testing_77: 'الرقمية',
  ad_testing_78: 'الحملات الإعلانية',
  ad_testing_79: 'عرض وإعلانات نقاط البيع',
  ad_testing_80: 'الرسوم المتحركة الأولية (أنيماتيك)',
  ad_testing_81: 'بمساعدتنا، يمكنك اختبار إعلانك في أي مرحلة',
  ad_testing_82: 'المفهوم',
  ad_testing_83: 'أي الأفكار لديها قدرة أقوى؟',
  ad_testing_84: 'مرحلة الإنتاج المبكرة',
  ad_testing_85: 'أي الرسوم المتحركة ستدخل مرحلة الإنتاج؟',
  ad_testing_86: 'الإنتاج',
  ad_testing_87: 'كيف يمكن تحرير الفيديو ليحافظ على الانتباه؟',
  ad_testing_88: 'ما قبل الوسائط',
  ad_testing_89: 'ما هي قنوات الاتصال التي ستعمل وما النتيجة المتوقعة؟',
  ad_testing_90: 'اختبار الإعلان بعد الإطلاق',
  ad_testing_91: 'الإنتاج',
  ad_testing_92: 'هل إعلاني جذاب؟ هل تقل فعالية الإبداع بمرور الوقت؟',
  ad_testing_93: 'ما قبل الوسائط',
  ad_testing_94: 'ما مدى فعالية إعلاني بالأرقام؟ كيف يقارن بالمنافسين؟',
  ad_testing_95: 'اختبار الإعلان قبل الإطلاق',
  ad_testing_96: 'لتزويدك ببيانات عالية الجودة، نستخدم',
  ad_testing_97: 'منهجية البحث الكمي',
  ad_testing_98: 'CAWI',
  ad_testing_99: 'منهجية البحث النوعي',
  ad_testing_100: 'مجموعات التركيز',
  ad_testing_101: 'الذكاء الاصطناعي',
  ad_testing_102: 'Wantent',
  ad_testing_103: 'التقارير التحليلية التي تتلقاها',
  ad_testing_104:
    'فريقنا من المحللين وخبراء الإعلام والمسوقين سيعدّون ويقدمون لك تقريرًا مخصصًا مع توصيات مفصلة',
  ad_testing_age: 'العمر',
  ad_testing_ad: 'الإعلان',
  automotive_industry_price_analysis_1: 'تحليل أسعار صناعة السيارات',
  automotive_industry_price_analysis_2:
    'يمكن أن يساعد تحليل الأسعار التنافسية في منع فقدان الأرباح وزيادة الحصة السوقية ومراقبة موقعك في السوق. اسمح لنا بمساعدتك في اختيار استراتيجية تنافسية ناجحة!',
  automotive_industry_price_analysis_3: 'طلب عرض سعر',
  automotive_industry_price_analysis_4: 'منهجيتنا',
  automotive_industry_price_analysis_5: 'أشخاص أنيقون في صالون سيارات',
  automotive_industry_price_analysis_6:
    'طريقة "العميل السري" هي النهج الوحيد الذي يعكس تجربة العميل الحقيقية ويقدم نظرة شاملة وموثوقة.',
  automotive_industry_price_analysis_7:
    'نحن نقدم أرقامًا دقيقة وبيانات موثوقة متعددة الجوانب',
  automotive_industry_price_analysis_8:
    'لدينا تغطية عالمية تمتد إلى جميع دول العالم',
  automotive_industry_price_analysis_9:
    'تشمل مواردنا الداخلية متسوقين ومراجعين سريين',
  automotive_industry_price_analysis_10: 'نحن نتحقق من جودة بياناتنا',
  automotive_industry_price_analysis_11: 'مزاياُنا:',
  automotive_industry_price_analysis_12:
    'مراقبة الأسعار لنماذج المنافسين المحددة (B2B وB2C)',
  automotive_industry_price_analysis_13: 'مراقبة مستوى الخصومات',
  automotive_industry_price_analysis_14:
    'مراقبة مخزون بائعي التجزئة لعلامتك التجارية والمنافسين',
  automotive_industry_price_analysis_15:
    'مراقبة أسعار السيارات في التجارة الإلكترونية',
  automotive_industry_price_analysis_16: 'تحليل تواصل الأسعار',
  automotive_industry_price_analysis_17: 'متابعة رسوم شحن بائعي التجزئة',
  automotive_industry_price_analysis_18:
    'مراقبة العروض الترويجية والخصومات لدى بائعي التجزئة',
  automotive_industry_price_analysis_19: 'تحديد مبالغ الدفعات الشهرية',
  automotive_industry_price_analysis_20: 'حساب دفعات الإيجار',
  automotive_industry_price_analysis_21:
    'تحليل اعتبارات التسعير الخاصة بالمركبات الكهربائية (EV)',
  automotive_industry_price_analysis_22:
    'إجراء مقارنات الأسعار بين البيع المباشر للمستهلك وتجار التجزئة',
  automotive_industry_price_analysis_23: 'تطوير نماذج تسعير الاشتراكات',
  automotive_industry_price_analysis_24:
    '4Service هي شركة عالمية في مجال تجربة العملاء (CX) مع أكثر من 20 عامًا من الخبرة',
  automotive_industry_price_analysis_25:
    'ستستخدم بيانات حول استعداد المستهلكين للدفع مقابل ميزات مختلفة لتحسين عرضك وتحديد أهم الميزات لعملائك المستهدفين.',
  automotive_industry_price_analysis_26:
    'يشمل تحليل 4Service لأسعار صناعة السيارات:',
  automotive_industry_price_analysis_27:
    'الأسعار المنخفضة ليست دائمًا مفتاح التنافسية لعلامات السيارات. دعنا نساعدك في إنشاء استراتيجية تسعير طويلة الأجل',
  automotive_industry_price_analysis_28:
    'من العملاء يفهمون أن الأسعار ترتفع عبر جميع العلامات التجارية',
  automotive_industry_price_analysis_29: '٢٩',
  automotive_industry_price_analysis_30:
    'من العملاء قالوا إنهم سيشترون السيارة التي يحبونها حتى لو أبلغتهم العلامة التجارية بزيادة سعر قادمة،',
  automotive_industry_price_analysis_31: '٣١',
  automotive_industry_price_analysis_32:
    'من الأشخاص يعتبرون أن الإيجار والدفع الشهري هو النموذج المفضل لديهم لشراء سيارة',
  automotive_industry_price_analysis_33: '٤٨',
  automotive_industry_price_analysis_34:
    'من الوكلاء ذكروا احتمال زيادة الأسعار أثناء عملية التواصل أو البيع',
  automotive_industry_price_analysis_35: '٤٧٫٦',
  automotive_industry_price_analysis_36: 'الأرقام الرئيسية',
  automotive_industry_price_analysis_37:
    'ستتعرف على كيفية تسعير منتجك بالنسبة إلى المركبات الأخرى في المجموعة.',
  automotive_industry_price_analysis_38:
    'ستستخدم بيانات حول استعداد المستهلكين للدفع مقابل ميزات مختلفة لتحسين عرضك وتحديد أهم الميزات لعملائك المستهدفين.',
  automotive_industry_price_analysis_39:
    'من العملاء قالوا إنهم سيشترون السيارة التي يحبونها حتى لو أبلغتهم العلامة التجارية بزيادة سعر قادمة',
  automotive_industry_price_analysis_40:
    'ستتمكن من تحديد الدفعات الشهرية المناسبة وأسعار الإيجار.',
  automotive_industry_price_analysis_41:
    'ما الفوائد التي ستحصل عليها علامتك التجارية أو وكالتك:',
  automotive_industry_price_analysis_42: 'تقدّم طلبًا',
  automotive_industry_price_analysis_43:
    'يتواصل معك مديرنا لتحديد الأهداف الرئيسية',
  automotive_industry_price_analysis_44: 'نقوم بإجراء بحث تسويقي',
  automotive_industry_price_analysis_45:
    'نقدم لك تقارير وتوصيات بانتظام في صيغة إلكترونية',
  automotive_industry_price_analysis_46: 'سيارة عليها ملصق خصم',
  automotive_industry_price_analysis_47: 'نطلق المشروع في يوم واحد!',
  automotive_industry_price_analysis_48:
    'نقدم مجموعة شاملة من التقارير تشمل تقارير الصور وتقارير PowerPoint وتقارير Excel، مجزأة حسب نوع المنطقة',
  retail_audit_1: 'تدقيق التسويق الميداني / تدقيق التجزئة',
  retail_audit_2:
    'اجمع بيانات تفصيلية عن متجرك أو علامتك التجارية، وحلل العوائق أمام النمو، وأنشئ استراتيجيات فعالة لتجاوزها',
  retail_audit_3: 'طلب عرض سعر',
  retail_audit_4:
    'تجري 4Service عمليات تدقيق ميدانية في المتاجر نيابةً عن العلامات التجارية لتقييم فعالية استراتيجياتها الترويجية، وفرق التنفيذ الميداني، والتكتيكات التسويقية في الوصول إلى السوق المستهدف.',
  retail_audit_5:
    'نراقب بدقة تنفيذ الحملات الترويجية ونضمن الالتزام بالإرشادات الترويجية.',
  retail_audit_6: 'أفضل 10',
  retail_audit_7: 'وكالات تجربة العملاء في أوروبا',
  retail_audit_8: 'سنوات من الخبرة',
  retail_audit_9: 'تغطية البلدان',
  retail_audit_10: '1.6 مليون',
  retail_audit_11: 'تقييم في السنة',
  retail_audit_12: 'ما الذي نتتبعه؟',
  retail_audit_13: 'وجود مواد نقاط البيع (POS)',
  retail_audit_14:
    'وجود وتفعيل سفراء العلامة التجارية، مع ضمان الالتزام بالجدول المخطط',
  retail_audit_15: 'تقييم مشاركة سفراء العلامة التجارية في الحملات الدعائية',
  retail_audit_16:
    'تقييم تفاعل المستهلك وضمان الامتثال للإرشادات الترويجية ورسائل العلامة التجارية',
  retail_audit_17: 'إجراءات منع الاحتيال',
  retail_audit_18:
    'يمكن لنشاطك التجاري استخدام نتائج تدقيق التسويق الميداني من أجل:',
  retail_audit_19: 'تقييم الامتثال للميزانية والعمليات',
  retail_audit_20: 'مقارنة النتائج الفعلية بالأهداف المحددة',
  retail_audit_21: 'تحسين أداء الحملات التسويقية',
  retail_audit_22: 'التخطيط الاستراتيجي للمستقبل',
  retail_audit_23: 'تحديد فرص خفض التكاليف',
  retail_audit_24: 'تحسين المبيعات ومعدلات التحويل',
  retail_audit_25: 'تحسين العائد على الاستثمار (ROI)',
  retail_audit_26: 'اختارونا كشريكهم في الاستثمار التجاري',
  retail_audit_27:
    'تعاونت شركة عالمية رائدة في تصنيع منتجات التبغ مع 4Service لتعزيز علاماتها التجارية وتحسين أدائها داخل المتاجر. قدمت فرقنا تدقيقًا تسويقيًا ميدانيًا وتقارير مباشرة لتجربة المستهلك.',
  retail_audit_28: 'زيادة في دقة تخطيط وكالة التسويق الميداني',
  retail_audit_29: 'زيادة في إيصال رسالة العلامة التجارية',
  retail_audit_30: 'زيادة في مشاركة سفراء العلامة التجارية (تنشيط المستهلك)',
  retail_audit_31:
    'زيادة في دقة جمع البيانات والامتثال للائحة العامة لحماية البيانات (GDPR)',
  retail_audit_32: 'ما الرؤى القيمة التي نميل إلى اكتشافها:',
  retail_audit_33:
    'نقص الاتساق أو حتى التعارض بين شروط اتفاقية مستوى الخدمة يؤدي إلى فرض رسوم كبيرة غير معتمدة على العميل',
  retail_audit_34: 'فرض رسوم غير صحيحة نتيجة خلط أنواع الخدمات المقدمة',
  retail_audit_35:
    'عدم تنفيذ الخدمة الميدانية بما في ذلك عدم تعيين الموظفين إلى الموقع المخطط | نقطة البيع',
  retail_audit_36: 'فرض رسوم على أساس تقديري بدلاً من الفعلي دون تسوية',
  retail_audit_37: 'تطبيق غير صحيح لإرشادات الترويج يؤدي إلى بيانات احتيالية',
  retail_audit_38: 'كيف نعمل؟',
  retail_audit_39:
    'يقوم المدقق لدينا بزيارة مواقع نقاط البيع (POS) المحددة بناءً على خطة تفعيل الوكالة.',
  retail_audit_40:
    'يقيمون مؤشرات الأداء الرئيسية (KPI) كما هو موضح في الموجز، مثل وجود نقاط البيع، مشاركة سفراء العلامة التجارية، الالتزام بالإرشادات الترويجية، وتدابير منع الاحتيال.',
  retail_audit_41: 'التحقق:',
  retail_audit_42: 'نقوم بجمع وتوحيد البيانات التي تم الحصول عليها.',
  retail_audit_43: 'يتم إعداد تقرير شامل.',
  retail_audit_44:
    'يقوم فريق التحقق لدينا بمراجعة جميع الاستبيانات بدقة للتأكد من صحتها، بما في ذلك الالتزام بموجز المشروع وأي تعليقات إضافية.',
  retail_audit_45: 'نظام التقارير عبر الإنترنت:',
  retail_audit_46:
    'يتم تحميل الاستبيانات المكتملة والمتحقق منها إلى بوابتنا الإلكترونية خلال 36 ساعة.',
  retail_audit_47:
    'يتمكن العملاء من الوصول إلى حسابهم الشخصي عبر البوابة الإلكترونية، مما يتيح لهم متابعة التقدم في أي وقت.',
  retail_audit_48: 'يتم تقديم تقرير نهائي يحتوي على النتائج والتوصيات.',
  retail_audit_49: 'تحدث مع خبير',
  retail_audit_50: 'نقاط قوتنا:',
  facility_check_audit_1: 'المنشأة',
  facility_check_audit_2: 'تدقيق الفحص',
  facility_check_audit_3: 'ارتقِ بتجربة العلامة التجارية في كل تفصيل',
  facility_check_audit_4: 'استكشف منهجنا',
  facility_check_audit_5: 'حول',
  facility_check_audit_6: 'من نحن',
  facility_check_audit_7:
    'بصفتها شركة عالمية متخصصة في تجارب العملاء، تقدم 4Service مجموعة شاملة من الخدمات لمساعدة العلامات التجارية على إنشاء تجارب استثنائية وتقديمها لعملائها.',
  facility_check_audit_8: 'خدمة تدقيق فحص المنشآت لدينا',
  facility_check_audit_9:
    'مصممة لمساعدتك على ضمان أن مواقعك الفعلية وحضور علامتك التجارية في المتاجر تلبي معاييرك وتترك انطباعًا إيجابيًا لدى العملاء.',
  facility_check_audit_10: 'الحلول 1',
  facility_check_audit_11: 'تدقيق فحص المنشأة',
  facility_check_audit_12:
    'هو فحص دقيق يقيم مدى توافق منافذ البيع بالتجزئة أو الأكشاك الخاصة بك مع معايير علامتك التجارية. لا نتحقق فقط من الجوانب المادية، بل نقيس أيضًا كيف تؤثر هذه العناصر على الطريقة التي يُنظر بها إلى علامتك التجارية من قبل عملائك الكرام.',
  facility_check_audit_13: 'حلّان',
  facility_check_audit_14: 'طريقتان للتنفيذ',
  facility_check_audit_15: 'الطريقة',
  facility_check_audit_16: 'تدقيق فحص المنشأة بواسطة المدققين الخبراء',
  facility_check_audit_17: 'التحقق من فحص المنشأة',
  facility_check_audit_18: 'التقارير',
  facility_check_audit_19:
    'ستحصل على تقارير كاملة بالأدلة المرئية والإحصاءات، ومتاحة خلال 48 ساعة.',
  facility_check_audit_20:
    'يمكن أن يوفر تدقيق فحص المنشأة المنفذ بشكل جيد عددًا من الفوائد لعلامتك التجارية، بما في ذلك:',
  facility_check_audit_21: 'تحسين تحويل العملاء:',
  facility_check_audit_22:
    'يمكن أن تؤدي تجربة العملاء الإيجابية إلى زيادة المبيعات وتكرار التعامل. يمكن لتدقيقاتنا مساعدتك في تحديد ومعالجة أي مجالات قد تؤثر على رضا العملاء.',
  facility_check_audit_23: 'تعزيز صورة العلامة التجارية:',
  facility_check_audit_24:
    'تُعد مواقعك الفعلية نقطة تواصل رئيسية مع العملاء، ويمكن أن تلعب دورًا مهمًا في تشكيل صورة علامتك التجارية. يمكن لتدقيقاتنا مساعدتك في ضمان اتساق مواقعك مع قيم علامتك التجارية وإنشاء انطباع إيجابي لدى العملاء.',
  facility_check_audit_25: 'لماذا نحن؟',
  facility_check_audit_26: 'لماذا يعد تدقيق فحص المنشأة مهمًا؟',
  facility_check_audit_27:
    'يمكن أن يوفر تدقيق فحص المنشأة المنفذ بشكل جيد عددًا من الفوائد لعلامتك التجارية، بما في ذلك:',
  facility_check_audit_28: 'تعزيز صورة العلامة التجارية:',
  facility_check_audit_29:
    'تُعد مواقعك الفعلية نقطة تواصل رئيسية مع العملاء، ويمكن أن تلعب دورًا مهمًا في تشكيل صورة علامتك التجارية. يمكن لتدقيقاتنا مساعدتك في ضمان اتساق مواقعك مع قيم علامتك التجارية وإنشاء انطباع إيجابي لدى العملاء.',
  facility_check_audit_30: 'تحسين تحويل العملاء:',
  facility_check_audit_31:
    'يمكن أن تؤدي تجربة العملاء الإيجابية إلى زيادة المبيعات وتكرار التعامل. يمكن لتدقيقاتنا مساعدتك في تحديد ومعالجة أي مجالات قد تؤثر على رضا العملاء.',
  facility_check_audit_32: 'من يحتاج',
  facility_check_audit_33: 'من يحتاج إلى تدقيق فحص المنشأة؟',
  facility_check_audit_34:
    'يعد تدقيق فحص المنشأة خدمة قيّمة لأي علامة تجارية تمتلك مواقع فعلية أو حضورًا ماديًا. وهو مهم بشكل خاص للعلامات التجارية التي ترغب في:',
  facility_check_audit_35: 'ضمان الامتثال لمعايير العلامة التجارية:',
  facility_check_audit_36:
    'يمكن لتدقيقاتنا مساعدتك في تحديد أي مجالات قد تنحرف فيها مواقعك عن معايير علامتك التجارية.',
  facility_check_audit_37: 'تحسين تجربة العملاء:',
  facility_check_audit_38:
    'يمكن لتدقيقاتنا مساعدتك في تحديد الفرص لتعزيز تجربة العملاء في مواقعك.',
  facility_check_audit_39: 'بناء علامة تجارية أقوى:',
  facility_check_audit_40:
    'يمكن لتدقيقاتنا مساعدتك في ضمان أن مواقعك الفعلية تخلق انطباعًا إيجابيًا لدى العملاء.',
  facility_check_audit_41: 'يلتقط موظفك أو المشتري السري صورة للموقع.',
  facility_check_audit_42: 'بعد ذلك، يملأ الاستبيان ويُرفق الصورة.',
  facility_check_audit_43:
    'يتلقى المدقق الصورة ويتحقق من مدى مطابقتها للمعايير.',
  facility_check_audit_44: 'تدقيق فحص المنشأة بواسطة المدققين الخبراء',
  facility_check_audit_45: 'مرحلة التحضير:',
  facility_check_audit_46: 'الموافقة المشتركة على جدول التدقيق',
  facility_check_audit_47: 'يتم إعداد الموزعين وإبلاغهم بعملية التدقيق القادمة',
  facility_check_audit_48: 'تدريب المدققين:',
  facility_check_audit_49:
    'يقوم مدربونا ذوو الخبرة في 4Service بتمكين المدققين من خلال إرشادات العلامة التجارية',
  facility_check_audit_50: 'مرحلة تدقيق المنشأة:',
  facility_check_audit_51:
    'يقوم المدققون، المجهزون برسائل تفويض خاصة، بزيارة المواقع',
  facility_check_audit_52: 'فحص شامل لكل نقطة، مع اتباع الإرشادات بدقة',
  facility_check_audit_53:
    'توثيق بصري إلى جانب التقييمات مقابل متطلبات المقر الرئيسي',
  facility_check_audit_54: 'تقرير PPT نهائي',
  facility_check_audit_55: 'تقرير PowerPoint شامل يوضح النتائج',
  facility_check_audit_56: 'عرض غامر عبر الإنترنت أو دون اتصال لنتائج التدقيق',
  facility_check_audit_57: 'التحقق من فحص المنشأة',
  facility_check_audit_58: 'الخطوات:',
  facility_check_audit_59: 'مرحلة تدقيق المنشأة:',
  facility_check_audit_60:
    'يستخدم ممثلو العلامة التجارية تطبيق 4Service لالتقاط الصور في الموقع',
  facility_check_audit_61: 'الالتزام بمعايير بصرية ووصفية صارمة',
  facility_check_audit_62: 'مرحلة التحقق:',
  facility_check_audit_63: 'يقوم المدققون المتخصصون بمراجعة كل تقرير بدقة',
  facility_check_audit_64: 'مقارنة شاملة للصور بمعايير العلامة التجارية',
  facility_check_audit_65: 'دمج الملاحظات والرؤى في التقرير لتوضيح أكبر',
  facility_check_audit_66:
    'التواصل المباشر مع الموزعين لتوضيحات إضافية عند الحاجة',
  facility_check_audit_67: 'مرحلة التقارير:',
  facility_check_audit_68:
    'تقارير كاملة بالأدلة المرئية والإحصاءات، متاحة خلال يومين',
  facility_check_audit_69: 'اتصل بنا اليوم',
  cx_solution_1: 'نحن لا نكتفي باكتشاف الرؤى،',
  cx_solution_2: 'بل نأخذ عملك إلى آفاق جديدة',
  cx_solution_3:
    'يكتشف خبراؤنا الذين يتمتعون بأكثر من 20 عامًا من الخبرة في مجال تجربة العملاء حلولًا معقدة ويوفرون لك خطة عمل محددة تسهم في نموك',
  cx_solution_4:
    'اكتشف مجموعة فريدة من الخدمات في حل واحد متكامل لمستقبل مضمون',
  cx_solution_5: 'حل تجربة العملاء الشامل',
  cx_solution_6: 'اختبار الإعلانات',
  cx_solution_7: 'الذكاء الاصطناعي وعلم الأعصاب التسويقي',
  cx_solution_8: 'صوت العميل',
  cx_solution_9: 'البحث المكتبي',
  cx_solution_10: 'رحلة العميل (CJM)',
  cx_solution_11: 'العميل السري',
  cx_solution_12: 'استشارات تجربة العملاء',
  cx_solution_13: 'الاستماع إلى وسائل التواصل الاجتماعي',
  cx_solution_14: 'البحوث الكمية والنوعية',
  cx_solution_15: 'تصميم الخدمة',
  cx_solution_16: 'استراتيجية التسويق',
  cx_solution_17: 'اختبار تجربة المستخدم وواجهة المستخدم (UX/UI)',
  cx_solution_18: 'رؤى الجمهور',
  cx_solution_19: 'يشرفنا أن نساهم في نجاحك',
  cx_solution_20:
    'نقوم بتخصيص ودمج الأدوات والخدمات بناءً على أهداف عملك لضمان تقديم نتائج مخصصة',
  cx_solution_21: 'بحث شامل',
  cx_solution_22:
    'عزز عملية اتخاذ القرار لديك، وامنح نفسك ميزة تنافسية في سوق يعتمد على البيانات.',
  cx_solution_23:
    'البحث النوعي هو جمع وتحليل البيانات غير الرقمية لفهم المفاهيم والآراء أو التجارب',
  cx_solution_24:
    'طرق البحث الكمي هي قياس موضوعي وتحليل عددي للبيانات التي تم جمعها من خلال الاستطلاعات والاستبيانات',
  cx_solution_25: 'نستخدم مجموعة مميزة من الأدوات بناءً على متطلباتك الخاصة',
  cx_solution_26: 'الأدوات',
  cx_solution_27: 'CAWI',
  cx_solution_28:
    'المقابلات عبر الويب بمساعدة الكمبيوتر هي أداة حيوية في ترسانتنا، حيث تتيح لنا إجراء الاستطلاعات وجمع البيانات من خلال المنصات عبر الإنترنت باستخدام برامج متخصصة، مما يضمن جمع بيانات فعال ودقيق لتلبية احتياجات أبحاث السوق لعملائنا',
  cx_solution_29: 'CATI',
  cx_solution_30:
    'المقابلات الهاتفية بمساعدة الكمبيوتر هي طريقة نستخدمها لإجراء الاستطلاعات وجمع بيانات قيّمة عبر الهاتف باستخدام برامج متخصصة لتبسيط العملية وضمان الدقة في جهودنا البحثية التسويقية',
  cx_solution_31: 'F2F',
  cx_solution_32:
    'المقابلات وجهًا لوجه جزء أساسي من نهجنا، حيث تسهل التفاعل المباشر والمشاركة الشخصية مع العملاء، مما يعزز الثقة والفهم والتواصل الفعّال الضروري لبناء علاقات طويلة الأمد ودفع نجاح الأعمال',
  cx_solution_33: 'البحث المكتبي',
  cx_solution_34:
    'يشمل البحث المكتبي جمع البيانات وتحليلها بشكل شامل، ويعد خطوة أساسية في عملية البحث لدينا لجمع الرؤى ودعم اتخاذ القرارات الاستراتيجية لعملائنا',
  cx_solution_35: 'تحليل SWOT',
  cx_solution_36:
    'تحليل SWOT هو أداة تقييم استراتيجي تساعد عملاءنا على تحديد نقاط القوة والضعف الداخلية، بالإضافة إلى الفرص والتهديدات الخارجية، مما يوفر رؤى قيّمة لدعم اتخاذ القرار وتطوير استراتيجيات أعمال فعالة',
  cx_solution_37: 'البحث الإثنوغرافي',
  cx_solution_38:
    'دراسة الأشخاص والثقافات من خلال التفاعل والملاحظة في بيئاتهم الطبيعية، مما يؤدي غالبًا إلى رؤى عميقة حول السلوكيات والمعتقدات والديناميكيات الاجتماعية',
  cx_solution_39: 'المقابلات المتعمقة',
  cx_solution_40:
    'المقابلات المتعمقة هي طريقة بحث نوعية نعتمدها، تتضمن مناقشات شاملة فردية مع المشاركين لاستكشاف وجهات نظرهم وتجاربهم وآرائهم بعمق، مما يوفر رؤى غنية ودقيقة لأهداف البحث وعمليات اتخاذ القرار لدى عملائنا',
  cx_solution_41: 'جلسات توليد الأفكار',
  cx_solution_42:
    'جلسات توليد الأفكار هي جلسات عصف ذهني تعاونية نقوم بتيسيرها، تجمع بين وجهات نظر وخبرات متنوعة لتوليد أفكار وحلول مبتكرة لتحديات عملائنا أو فرصهم، مما يعزز الابتكار ويدفع المبادرات الاستراتيجية قدمًا',
  cx_solution_43: 'شخصيات المشتري',
  cx_solution_44:
    'شخصيات المشتري هي ملفات تعريف مفصلة نطورها تمثل العملاء المستهدفين بناءً على البحث وتحليل البيانات، مما يساعدنا على فهم احتياجاتهم وتفضيلاتهم وسلوكياتهم بشكل أفضل، وتخصيص استراتيجياتنا واتصالاتنا للتفاعل معهم بفعالية وتحقيق النجاح التجاري',
  cx_solution_45: 'العميل السري',
  cx_solution_46:
    'العميل السري هو خدمة استراتيجية نقدمها، تقيس وتراقب التفاعل بين العميل والشركة ضمن سيناريو محدد مسبقًا',
  cx_solution_47: 'المرافقة أثناء التحقق',
  cx_solution_48:
    'المرافقة أثناء التحقق هي شكل متخصص من العميل السري، حيث يرافق مقيمونا العملاء طوال تجربتهم الخدمية بالكامل، مما يوفر رؤى شاملة حول كل جانب من جوانب رحلة العميل، مما يمكّن عملاءنا من فهم خدماتهم بعمق وإجراء تحسينات مدروسة لرفع مستوى رضا العملاء وولائهم',
  cx_solution_49: 'تحليل جمع الملاحظات',
  cx_solution_50:
    'تحليل جمع الملاحظات هو عملية أساسية نقوم بها، تشمل جمع وتحليل ملاحظات العملاء بشكل منهجي من قنوات مختلفة مثل الاستطلاعات والمراجعات ووسائل التواصل الاجتماعي، مما يتيح لنا استخراج رؤى قيّمة وتحديد الاتجاهات وتقديم توصيات قائمة على البيانات لتحسين منتجات وخدمات وتجربة العملاء الشاملة لعملائنا',
  cx_solution_51: 'مجموعات التركيز',
  cx_solution_52:
    'مجموعات التركيز هي جلسات بحث ديناميكية نقوم بتيسيرها، تجمع بين مجموعة متنوعة من المشاركين لمناقشة مواضيع أو منتجات محددة بعمق، مما يتيح لنا جمع رؤى نوعية، وكشف المواقف والتفضيلات والتصورات، واستكشاف الأفكار والمفاهيم، مما يساهم في نهاية المطاف في عمليات اتخاذ القرار وتطوير الاستراتيجيات لعملائنا',
  cx_solution_53: '20 عامًا من صياغة تجارب عملاء استثنائية',
  cx_solution_54: 'تأكد من أن رسالتك تجذب جمهورك وتلقى صدى لديهم.',
  cx_solution_55: 'نحن ملتزمون بتقديم نتائج تتجاوز توقعاتك',
  cx_solution_56: 'نكتشف حلولاً معقدة تسهم في نموك',
  cx_solution_57: 'ارفع مستوى تجربة عملائك من خلال منهجيتنا',
  cx_solution_58:
    'رسم خريطة رحلة العميل يتعلق بتحديد الجمهور المستهدف، وفهم احتياجاتهم وبيئتهم، ثم إنشاء خطة لتقديم تجربة جذابة',
  cx_solution_59: 'BHT',
  cx_solution_60:
    'يتيح بحث تتبع صحة العلامة التجارية قياس أداء علامتك التجارية من حيث الوعي والاستخدام، وتموضع العلامة، وأدائها العام',
  cx_solution_61: 'CSI',
  cx_solution_62:
    'مؤشر رضا العملاء هو درجة تشير إلى مدى رضا عملائك عن منتجات / خدمات الشركة.',
  cx_solution_63: 'مراقبة الأسعار هي عملية جمع ومعالجة وتحليل أسعار المنافسين',
  cx_solution_64: 'NPS',
  cx_solution_65:
    'صافي نقاط المروجين هو المعيار الذهبي لمقاييس تجربة العملاء، ويعتمد على سؤال واحد: ما مدى احتمالية أن توصي بالمنظمة / المنتج / الخدمة؟',
  cx_solution_66: 'بحوث الموارد البشرية',
  cx_solution_67:
    'تُستخدم بحوث الموارد البشرية لتقييم ممارسات وأداء الموارد البشرية وتقدم تحليلًا تفصيليًا حول التطوير والإدارة الحالية',
  cx_solution_68:
    'اختبار قابلية الاستخدام هو كيفية تفاعل الأشخاص الحقيقيين مع موقع إلكتروني أو تطبيق أو منتج آخر ومراقبة سلوكهم وردود أفعالهم تجاهه',
  cx_solution_69: 'أخرى',
  cx_solution_70: 'يختار الخبراء أفضل منهجية لأعمالك',
  cx_solution_71: 'لنبدأ',
  cx_solution_72: '1 - اجتماع الانطلاق',
  cx_solution_73:
    'أثناء اجتماع الانطلاق، نحدد المهام الرئيسية ونركز عليها. النتيجة: فهم الهدف، مهام البحث، المواعيد النهائية، الأساليب، ومجالات المسؤولية.',
  cx_solution_74: '2 - تطوير المفهوم',
  cx_solution_75:
    'يقوم قسم التحليلات في 4Service بتجميع البيانات وتنسيق هيكل التقرير. ثم نقدم النتائج للعميل مع رؤى وتوصيات للتنفيذ.',
  cx_solution_76: '3 - العمل الميداني',
  cx_solution_77:
    'لإجراء البحث، نقوم بتجنيد المشاركين، وإجراء المقابلات، ومراحل البحث الأساسية الأخرى. يتلقى العميل تسجيلات صوتية وفيديو مفرغة، بالإضافة إلى ملخصات موجزة.',
  cx_solution_78: '4 - التحليلات',
  cx_solution_79:
    'يقوم قسم التحليلات في 4Service بتجميع البيانات وتنسيق هيكل التقرير. ثم نقدم النتائج للعميل مع رؤى وتوصيات للتنفيذ.',
  cx_solution_80: '5 - ورشة العمل',
  cx_solution_81: 'إجراء مناقشة مع العميل بشأن خطة التنفيذ',
  cx_solution_82: 'تعرف على أفضل ممارساتنا',
  cx_solution_83:
    'تتيح خريطة رحلة العميل فحصًا سريعًا لجميع قنوات الاتصال، وتحديد أوجه القصور المحتملة في نقاط التفاعل الحاسمة، وفهمًا شاملاً للمجالات التي قد تنحرف عن المسار المخطط.',
  cx_solution_84: 'متى يتم استخدامها؟',
  cx_solution_85:
    'أنشئ حملة إعلانية مخصصة بناءً على بيانات حقيقية حول مجموعات الجمهور',
  cx_solution_86:
    'اكتشف محفزات شرائح الجمهور المستهدف المختلفة ولبِّ احتياجاتهم',
  cx_solution_87: 'استهدف كل مجموعة بدقة لتحقيق أقصى قدر من التحويل',
  cx_solution_88:
    'تتيح تقنية الفحص المرافق تقييم إمكانيات أفضل الطرق لتحقيق أهدافك.',
  cx_solution_89: 'اختبار موقع ويب جديد أو منتج قبل الإطلاق',
  cx_solution_90: 'التحقق من العمليات المطورة قبل تنفيذ التغييرات',
  cx_solution_91: 'تقييم الموقع أو المنتج في ظل انخفاض المبيعات',
  cx_solution_92: 'إطلاق منتج جديد مصمم وفقًا لتفضيلات العملاء',
  cx_solution_93: 'دراسة الشركات المنافسة لتأمين موقع قيادي في السوق',
  cx_solution_94:
    'نقدم نهجًا شاملاً برؤية 360 درجة لإنشاء نموذج خدمة موجه نحو العميل.',
  cx_solution_95: 'تدريب وتطوير الموظفين',
  cx_solution_96: 'تحسين معايير الخدمة',
  cx_solution_97: 'زيادة تدفق العملاء والمبيعات',
  cx_solution_98: 'تحديد مؤشرات الأداء الرئيسية ونظام التحفيز للموظفين',
  cx_solution_99: 'اكتشف قصص نجاحنا',
  cx_solution_100: 'السيارات',
  cx_solution_101: 'التبغ',
  cx_solution_102: 'التجزئة',
  cx_solution_103: 'المرحلة النوعية',
  cx_solution_104: 'المرحلة الكمية (التجزئة)',
  cx_solution_105: 'مجموعات التركيز',
  cx_solution_106: 'تغطية جمهور عالمي عبر الإنترنت',
  cx_solution_107: 'مزيج من التقنيات أثناء المقابلات',
  cx_solution_108: 'أسئلة مفتوحة فقط',
  cx_solution_109: 'دعم المستجيبين على مدار الساعة',
  cx_solution_110: 'الحفاظ على التفاصيل المهمة والصورة الواقعية للمسار',
  cx_solution_111: 'بحوث السوق',
  cx_solution_112: 'تشخيص الشركة والمنافسين',
  cx_solution_113: 'نماذج خدمة محدثة وعمليات عمل جديدة',
  cx_solution_114: 'تعزيز الخدمة الموجهة نحو العميل',
  cx_solution_115: 'تنفيذ التغييرات والتحكم في تطوير استراتيجيات الخدمة',
  usage_attitude_1: 'الاستخدام و \n الموقف (U&A)',
  usage_attitude_2:
    'احصل على رؤى شاملة حول كيفية إدراك الجمهور المستهدف \n واستخدامه وتفاعله مع علامتك التجارية.',
  usage_attitude_3: 'تحدث إلى خبير',
  usage_attitude_4: 'حول',
  usage_attitude_5:
    '<b>استكشف عادات</b> المستهلكين للكشف بعمق عن التفضيلات والتأثيرات',
  usage_attitude_6:
    "<b>اكتشف 'السبب'</b> وراء اختيارات المستهلكين من خلال تحليلنا التفصيلي",
  usage_attitude_7:
    '<b>افهم كيف</b> يتفاعل العملاء مع منتجاتك للحصول على رؤى استراتيجية',
  usage_attitude_8:
    '<b>احصل على رؤى حول</b> سلوك المستهلكين وعاداتهم وتفضيلاتهم لاتخاذ قرارات مستنيرة',
  usage_attitude_9: 'الخبرة',
  usage_attitude_10:
    'يبتكر خبراء 4Service الذين يمتلكون أكثر من 20 عامًا من الخبرة في خدمة العملاء حلولًا فريدة تساعد على تنمية عملك',
  usage_attitude_11: 'اتصل بنا',
  usage_attitude_12: 'لمن',
  usage_attitude_13: 'من يستفيد من دراسة استخدام العلامة التجارية والمواقف؟',
  usage_attitude_14: 'تُبدي مختلف الصناعات وقطاعات الخدمات اهتمامًا بـ:',
  usage_attitude_15: '<b>التعرف على</b> احتياجات العملاء ونقاط الألم لديهم',
  usage_attitude_16: '<b>تحديد</b> الفرص لزيادة استهلاك العملاء',
  usage_attitude_17: '<b>تطوير</b> فئات منتجات جديدة أو استراتيجيات تسويقية',
  usage_attitude_18: '<b>اكتساب</b> فهم عميق للمشهد التنافسي',
  usage_attitude_19: 'يتم اختيار المنهجية بشكل فردي بناءً على طلب العميل',
  usage_attitude_20:
    '<b>البحث النوعي</b> يشمل جمع وتحليل البيانات غير الرقمية لفهم المفاهيم أو الآراء أو التجارب.',
  usage_attitude_21:
    '<b>البحث الكمي</b> يتضمن قياس البيانات وتحليلها عدديًا بشكل موضوعي من خلال الاستطلاعات والاستبيانات.',
  usage_attitude_22:
    '<b>بعد جمع البيانات</b>، يقوم الخبراء بتحليل المعلومات واستخلاص النتائج لتزويدك بأفضل التوصيات.',
  usage_attitude_23: 'من يحتاج',
  usage_attitude_24: 'قصة نجاحك تبدأ من هنا',
  usage_attitude_25:
    '<b>ستتلقى بحثًا</b> يحتوي على رؤى قيمة تمكِّنك من اتخاذ قرارات استراتيجية تستند إلى فهم عميق لسلوك المستهلكين.',
  usage_attitude_26:
    '<b>يوفر البحث أساسًا قويًا لتحسين</b> استراتيجيات العلامة التجارية ومواءمتها بشكل أكبر مع تفضيلات ومواقف المستهلكين.',
  usage_attitude_27: 'الحلول',
  usage_attitude_28: 'استكشف العديد من الفرص من خلال حلولنا',
  usage_attitude_29: 'تفضيل المنتج داخل الفئة',
  usage_attitude_30:
    'حدد أهم تفضيلات المستهلكين عبر فئات مختلفة، بما في ذلك الطعام والمشروبات والملابس والإلكترونيات والمزيد.',
  usage_attitude_31: 'سلوك الاستهلاك / الاستخدام',
  usage_attitude_32:
    'حلل تكرار استهلاك أو استخدام منتجات / خدمات معينة، وحدد المناسبات واللحظات المرتبطة بها.',
  usage_attitude_33: 'سلوك الشراء',
  usage_attitude_34:
    'افحص القنوات التي يستخدمها العملاء لعمليات الشراء وحدد مصادر المعلومات التي يعتمدون عليها.',
  usage_attitude_35: 'دوافع واحتياجات المستهلكين',
  usage_attitude_36:
    'افحص الدوافع والعوائق التي تؤثر على الاستهلاك. قيّم العوامل التي تؤثر على قرارات الشراء لدى المستهلكين. استكشف تصور فئة المنتج، وحلل كيفية إدراك السعر.',
  usage_attitude_37: 'نهجنا',
  usage_attitude_38: 'دراسة استخدام العلامة التجارية والموقف تجاهها',
  usage_attitude_39: 'المعلومات',
  usage_attitude_40: 'إجراء الاستطلاعات باستخدام الأساليب الكمية والنوعية معًا',
  usage_attitude_41: 'البدء',
  usage_attitude_42: 'تحديد الأهداف وتحديد الأساليب بناءً على الطلبات الفردية',
  usage_attitude_43: 'التحليل',
  usage_attitude_44: 'استخدام تقنيات متقدمة من قبل خبرائنا',
  usage_attitude_45: 'نستخدم مجموعة مميزة من الأدوات بناءً على متطلباتك الخاصة',
  usage_attitude_46: 'CATI',
  usage_attitude_47:
    'المقابلات الهاتفية بمساعدة الكمبيوتر هي طريقة نستخدمها لإجراء الاستطلاعات وجمع البيانات القيمة عبر الهاتف باستخدام برامج متخصصة لتبسيط العملية وضمان الدقة في بحوث السوق.',
  usage_attitude_48: 'CAWI',
  usage_attitude_49:
    'المقابلات عبر الإنترنت بمساعدة الكمبيوتر هي أداة أساسية في ترسانتنا، تتيح لنا إجراء الاستطلاعات وجمع البيانات عبر المنصات الإلكترونية بمساعدة برامج متخصصة، مما يضمن جمع بيانات فعالًا ودقيقًا لاحتياجات بحوث السوق لدى عملائنا.',
  usage_attitude_50: 'CAPI',
  usage_attitude_51:
    'المقابلات الشخصية بمساعدة الكمبيوتر هي طريقة نستخدمها لتحسين عمليات جمع البيانات، وجعل المقابلات أكثر سلاسة، وضمان نتائج دقيقة ومفيدة لاحتياجات عملك.',
  usage_attitude_52: 'مجموعات التركيز',
  usage_attitude_53:
    'مجموعات التركيز هي جلسات بحث ديناميكية نقوم بتيسيرها، تجمع مجموعة متنوعة من المشاركين لمناقشة مواضيع أو منتجات محددة بعمق، مما يتيح لنا جمع رؤى نوعية، وكشف المواقف والتفضيلات والتصورات، واستكشاف الأفكار والمفاهيم، مما يساهم في النهاية في عمليات اتخاذ القرار وتطوير الاستراتيجيات لدى عملائنا.',
  usage_attitude_54: 'F2F',
  usage_attitude_55:
    'الاتصال المباشر وجهًا لوجه جزء أساسي من نهجنا، حيث يتيح تفاعلات مباشرة ومشاركات شخصية مع العملاء والمستهلكين، مما يعزز الثقة والفهم والتواصل الفعّال لبناء علاقات دائمة وتحقيق النجاح التجاري في مجموعات التركيز.',
  usage_attitude_56: 'البحث الإثنوغرافي',
  usage_attitude_57:
    'دراسة الناس والثقافات من خلال الانغماس والملاحظة في بيئاتهم الطبيعية، مما يؤدي غالبًا إلى رؤى عميقة حول السلوكيات والمعتقدات والديناميكيات الاجتماعية.',
  thank_you_page: 'شكرًا لوقتك! سيتواصل معك مديرنا قريبًا.',
  back_main: 'العودة إلى الرئيسية',
  opportunities_1: 'تعرف على المزيد حول حالاتنا',
  opportunities_2: 'اكتشف',
  opportunities_3: 'بنفسك',
  opportunities_4: 'الفرص',
  opportunities_5: 'للأعمال الدولية مع مجموعة أبحاث 4Service',
  opportunities_6:
    'ما هي <span>المنتجات</span> التي يمكننا من خلالها تعزيز عملك؟',
  opportunities_7: 'CX',
  opportunities_8: 'حلول مخصصة وشاملة للأعمال',
  opportunities_9: 'جميع أنواع التسوق الخفي',
  opportunities_10:
    'ننفذ تسوق الموظف السري، والمتصل السري، والمتسوق الفاخر، والمتسوق في مجال السيارات، وأنواعًا أخرى',
  opportunities_11: 'حلول تقنية مخصصة للأعمال',
  opportunities_12:
    'حلول تقنية خاصة بالذكاء الاصطناعي، ومنصات لتحليل الملاحظات وتفريغ المكالمات',
  opportunities_13: 'بحوث السوق',
  opportunities_14:
    'لأي طلبات تجارية (تتبع صحة العلامة التجارية، التقسيم، NPS، eNPS، CJM، اختبار المنتج والإعلان، إلخ.)',
  opportunities_15: 'عمليات التدقيق',
  opportunities_16:
    'نقوم بإجراء عمليات تدقيق خدمة متنوعة، بالإضافة إلى مراقبة الأسعار (دون اتصال بالإنترنت، لمجالات محددة، إلخ)',
  opportunities_17: 'تصميم الخدمة',
  opportunities_18:
    '4Service - شركاء معتمدون لأكاديمية DesignThinkers، يقدمون تدريبًا للشركات ويعقدون ورش عمل بانتظام للأعمال',
  opportunities_19:
    'نشارك خبرتنا، ولكننا <span>نحترم ولا نعطل</span> عملية عملك.',
  opportunities_20:
    'نحن نعرف الصعوبات التي تواجهها الشركات في رحلة تطورها، ونعرف كيف نتغلب على هذه العوائق بفضل الخبرة الدولية الناجحة. ستحصل على الخبرة والموارد معًا.',
  opportunities_21: 'ندعوك للتعاون!',
  opportunities_22: 'نحن نقدم <span>برنامج شراكة</span> لعملك',
  opportunities_23:
    'تحت العلامة التجارية المعترف بها دوليًا 4Service، يمكنك التأثير إيجابيًا في جذب عملاء جدد.',
  opportunities_24:
    'يحصل شركاؤنا على دعم شامل، بما في ذلك التدريب، والمواد التسويقية، والمساعدة التشغيلية.',
  opportunities_25:
    'ستتيح لك الشراكة معنا تنفيذ خططك دون تعطيل عملية عملك الحالية.',
  opportunities_26: 'مكاتبنا',
  opportunities_27: 'عملاؤنا',
  opportunities_28: 'لدينا أكثر من 20 عامًا من الخبرة في تجربة العملاء (CX)',
  opportunities_29: 'البلدان التي نغطيها',
  opportunities_30: 'ألف',
  opportunities_31: 'مشاريع فريدة',
  opportunities_32: 'مليون',
  opportunities_33: 'زيارات من المتسوقين السريين',
  opportunities_34: 'مدرجة ضمن أفضل 10 وكالات تجربة العملاء في أوروبا',
  opportunities_35: 'فرصك مع 4Service',
  opportunities_36: 'زيادة الأرباح',
  opportunities_37: 'ستحصل على إمكانية الوصول إلى الطلبات الدولية',
  opportunities_38: 'نهج فريد في تجربة العملاء',
  opportunities_39: 'دعم من خبراء ذوي خبرة 20 عامًا',
  opportunities_40: 'الدعم',
  opportunities_41: 'سيدعمك فريقنا لتحقيق النتائج',
  opportunities_42: 'المبيعات',
  opportunities_43: 'سنساعدك في إعداد نظام المبيعات',
  opportunities_44: 'الوصول إلى البرمجيات',
  opportunities_45:
    'ستحصل على إمكانية الوصول إلى جميع الأدوات التقنية المعتمدة',
  opportunities_46: 'التدريب',
  opportunities_47:
    'لن نقوم فقط بتدريب موظفيك، بل سنواصل أيضًا تقديم الخدمات الاستشارية',
  opportunities_48: 'من هو المناسب للشراكة؟',
  opportunities_49: 'هل عملك مرتبط بأبحاث السوق؟',
  opportunities_50: 'أم أنك تخطط لتجربة نفسك في مجال جديد؟',
  opportunities_51: 'هل تخطط لـ:',
  opportunities_52: 'تطبيق الابتكارات',
  opportunities_53: 'العمل مع العلامات التجارية الدولية',
  opportunities_54: 'توسيع مجموعة منتجاتك',
  opportunities_55: 'تعزيز موقعك في السوق؟',
  opportunities_56: 'تدريب موظفيك',
  opportunities_57: 'توسيع نطاق عملك',
  opportunities_58: 'مواردنا = مواردك',
  opportunities_59:
    'نظرًا لخبرتنا الواسعة، نحن مستعدون لمشاركتها معك في المرحلة الأولى من التعاون',
  opportunities_60: 'تحليل البيانات:',
  opportunities_61: 'فريق تحليلات دولي',
  opportunities_62: 'طرق معالجة البيانات - SPSS, Power BI',
  opportunities_63: 'منهجيات مبتكرة ونطاق واسع من الأساليب',
  opportunities_64: 'تقارير بأي تنسيق',
  opportunities_65: 'البرمجيات:',
  opportunities_66: 'تطويرات تقنية مخصصة خاصة بنا',
  opportunities_67: 'DigSee Sure لـ CAPI',
  opportunities_68: 'SurveyMonkey لـ CAWI',
  opportunities_69: 'Shopmetrics',
  opportunities_70: 'VoIPTime (مركز الاتصال)',
  opportunities_71: 'الدعم التسويقي:',
  opportunities_72: 'دعم العلاقات العامة',
  opportunities_73: 'المساعدة في الترويج وإنشاء المحتوى',
  opportunities_74: 'إعداد عمليات توليد العملاء المحتملين',
  opportunities_75: 'الدعم التقني:',
  opportunities_76: 'دعم فني في التثبيت، والإعداد، واستخدام برامجنا.',
  opportunities_77: 'مساعدة عن بُعد',
  opportunities_78: 'مراقبة الأمان',
  opportunities_79: 'الدعم التشغيلي:',
  opportunities_80: 'المساعدة في إعداد العمليات الميدانية',
  opportunities_81: 'نظام مكافحة الاحتيال',
  opportunities_82: 'توظيف بأي مستوى من التعقيد',
  opportunities_83: 'الإدارة التشغيلية للمشروع وفريق الأقسام الميدانية',
  opportunities_84: 'مراقبة جودة التوظيف',
  opportunities_85: 'أب وورك',
  opportunities_86: 'ما المكافآت التي ستحصل عليها؟',
  opportunities_87: 'زيادة قاعدة العملاء',
  opportunities_88: 'تعزيز صورة السوق',
  opportunities_89: 'تنويع مخاطر فقدان العملاء',
  opportunities_90: 'تحسين العمليات التقنية',
  opportunities_91: 'الخبرة الدولية',
  opportunities_92: 'المزيد من المبيعات للعملاء الحاليين',
  main_67:
    'تحليل الأسعار التنافسية يحسن العروض، ويزيد الأرباح، ويعزز الحصة السوقية من خلال الاستفادة من بيانات استعداد المستهلكين للدفع لتحديد الميزات الرئيسية',
  main_68:
    'يضمن توافق نقاط البيع الخاصة بك مع معايير العلامة التجارية، من خلال تقييم الخصائص المادية وتأثيرها على تصور العملاء',
  main_69: 'حلول تجربة العملاء (CX)',
  main_70:
    'اكتشف حل تجربة العملاء الشامل بزاوية 360 درجة: نحن نخصص الأدوات والخدمات بناءً على أهدافك لدفع عملك نحو النجاح',
  main_71: 'تحليلات الكلام',
  main_72:
    'أداتنا المتقدمة لتحليل الكلام تحول اللغة المنطوقة إلى نص، مما يوفر رؤى لا تقدر بثمن لمساعدة الشركات على تحسين تجارب العملاء، ومراقبة الأداء، وضمان الامتثال، وتحفيز النمو',
  parthership: 'شراكة',
  banner_1: 'استشارات وخدمات تجربة العملاء لرؤية شاملة 360° لعملك',
  banner_2: 'ابق على اطلاع بأحدث الأبحاث!',
  banner_3: 'أوافق على معالجة البيانات الشخصية وفقًا لسياسة الخصوصية',
  banner_4: '*اختر السوق',
  banner_5: 'شكرًا لاشتراكك!',
  banner_6: 'سنشارك معك فقط المحتوى الأكثر إثارة للاهتمام!',
  banner_7: 'إرسال',
  banner_8: 'أوكرانيا',
  banner_9: 'كازاخستان',
  brand_awareness_1: 'الوعي بالعلامة التجارية',
  brand_awareness_2: 'واستخدامها',
  brand_awareness_3:
    'اكتشف إمكانات الوعي بعلامتك التجارية واستخدامها لتحقيق نجاح الأعمال',
  brand_awareness_4: 'تحدث مع خبير',
  brand_awareness_5: 'حول',
  brand_awareness_6: '<b>قيّم مستوى</b> التعرف والإلمام بعلامتك التجارية',
  brand_awareness_7:
    '<b>حدد مستوى الوعي بالعلامة التجارية</b> في السوق المستهدفة الخاصة بك',
  brand_awareness_8: '<b>راقب عن كثب</b> معدلات الاحتفاظ والولاء',
  brand_awareness_9: '<b>اختر الاستراتيجية المثلى</b> لتحسين المؤشرات المطلوبة',
  brand_awareness_10: 'استكشف العديد من الفرص مع حلولنا',
  brand_awareness_11: 'الوعي بالعلامة التجارية',
  brand_awareness_12: 'استخدام العلامة التجارية',
  brand_awareness_13:
    '<b>اكتشف</b> مدى تعرف المستهلكين على علامتك التجارية ضمن الشرائح المختلفة',
  brand_awareness_14: '<b>راقب</b> مستوى الوعي بين جمهورك',
  brand_awareness_15: '<b>ادرس</b> الأفكار العفوية للمستهلكين قبل الشراء',
  brand_awareness_16:
    '<b>افهم</b> المصادر الأساسية التي تسهم في وعي المستهلكين بعلامتك التجارية',
  brand_awareness_17:
    '<b>فكر في</b> عدد المستهلكين الذين جربوا منتجات أو خدمات علامتك التجارية',
  brand_awareness_18:
    '<b>حدد</b> المستهلكين الذين استمروا في استخدام علامتك التجارية بعد تجربتها لأول مرة',
  brand_awareness_19: '<b>اكتشف</b> احتمال توصية علامتك التجارية للآخرين',
  brand_awareness_20:
    '<b>اكشف</b> نسبة المستهلكين الذين يفكرون في استخدام علامتك التجارية في المستقبل',
  brand_awareness_21: 'من يستفيد من الوعي واستخدام العلامة التجارية؟',
  brand_awareness_22: 'الشركات التي تطلق منتجًا جديدًا',
  brand_awareness_23: 'الشركات التي تعيد تنشيط علامة تجارية قائمة',
  brand_awareness_24:
    'أي شركة تسعى لفهم وتحسين كيفية تعرف المستهلكين على علامتها التجارية واستخدامها',
  brand_awareness_25:
    'توفر منهجياتنا رؤى قيّمة لتحسين الوعي بعلامتك التجارية واستخدامها',
  brand_awareness_26: 'يتم اختيار المنهجية بشكل فردي بناءً على طلب العميل',
  brand_awareness_27: 'منهجية قمع استخدام العلامة التجارية',
  brand_awareness_28:
    'يُظهر معدل التجربة نسبة الجمهور الذي يعرف العلامة التجارية وجرب منتجاتها أو خدماتها.',
  brand_awareness_29:
    'يشير معدل التكرار إلى نسبة الجمهور الذي يعرف العلامة التجارية وجرب منتجاتها أو خدماتها واستمر في الشراء أو الاستخدام خلال الـ 12 شهرًا الماضية.',
  brand_awareness_30:
    'يكشف معدل الاحتفاظ عن نسبة الأفراد الذين استخدموا منتجات أو خدمات العلامة التجارية بانتظام خلال الأشهر الستة الماضية.',
  brand_awareness_31:
    'يوضح معدل الاحتفاظ نسبة العملاء الذين استخدموا منتجات أو خدمات العلامة التجارية خلال الأشهر الستة الماضية واستمروا في اختيارها وإظهار الولاء لها بمرور الوقت.',
  brand_awareness_32: 'منهجية الوعي بالعلامة التجارية',
  brand_awareness_33:
    'تمثل قمة الذهن (TOM) العلامة التجارية الأولى التي يذكرها المستجيب تلقائيًا.',
  brand_awareness_34:
    'يمثل الوعي التلقائي الكلي مجموع الإشارات التلقائية، بما في ذلك قمة الذهن (TOM).',
  brand_awareness_35:
    'يكشف الوعي المساعد مدى تعرف المستخدمين على علامتك التجارية عند تذكيرهم بها.',
  brand_awareness_36: 'خريطة أداء سمات العلامة التجارية',
  brand_awareness_37:
    'يقوم هذا الأداة بتقييم وتمثيل أهمية سمات العلامة التجارية المختلفة بصريًا، مما يوفر رؤى حول كيفية مساهمة كل سمة في الأداء العام للعلامة التجارية وإدراك المستهلكين لها.',
  brand_awareness_38:
    'اكتشف مفاتيح تعزيز تأثير علامتك التجارية من خلال تحليلنا الشامل.',
  brand_awareness_39: 'خريطة إدراك العلامات التجارية',
  brand_awareness_40:
    'تقدم هذه الأداة تمثيلاً بصريًا لتصورات المستهلكين في بيئة سوق تنافسية. هذا النهج ضروري لتوضيح الفروقات بين العلامات التجارية وتسليط الضوء على السمات المحورية في السوق.',
  brand_awareness_41:
    'يسهّل ملاحظة وتفسير العلاقات بين العلامات التجارية وهذه الخصائص المحددة.',
  brand_awareness_42:
    'تشير قرب العلامة التجارية من سمات معينة إلى ارتباطها القوي بتلك الخصائص. وبالمثل، فإن قرب علامتين تجاريتين يدل على تشابهاتهما وصورتهما المشتركة، مما يبرز انتماءهما إلى نفس القطاع السوقي.',
  consumer_journey_map_1: 'خريطة رحلة المستهلك',
  consumer_journey_map_2:
    'اكتشف وتغلب على العقبات في عملك باستخدام خريطة رحلة المستهلك لدينا',
  consumer_journey_map_3: 'موثوق من قبل',
  consumer_journey_map_4: '4Service',
  consumer_journey_map_5:
    'اكتشف إمكانات خريطة رحلة المستهلك (CJM) لتحسين التفاعلات بين المستهلكين وعلامتك التجارية',
  consumer_journey_map_6: 'حدد الخطوات التي يتخذها المستهلك قبل شراء المنتج',
  consumer_journey_map_7: 'احصل على رؤى من عملائك الحقيقيين، وليس من افتراضات',
  consumer_journey_map_8: 'احصل على فهم شامل لتجارب عملائك',
  consumer_journey_map_9: 'حدد الفرص الضائعة وقارن نفسك بمنافسيك',
  consumer_journey_map_10: 'اكتشف نهجنا في CJM',
  consumer_journey_map_11:
    'ننشئ مسار تفاعل المستهلك مع المنتج أو الخدمة أو الشركة أو العلامة التجارية عبر قنوات مختلفة وخلال فترة زمنية محددة.',
  consumer_journey_map_12:
    'نحدد المراحل التي يمر بها المستهلكون قبل إتمام عملية الشراء، بما في ذلك التوقعات والمشاعر والدوافع في كل مرحلة.',
  consumer_journey_map_13: 'استفد معنا',
  consumer_journey_map_14:
    'نقدم فريقًا من المحترفين ذوي الخبرة الذين يفهمون تعقيدات النجاح في الأعمال العالمية',
  consumer_journey_map_15: 'نلتزم بتقديم نتائج تفوق توقعاتك',
  consumer_journey_map_16: 'نكتشف حلولًا معقدة تسهم في نموك',
  consumer_journey_map_17: 'نحن متخصصون في تقديم حلول CJM مخصصة',
  consumer_journey_map_18: 'احجز استشارة',
  consumer_journey_map_19: 'قرارات قائمة على البيانات',
  consumer_journey_map_20:
    'اتخذ قراراتك بناءً على بيانات حقيقية بدلاً من الافتراضات',
  consumer_journey_map_21: 'حسّن CJM الخاص بك',
  consumer_journey_map_22:
    'ابنِ علاقات أقوى مع العملاء من خلال تلبية احتياجاتهم وتوقعاتهم في كل مرحلة من رحلتهم',
  consumer_journey_map_23: 'قد الطريق',
  consumer_journey_map_24: 'قارن نفسك بمنافسيك وابق متقدمًا على السوق',
  consumer_journey_map_25: 'التوصيات',
  consumer_journey_map_26:
    'نفّذ توصيات CJM الخاصة بنا لتحقيق النجاح، وتعزيز ولاء العملاء، وزيادة المبيعات، وتعظيم إمكانات عملك',
  consumer_journey_map_27:
    'اكتشف رحلة المستهلك الحقيقية باستخدام خريطة رحلة المستهلك لدينا',
  consumer_journey_map_28:
    'يقدم الخبراء الذين لديهم أكثر من 20 عامًا من الخبرة بحثًا شاملاً',
  consumer_journey_map_29:
    'يتضمن البحث النوعي جمع وتحليل البيانات غير الرقمية لفهم المفاهيم والآراء أو التجارب.',
  consumer_journey_map_30:
    'تشمل طرق البحث الكمي القياس الموضوعي والتحليل الرقمي للبيانات التي يتم الحصول عليها من خلال الاستطلاعات والاستبيانات.',
  consumer_journey_map_31:
    'بعد جمع البيانات، يقوم الخبراء بتحليل المعلومات واستخلاص الاستنتاجات لتزويدك بأفضل التوصيات.',
  boarding_1: 'خريطة رحلة العميل',
  boarding_2:
    'تتعلق خريطة رحلة العميل (CJM) بتحديد الجمهور المستهدف وفهم احتياجاته وبيئته، ثم إنشاء خطة لتقديم تجربة جذابة',
  boarding_3: 'مؤشر المروج الصافي',
  boarding_4:
    'مؤشر المروج الصافي (NPS) هو المعيار الذهبي لمقاييس تجربة العملاء، ويعتمد على سؤال واحد: ما مدى احتمالية أن توصي بالمؤسسة / المنتج / الخدمة؟',
  boarding_5: 'تتبع صحة العلامة التجارية',
  boarding_6:
    'يُمكن لأبحاث تتبع صحة العلامة التجارية (BHT) قياس أداء علامتك التجارية من حيث الوعي والاستخدام، وتموضع العلامة التجارية، وأدائها',
  boarding_7: 'أبحاث الموارد البشرية',
  boarding_8:
    'تُستخدم أبحاث الموارد البشرية لتقييم ممارسات وأداء إدارة الموارد البشرية، وتقدم تحليلاً تفصيلياً للتطور والإدارة الحالية',
  boarding_9: 'اختبار تجربة المستخدم (UX)',
  boarding_10:
    'اختبار قابلية الاستخدام (UX) هو طريقة لمعرفة كيفية تفاعل الأشخاص الحقيقيين مع موقع إلكتروني أو تطبيق أو منتج آخر، وملاحظة سلوكهم وردود أفعالهم تجاهه',
  boarding_11: 'مؤشر رضا العملاء',
  boarding_12:
    'يقيس رضا العملاء مدى تلبية توقعاتهم فيما يتعلق بشراء منتج أو خدمة تقدمها شركتك',
  boarding_13: 'اختبار الإعلانات',
  boarding_14:
    'الحملة الإعلانية استثمار ضخم. تأكد من أن إعلاناتك قوية وتحقق أقصى عائد على الاستثمار',
  boarding_15: 'تدقيق ميداني / تدقيق البيع بالتجزئة',
  boarding_16:
    'اجمع بيانات مفصلة عن متجرك أو علامتك التجارية، وحلل عوائق النمو، وأنشئ استراتيجيات فعّالة لتجاوزها',
  boarding_17: 'Play4Sales',
  boarding_18: 'برنامج إدارة الأداء. تطبيق ترفيهي مصمم لزيادة المبيعات',
  boarding_19: 'Voicer',
  boarding_20:
    'نظام إدارة الملاحظات. صوت عملائك في نظام واحد. نظام إدارة تعليقات العملاء',
  boarding_21: 'البحث النوعي',
  boarding_22:
    'البحث النوعي هو جمع وتحليل البيانات غير الرقمية لفهم المفاهيم أو الآراء أو التجارب',
  boarding_23: 'البحث الكمي',
  boarding_24:
    'طرق البحث الكمي هي قياس موضوعي وتحليل رقمي للبيانات التي يتم جمعها من خلال الاستطلاعات والاستبيانات والمسوحات',
  boarding_25: 'الشراء الخفي',
  boarding_26:
    'الشراء الخفي هو تقنية بحث سوقية تُستخدم لقياس ومراقبة التفاعلات بين العميل والشركة أو المؤسسة وفق سيناريو محدد مسبقاً',
  boarding_27: 'Wantent',
  boarding_28: 'منصة ذكاء محتوى مدعومة بالذكاء الاصطناعي توفر رؤى من الجمهور',
  boarding_29: 'مراقبة الأسعار',
  boarding_30: 'مراقبة الأسعار هي عملية جمع ومعالجة وتحليل أسعار المنافسين',
  boarding_31: 'تصميم الخدمات',
  boarding_32:
    'تصميم الخدمات هو طريقة لفهم احتياجات ورغبات الأشخاص الذين سيستخدمون منتجاً أو خدمة من خلال قضاء الوقت معهم',
  boarding_33: 'تحليل أسعار صناعة السيارات',
  boarding_34:
    'يُحسن تحليل الأسعار التنافسية العروض، ويزيد الأرباح، ويُعزز الحصة السوقية من خلال الاستفادة من بيانات استعداد المستهلكين للدفع لتحديد الخصائص الرئيسية',
  boarding_35: 'تدقيق فحص المنشأة',
  boarding_36:
    'يضمن توافق منافذ البيع بالتجزئة مع معايير العلامة التجارية، من خلال تقييم الخصائص المادية وتأثيرها على تصور العملاء',
  boarding_37: 'حلول تجربة العملاء (CX)',
  boarding_38:
    'اكتشف حل تجربة العملاء الشامل بزاوية 360 درجة: نحن نُخصص الأدوات والخدمات بناءً على أهدافك لدفع عملك نحو النجاح',
  boarding_39: 'تحليلات الكلام',
  boarding_40:
    'أداتنا المتقدمة لتحليل الكلام تُحوّل اللغة المنطوقة إلى نص، مما يوفر رؤى لا تقدر بثمن لمساعدة الشركات على تحسين تجربة العملاء، ومراقبة الأداء، وضمان الامتثال، وتعزيز النمو',
  boarding_41: 'الاستخدام والموقف',
  boarding_42:
    'التحليل القائم على الاستخدام والموقف هو نهجنا لفهم كيفية تفاعل الجماهير مع علامتك التجارية من خلال تحليل أنماط الاستخدام العملي والمواقف النفسية، مما يُمكّن من وضع استراتيجيات تسويق ومنتجات مخصصة',
  boarding_43: 'الوعي بالعلامة التجارية والاستخدام',
  boarding_44:
    'يتضمن الوعي بالعلامة التجارية والاستخدام تقييم مدى التعرف عليها والألفة بها وتكرار التفاعل والاحتفاظ بها داخل السوق المستهدف لتعزيز ظهور العلامة التجارية ومشاركتها',
  boarding_45: 'هوية العلامة التجارية وتموضعها',
  boarding_46:
    'تحليل شامل لهوية العلامة التجارية وتموضعها، يكشف عن تصورات المستهلكين ووجهات نظر الجمهور المختلفة والرؤى حول كيفية إدراك علامتك التجارية',
  boarding_47: 'تصنيف وتقسيم العملاء',
  boarding_48:
    'يتضمن تصنيف وتقسيم العملاء تقسيم السوق المستهدف إلى مجموعات مميزة بناءً على الخصائص المشتركة، مما يُتيح إنشاء استراتيجيات مخصصة تتماشى مع شرائح الجمهور المحددة',
  boarding_49: 'خريطة رحلة المستهلك',
  boarding_50:
    'خريطة رحلة المستهلك هي تمثيل مرئي للمراحل ونقاط الاتصال والمشاعر والدوافع التي يمر بها المستهلك أثناء تفاعله مع منتجك أو علامتك التجارية',
  boarding_51:
    'تعرّف على التقنيات المبتكرة التي تدعم التزامنا بتوفير رؤى قابلة للتطبيق وتحقيق نتائج مؤثرة لعملك',
  boarding_52:
    'استكشف مجموعتنا من المنتجات المليئة بالذكاء القائم على البيانات المصممة لصناعتك، مما يمكّنك من اتخاذ قرارات مستنيرة والبقاء في صدارة المنافسة',
  boarding_53:
    'تعمق في اتجاهات السوق وسلوك المستهلك والمشهد التنافسي من خلال حلولنا الشاملة لأبحاث السوق',
  boarding_54: 'البحث المخصص (Ad Hoc Research)',
  boarding_55:
    'البحث المخصص هو نهج مصمم لمعالجة قضية محددة باستخدام مزيج من المنهجيات الحالية أو منهجية جديدة لإنشاء حل مخصص',
  boarding_56: 'البحث السوسيولوجي',
  boarding_57:
    'يكشف البحث السوسيولوجي أنماط السلوك البشري والتفاعلات الاجتماعية، مما يوفر رؤى قيّمة لتطوير استراتيجيات مبتكرة وإنشاء روابط ذات معنى مع الجمهور المستهدف',
  not_found_1: 'عذراً! لا يمكننا العثور على هذه الصفحة.',
  not_found_2: 'لماذا لا تتحقق من منتجاتنا؟',
  not_found_3: 'احجز استشارة',
  customer_profiling_segmentation_1: 'تصنيف وتقسيم العملاء',
  customer_profiling_segmentation_2:
    'سنساعدك في تحديد جمهورك المستهدف بدقة، لجعل استراتيجيتك أكثر فعالية',
  customer_profiling_segmentation_3:
    'استفد من قوة تقسيم السوق لضمان وصول رسائلك دائماً بفعالية إلى مجموعات المستهلكين المستهدفة',
  customer_profiling_segmentation_4: 'افهم المستهلكين بعمق أكبر',
  customer_profiling_segmentation_5: 'ابحث عن أفضل جمهور مستهدف لمنتجك',
  customer_profiling_segmentation_6: 'استكشف شرائح جديدة لجذبها',
  customer_profiling_segmentation_7: 'اكتشف العوائق التي تمنع الشراء',
  customer_profiling_segmentation_8: 'نحن متخصصون في تقديم حلول تقسيم مخصصة',
  customer_profiling_segmentation_9: 'نهج فريد',
  customer_profiling_segmentation_10:
    'اختبر حلاً فريداً مخصصاً تم تصميمه خصيصاً لتلبية احتياجاتك',
  customer_profiling_segmentation_11: 'الشخصيات المستهدفة',
  customer_profiling_segmentation_12:
    'تم إنشاء شخصيات مستهدفة بناءً على تحليل سوقي عميق وبحث شامل',
  customer_profiling_segmentation_13: 'شرائح جديدة',
  customer_profiling_segmentation_14:
    'حدّد أكثر شرائح جمهورك قيمة واكشف عن فوائد الاستهداف المخصص',
  customer_profiling_segmentation_15: 'التوصيات',
  customer_profiling_segmentation_16:
    'نفّذ توصياتنا وحقق النجاح، عزّز ولاء العملاء، زِد المبيعات، واستفد من أقصى إمكانات عملك',
  customer_profiling_segmentation_17:
    'يقدّم الخبراء الذين يمتلكون أكثر من 20 عاماً من الخبرة بحثاً شاملاً',
  customer_profiling_segmentation_18:
    'يتضمن البحث النوعي جمع وتحليل البيانات غير الرقمية لفهم المفاهيم أو الآراء أو التجارب.',
  customer_profiling_segmentation_19:
    'تشمل طرق البحث الكمي القياس الموضوعي والتحليل الرقمي للبيانات التي تم الحصول عليها من خلال الاستطلاعات والاستبيانات والمسوحات.',
  customer_profiling_segmentation_20:
    'بعد جمع البيانات، يقوم الخبراء بتحليل المعلومات واستخلاص النتائج لتزويدك بأفضل التوصيات.',
  customer_profiling_segmentation_21:
    'نحن لا نجري القياسات فقط، بل نقدم لك خطة عمل مع خطوات واضحة خطوة بخطوة',
  customer_profiling_segmentation_22: 'منهجيتنا',
  customer_profiling_segmentation_23: 'مؤشر جاكارد',
  customer_profiling_segmentation_24:
    'عندما يُسأل المجيبون مباشرة، قد لا تتوافق إجاباتهم حول تفضيلات الشركة مع سلوكهم الفعلي. وبدلاً من الأسئلة المباشرة، نستخدم تحليل جاكارد الإحصائي لفهم العلاقة بين خصائص الشركة وخيارات المستهلكين.',
  customer_profiling_segmentation_25: 'المحفزات',
  customer_profiling_segmentation_26:
    'نحدد المحفزات (العوامل التي تؤثر على نتيجة معينة) ونصنفها إلى محفزات رئيسية ومتوسطة وغير مهمة بناءً على أهميتها.',
  customer_profiling_segmentation_27: 'التقسيم',
  customer_profiling_segmentation_28:
    'تحصل على عملية تقسيم مع خصائص واضحة لاختيارات العملاء.',
  customer_profiling_segmentation_29: 'نهجنا في التقسيم',
  customer_profiling_segmentation_30: 'ديموغرافي',
  customer_profiling_segmentation_31: 'العمر',
  customer_profiling_segmentation_32: 'الجنس',
  customer_profiling_segmentation_33: 'الدخل',
  customer_profiling_segmentation_34:
    'يساعد على تخصيص المنتجات والخدمات والتسويق لمجموعات محددة، مما يحسن الصلة والفعالية',
  customer_profiling_segmentation_35: 'نفسي',
  customer_profiling_segmentation_36: 'نمط الحياة',
  customer_profiling_segmentation_37: 'القيم',
  customer_profiling_segmentation_38: 'السلوكيات',
  customer_profiling_segmentation_39:
    'يتيح التسويق المخصص، ويعمّق الروابط مع العملاء، ويزيد الولاء والمبيعات للشركة',
  customer_profiling_segmentation_40: 'سلوكي',
  customer_profiling_segmentation_41: 'الأفعال',
  customer_profiling_segmentation_42: 'الدوافع',
  customer_profiling_segmentation_43: 'تكرار الشراء',
  customer_profiling_segmentation_44:
    'يتيح التسويق المستهدف، ويحسن رضا العملاء، ويزيد من الاحتفاظ بهم، ويعزز ربحية الشركة',
  customer_profiling_segmentation_45: 'جغرافي',
  customer_profiling_segmentation_46: 'الموقع',
  customer_profiling_segmentation_47:
    ' يتيح التسويق المستهدف، وتخصيص المنتجات، والتوزيع الفعّال، وزيادة اختراق السوق للشركة.',
  brands_identity_1: 'هوية العلامة التجارية وتموضعها',
  brands_identity_2:
    'حوّل علامتك التجارية من خلال تحليلنا المتعمق، الذي يكشف عن رؤى حول تصورات المستهلكين ويُحسّن استراتيجيتك لتحقيق النجاح',
  brands_identity_3: 'تحدث إلى خبير',
  brands_identity_4: '<b>اكتشف تحليلاً شاملاً</b> لهوية العلامة التجارية',
  brands_identity_5: '<b>استكشف الرؤى</b> المستخلصة من تصورات المستهلكين',
  brands_identity_6: '<b>افهم وجهات النظر المتنوعة</b> للجمهور المستهدف',
  brands_identity_7:
    '<b>احصل على رؤى حول</b> سلوك المستهلكين وعاداتهم وتفضيلاتهم لاتخاذ قرارات مدروسة',
  brands_identity_8:
    'يقدّم خبراء 4Service الذين يمتلكون أكثر من 20 عاماً من الخبرة في مجال العملاء حلولاً فريدة تساعد على نمو عملك',
  brands_identity_9:
    '<b>ستحصل على حزمة بحث</b> مزودة بجميع البيانات الأساسية. إنها أداة تشخيصية تُبرز نقاط القوة والمجالات التي قد تحتاج إلى تحسين',
  brands_identity_10:
    '<b>تُوفّر خدماتنا للشركات الأدوات اللازمة</b> لاتخاذ قرارات مستنيرة، وتحسين الاستراتيجيات، وتحقيق النجاح في مجالاتها المختلفة.',
  brands_identity_11: 'لتحسين مكانة علامتك التجارية في السوق التنافسية',
  brands_identity_12: 'الشركات التي تسعى إلى تعزيز حضورها في السوق',
  brands_identity_13: 'الشركات التي ترغب في تطوير استراتيجيتها',
  brands_identity_14: 'هوية العلامة التجارية',
  brands_identity_15: 'تموضع العلامة التجارية',
  brands_identity_16:
    '<b>اكتشف كيف تُدرك علامتك التجارية</b> عبر شرائح المستهلكين المختلفة.',
  brands_identity_17:
    '<b>حدّد الصفات المنسوبة</b> إلى علامتك التجارية والمنافسين.',
  brands_identity_18:
    '<b>قيّم نقاط القوة</b> والضعف من أجل التحسين الاستراتيجي.',
  brands_identity_19:
    '<b>قيّم مدى توافق</b> صورة علامتك التجارية مع القيم التي تروّج لها.',
  brands_identity_20:
    '<b>قيّم مدى مصداقية</b> علامتك التجارية كما يراها المستهلكون.',
  brands_identity_21:
    '<b>استكشف التصورات الرمزية والنمطية</b> لعلامتك التجارية.',
  brands_identity_22:
    '<b>حدّد نقاط البيع الفريدة</b> لعلامتك التجارية وعوامل تميزها مقارنةً بالمنافسين.',
  brands_identity_23:
    '<b>حدّد الخصائص الرئيسية المؤثرة</b> في احتمالية شراء المستهلكين لمنتجاتك أو خدماتك.',
  brands_identity_24:
    '<b>تعرّف على كيفية تموضع علامتك التجارية حالياً</b> في أذهان المستهلكين وحدد الجوانب التي يجب إبرازها لجذب الشرائح السوقية المستهدفة.',
  brands_identity_25: 'يتم اختيار المنهجية بشكل فردي بناءً على طلب العميل',
  brands_identity_26: 'الوعي بالعلامة التجارية والاستخدام',
  brands_identity_27:
    'يتضمن تقييم مستوى العلامة التجارية قياس الوعي ومستويات الاستهلاك، ويُعد مكوناً أساسياً في عملية التقييم.',
  brands_identity_28: 'تسليم العلامة التجارية والثقة',
  brands_identity_29:
    'يقيس هذا المقياس مدى دعم العملاء (التوصية) والقدرة المستمرة للعلامة التجارية على الوفاء بالوعود، وخلق تجارب إيجابية للعملاء، وبناء الثقة.',
  brands_identity_30: 'أداء صورة العلامة التجارية',
  brands_identity_31:
    'يتضمن تقييم أداء العلامة التجارية تقييم ارتباطها بست قيم أساسية (3 عقلانية و3 عاطفية)، ومدى تميزها ضمن الفئة، وقدرتها على إلهام الفخر بين المستهلكين.',
  brands_identity_32: 'مؤشر صحة العلامة التجارية',
  brands_identity_33:
    'يُظهر مؤشر صحة العلامة التجارية فهماً شاملاً لكيفية أداء علامتك التجارية في بيئة المنافسة.',
  sociological_research_1: 'البحث الاجتماعي',
  sociological_research_2:
    'نقوم بإجراء تحليل متعمق للظواهر والعمليات الاجتماعية، مما يساعد على اتخاذ قرارات مستنيرة من خلال استنتاجات وتحليلات فريدة.',
  sociological_research_3: 'اتصل بنا',
  sociological_research_4: 'عملاؤنا',
  sociological_research_5: 'CAWI',
  sociological_research_6:
    'CATI - هي طريقة لجمع البيانات تستخدم الحاسوب لإجراء المقابلات عبر الهاتف. يتيح برنامج CATI أتمتة عمليات جمع البيانات، وإدخال الإجابات، وإدارة الاستبيانات. تسهل هذه الطريقة التحكم في المقابلات، وتمكّن من تحليل ومعالجة البيانات بسرعة، وتضمن مستوى عالٍ من توحيد المعايير.',
  sociological_research_7: 'CATI',
  sociological_research_8:
    'CAWI - هي طريقة لجمع البيانات يقوم فيها المستجيبون بملء الاستبيانات أو الإجابة على الأسئلة عبر واجهة الويب، ويتم جمع البيانات ومعالجتها تلقائيًا باستخدام برامج متخصصة. تتيح طريقة CAWI إجراء دراسات واسعة النطاق وجمع وتحليل البيانات بسرعة.',
  sociological_research_9: 'CAPI',
  sociological_research_10:
    'CAPI - هي طريقة لجمع البيانات من خلال مقابلات وجهاً لوجه حيث يستخدم الباحث جهازًا لوحيًا أو هاتفًا محمولًا لإدخال إجابات المستجيبين، مما يسمح بجمع بيانات آلي يقلل من أخطاء الإدخال ويسهل تحليل النتائج.',
  sociological_research_11: 'يستخدم خبراؤنا مجموعة متنوعة من الأدوات',
  sociological_research_12: 'العينة',
  sociological_research_13: 'نحسب ونطبق عينات من أي درجة تعقيد',
  sociological_research_14:
    'في عملنا نستخدم العينات البسيطة، والنظامية، والمقسمة، والعنقودية',
  sociological_research_15:
    'لإجراء الدراسات الميدانية التمثيلية على المستوى الوطني، نستخدم إجراءات أخذ عينات متعددة المراحل ومقسمة طبقيًا',
  sociological_research_16:
    'يتم اختيار التجمعات حسب المناطق وفقًا للحجم ونوع المستوطنة، ويتم تحديد عددها بما يتناسب مع حجمها في كل منطقة',
  sociological_research_17: 'نقوم بإجراء',
  sociological_research_18: 'أبحاث الرأي العام',
  sociological_research_19: 'الأبحاث الاجتماعية والاقتصادية',
  sociological_research_20: 'أبحاث المكتب',
  sociological_research_21: 'تقييم جودة الخدمات الاجتماعية',
  sociological_research_22: 'دراسة الحالة',
  sociological_research_23: 'أبحاث الموظفين',
  sociological_research_24:
    'أبحاث الجماهير المستهدفة (الفئات الضعيفة، بما في ذلك النازحين، والعسكريين، والشباب، وغيرهم)',
  sociological_research_25: 'نحن نعمل مع كل عميل بشكل فردي',
  sociological_research_26: 'عملاؤنا:',
  sociological_research_27: 'المؤسسات الخيرية',
  sociological_research_28: 'المنظمات والنقابات العامة',
  sociological_research_29: 'الهيئات الحكومية',
  sociological_research_30: 'نهجنا في العمل',
  sociological_research_31:
    'نستخدم نهجًا علميًا وفهمًا عميقًا للواقع الحالي، بالإضافة إلى استخدام طرق بحث متنوعة لجمع البيانات.',
  sociological_research_32:
    'نستعين بخبراء متخصصين يتمتعون بالخبرة اللازمة للتعامل مع الطلبات المحددة ولدينا مجموعة من الخبراء في مجالات مختلفة.',
  sociological_research_33:
    'يقوم قسم التحليل الداخلي لدينا بتحليل البيانات المجمعة باستخدام مجموعة أدوات فريدة اعتمادًا على خصوصية المهمة.',
  sociological_research_34:
    'نقوم بإعداد تقارير تحتوي على استنتاجات وتوصيات مفصلة، مع مراعاة احتياجات وتوقعات جمهورك المستهدف.',
  sociological_research_35:
    'نقدم المشورة والدعم أثناء تنفيذ التوصيات، لمساعدتك على تحقيق التغييرات الإيجابية.',
  sociological_research_36: 'أبحاثنا على التلفزيون',
  sociological_research_37: 'اطلع على تقاريرنا',
  sociological_research_38:
    'يضمن نهجنا العلمي في العمل لعملائنا بيانات اجتماعية دقيقة وموثوقة في جميع أنحاء أوكرانيا وأوروبا بأدنى هامش خطأ.',
  sociological_research_39:
    'نحن نلتزم بجميع مبادئ ومعايير الأخلاقيات وقواعد إجراء الأبحاث الاجتماعية.',
  sociological_research_40:
    'نلتزم بمدونة الأخلاقيات المهنية لعلماء الاجتماع التابعة لجمعية علم الاجتماع الأوكرانية وإعلان هلسنكي للمبادئ الأخلاقية للبحث. نحن أعضاء في ESOMAR، وجمعية التسويق الأوكرانية، والجمعية الأوكرانية لمراكز الاتصال.',
  sociological_research_41: 'الميدان',
  sociological_research_42: 'اللجنة الإلكترونية (الاستطلاع عبر الإنترنت)',
  sociological_research_43: 'المقابلون المنتظمون',
  sociological_research_44: 'المشرفون',
  sociological_research_45: 'مراقبة جودة الميدان',
  sociological_research_46: 'تسجيل 100٪ لإحداثيات GPS (CAPI)',
  sociological_research_47:
    'التحقق من صحة الاستبيانات (CAWI، CAPI، CATI، PAPI)',
  sociological_research_48: 'تسجيل 100٪ للمقابلات (CAPI، CATI)',
  sociological_research_49: 'نستخدم برامج مرخصة:',
  sociological_research_50:
    'SPSS لتحليل البيانات الإحصائية ومعالجة مجموعات البيانات',
  sociological_research_51:
    'DigSee Sure لـ CAPI: منطق الاستبيان، تحديد الموقع الجغرافي، التسجيل الصوتي للمقابلات، عرض المواد المرئية',
  sociological_research_52:
    'SurveyMonkey لـ CAWI: منطق الاستبيان، التنسيق المريح، التصور',
  sociological_research_53:
    'VoIPTime (مركز الاتصال): برمجة الاستبيانات من أي تعقيد، ونقل التسجيلات الصوتية إلى العميل',
  sociological_research_54: 'العينة',
  sociological_research_55: 'نحسب ونطبق عينات من أي درجة تعقيد',
  sociological_research_56:
    'في عملنا نستخدم العينات البسيطة، والنظامية، والمقسمة، والعنقودية',
  sociological_research_57:
    'لإجراء الدراسات الميدانية التمثيلية على المستوى الوطني، نستخدم إجراءات أخذ عينات متعددة المراحل ومقسمة طبقيًا',
  sociological_research_58:
    'يتم اختيار التجمعات حسب المناطق وفقًا للحجم ونوع المستوطنة، ويتم تحديد عددها بما يتناسب مع حجمها في كل منطقة',
  sociological_research_59: 'الفريق',
  sociological_research_60:
    'علماؤنا الاجتماعيون هم أعضاء في جمعية علماء الاجتماع في أوكرانيا',
  sociological_research_61:
    'لدينا 12 محللاً بدوام كامل يتمتعون بخبرة في المشاريع الكمية والنوعية في مختلف الصناعات.',
  sociological_research_62:
    'لدينا فريق تحليلي قوي من المحترفين بخبرة تزيد عن 10 سنوات في البحث. لدينا علماء، ودكتوراه، وماجستير في إدارة الأعمال.',
  sociological_research_63: 'إيرينا ماكسيمايوك',
  sociological_research_64:
    'رئيسة قسم البحوث. أكثر من 15 عامًا من الخبرة في أبحاث التسويق، وإدارة البحث في جميع المراحل، وإعداد التقارير التحليلية والعروض التقديمية.',
  sociological_research_65: 'أندري بيلوسكورسكي',
  sociological_research_66:
    'رئيس قسم البرمجة ومعالجة البيانات. 20 عامًا من الخبرة في أبحاث التسويق والاجتماع والسوق.',
  sociological_research_67: 'أولينا سوموفا',
  sociological_research_68:
    'أخصائية برمجة وطالبة دراسات عليا في علم الاجتماع في جامعة دونيتسك. 5 سنوات من الخبرة في أبحاث التسويق، وعضوة في مجلس التحالف الديمقراطي للنساء، ورئيسة قسم جمع التبرعات.',
  sociological_research_69: 'آنا بادالكا',
  sociological_research_70:
    'رئيسة قسم البحوث الاجتماعية في إدارة البحوث، تمتلك 13 عامًا من الخبرة في المشاريع الاجتماعية والاجتماعية على المستويين الدولي والوطني. حاصلة على درجة الدكتوراه في علم الاجتماع، ورئيسة لجنة البحوث في الجمعية الأوكرانية لمراكز الاتصال.',
  ad_hoc_1: 'بحث خاص (Ad Hoc)',
  ad_hoc_2: 'اكتشف أبحاثنا البديلة للحالات الفريدة',
  ad_hoc_3: 'اتصل بنا',
  ad_hoc_4: 'نهجنا',
  ad_hoc_5:
    'يقوم فريق خبرائنا بتحليل دقيق للبيانات المجمعة، مما يوفر لك حلولًا معقدة تساهم في نموك.',
  ad_hoc_6:
    'نصمم بحثًا فريدًا مخصصًا لمتطلباتك الخاصة، بالاعتماد على مجموعة متنوعة من المنهجيات، بما في ذلك الاستطلاعات والمقابلات ومجموعات التركيز وتحليل البيانات وغيرها.',
  ad_hoc_7: 'لماذا تختار بحث Ad Hoc؟',
  ad_hoc_8: 'المرونة',
  ad_hoc_9:
    'لا يوجد مشروع بحثي يشبه الآخر. مع أبحاث Ad Hoc، لدينا المرونة للتكيف وتطوير النهج الفريد حسب الحاجة، مما يضمن بقاء رؤاك ذات صلة وقابلة للتنفيذ.',
  ad_hoc_10: 'الدقة',
  ad_hoc_11:
    'من خلال تخصيص منهجياتنا وفقًا لمتطلباتك الخاصة، نقدم نتائج دقيقة وموجهة توفر رؤى قيّمة.',
  ad_hoc_12: 'الابتكار',
  ad_hoc_13:
    'نحتضن الابتكار والإبداع في عملية البحث لدينا، ونستكشف تقنيات وأساليب جديدة لاكتشاف الفرص والتحديات الخفية.',
  ad_hoc_14: 'السرعة',
  ad_hoc_15:
    'يتيح بحث Ad Hoc التنفيذ السريع، مما يمكّنك من الوصول إلى رؤى حاسمة في الوقت المناسب، ويجعلك في طليعة المنافسة في مجالك.',
  ad_hoc_16: 'خبرتنا',
  ad_hoc_17:
    'يقدم خبراء 4Service الذين يمتلكون أكثر من 20 عامًا من الخبرة في أبحاث السوق وتجربة العملاء حلولًا فريدة تساعد في تنمية عملك.',
  ad_hoc_18: 'نستخدم مجموعة أدوات مميزة بناءً على متطلباتك المحددة',
  ad_hoc_19: 'لا توجد منهجية واحدة تعمل من أجلك؟',
  ad_hoc_20: 'اطلب بحث Ad Hoc',
  ad_hoc_21: 'مصمم خصيصًا لمشكلة محددة',
  ad_hoc_22:
    'نستخدم مزيجًا من أجزاء مختلفة من المنهجيات بالإضافة إلى نهج جديد تمامًا',
  ad_hoc_23: 'نهج فردي',
  ad_hoc_24: 'نقوم بتخصيص حل بعناية يتناسب مباشرة مع مشكلتك',
  ad_hoc_25: 'تجاوز التوقعات',
  ad_hoc_26: 'نقدم خطة عمل تحتوي على توصيات لمساعدة عملك على تحقيق أهدافه',
  ad_hoc_27: 'لديك مشكلة غير قياسية',
  ad_hoc_28: 'لا تعمل أي من المنهجيات لمشكلتك',
  ad_hoc_29: 'ترغب في طلب منهجيات مختلفة أو أجزاء منها في وقت واحد',
  ad_hoc_30: 'من يستفيد من بحث Ad Hoc؟',
  service_design_1: 'بعض من عملائنا',
  service_design_2: 'تصميم الخدمات',
  service_design_3:
    'حوّل عملك من التركيز على المنتج والمبيعات إلى التركيز على الخدمة والإنسان',
  service_design_4: 'تحدث مع خبير',
  service_design_5: 'تعلم مجانًا!',
  service_design_6:
    'لقد جمعنا معلومات عملية ومفيدة في مكتبة تصميم الخدمات لدينا',
  service_design_7:
    'تحتوي المكتبة على أوصاف مفصلة لكل خطوة، وأدوات وتقنيات ذات صلة، ونصائح حول التفاصيل المهمة، ومقاطع فيديو توضيحية.',
  service_design_8: 'انتقل إلى المكتبة',
  service_design_9: 'استفد من تصميم الخدمات!',
  service_design_10:
    'يهدف تصميم الخدمات إلى إنشاء وتحسين الخدمات من خلال معالجة النظام البيئي الكامل للخدمة — الأشخاص والعمليات ونقاط الاتصال — لتعزيز رضا المستخدمين وكفاءة التشغيل.',
  service_design_11:
    'تصميم الخدمات ليس فقط سبب تفضيلك لمقهى على آخر. إنه أيضًا السبب في عودتك إلى هذا المكان مرارًا وتكرارًا، وإخبار جميع أصدقائك عنه.',
  service_design_12: 'كيف يمكن للأعمال الاستفادة من تصميم الخدمات',
  service_design_13: 'رضا المستخدمين',
  service_design_14: 'أنشئ تجارب سلسة وشخصية تُسعد المستخدمين.',
  service_design_15: 'الكفاءة التشغيلية',
  service_design_16: 'تبسيط العمليات، تقليل التكاليف، وتحسين تقديم الخدمات.',
  service_design_17: 'اتساق العلامة التجارية',
  service_design_18: 'ضمان توافق جميع نقاط الاتصال مع قيم العلامة التجارية.',
  service_design_19: 'القدرة على التكيف مع التغيرات',
  service_design_20: 'تصميم خدمات يمكنها النمو والتطور مع الاحتياجات المتغيرة.',
  service_design_21: 'زيادة الولاء',
  service_design_22:
    'بناء علاقات أقوى مع العملاء وتعزيز الولاء من خلال تجارب خدمة استثنائية.',
  service_design_23: 'الميزة التنافسية',
  service_design_24: 'تميّز في السوق من خلال تجارب خدمة فريدة ولا تُنسى.',
  service_design_25: 'لماذا',
  service_design_26: 'لماذا تختار تصميم الخدمات؟',
  service_design_27:
    'إنها ثقافة ومنهجية وطريقة تفكير تساعد الشركات في جميع أنحاء العالم على التحول من التركيز على المنتج والمبيعات إلى التركيز على احتياجات البشر ومشكلاتهم.',
  service_design_28: 'خدماتنا',
  service_design_29: 'تصميم خدمة العملاء',
  service_design_30:
    'نطوّر وننفذ مشاريع تركز على العملاء لإنشاء منتجات جديدة أو تحسين المنتجات الحالية. كما نوفر تدريبًا للعمل المستقل المستقبلي مع هذه التغييرات.',
  service_design_31: 'تصميم خدمة الموظفين',
  service_design_32:
    'دورة عملية لتطوير وتنفيذ العمليات والهياكل والتغييرات الموجهة نحو الموظفين داخل الشركة.',
  service_design_33: 'تفكير تصميم المستقبل',
  service_design_34:
    'تطوير مفاهيم مستقبلية واستراتيجية الشركة مع مراعاة السيناريوهات المختلفة والابتكارات المحتملة.',
  service_design_35: 'الإبداع في الأعمال',
  service_design_36:
    'تدريب عملي يساعد المشاركين على استخدام الإبداع لحل المشكلات المحددة وتطوير حلول فريدة للسوق.',
  service_design_37: 'ورش عملنا',
  service_design_38:
    'نقدم ورش عمل عملية مع شهادات معترف بها عالميًا لمشاركيْنا.',
  service_design_39: 'إنشاء منتجات وخدمات ومرافق تتجاوز التوقعات',
  service_design_40: 'تنفيذ عمليات تجارية فعّالة',
  service_design_41: 'تناغم العلاقة بين موظفي الشركة والعملاء',
  service_design_42: 'التقويم',
  service_design_43: 'قريباً',
  service_design_44: 'تعرّف أكثر على فعالياتنا السابقة',
  service_design_45: 'أساسيات تصميم الخدمات',
  service_design_46: 'إنشاء منتجات وخدمات ومرافق تتجاوز التوقعات',
  service_design_47: 'تصميم خدمة تجربة الموظف (EX)',
  service_design_48: 'إنشاء منتجات وخدمات ومرافق تتجاوز التوقعات',
  service_design_49: 'المزيد',
  service_design_50: 'نهجنا',
  service_design_51: '4Service هي العمود الفقري لخدمتك المتمحورة حول الإنسان!',
  service_design_52:
    'نساعد الشركات على تطوير طريقة التفكير اللازمة وخلق بيئة داخلية تركز على الإنسان.',
  service_design_53: 'الأدوات',
  service_design_54:
    'نستخدم مجموعة مميزة من التقنيات والأدوات بناءً على متطلباتك الخاصة.',
  service_design_55: 'بحث المستخدمين',
  service_design_56:
    'مقابلات، استبيانات، مقابلات مباشرة، ودراسات إثنوغرافية لفهم احتياجات المستخدمين وسلوكياتهم.',
  service_design_57: 'الشخصيات التمثيلية (Personas)',
  service_design_58:
    'شخصيات خيالية تمثل أنواعًا مختلفة من المستخدمين لتوجيه قرارات التصميم.',
  service_design_59: 'خرائط رحلة العميل',
  service_design_60:
    'تمثيلات مرئية لتجربة المستخدم عبر الخدمة، مع تحديد نقاط الاتصال والمشاكل الرئيسية.',
  service_design_61: 'جلسات العصف الذهني',
  service_design_62: 'جلسات تعاونية مع أصحاب المصلحة لتوليد الأفكار والحلول.',
  service_design_63: 'النماذج الأولية',
  service_design_64: 'إنشاء نسخ أولية من الخدمة لاختبار المفاهيم وتحسينها.',
  service_design_65: 'مخططات الخدمة',
  service_design_66:
    'مخططات تفصيلية توضح العلاقات بين مكونات الخدمة المختلفة وعملياتها.',
  service_design_67: 'الشريك',
  service_design_68: '4Service و DTA',
  service_design_69:
    '4Service هي الممثل الحصري الرسمي لأكاديمية التفكير التصميمي.',
  service_design_70: 'كجزء من شراكتنا، نحن:',
  service_design_71:
    '<b>نقدّم تدريبًا عمليًا</b> باستخدام منهجية تصميم الخدمات في ورش عمل يقودها خبراء رائدون؛',
  service_design_72: '<b>نُدرّب متخصصين معتمدين</b> في التفكير التصميمي؛',
  service_design_73:
    '<b>نُنفذ مشاريع تصميم الخدمات</b> مع ميسّرين دوليين للعديد من الشركات.',
  service_design_74: 'أنشأنا مراكز تميز لتصميم الخدمات في:',
  service_design_75: 'أوكرانيا',
  service_design_76: 'كازاخستان',
  service_design_77: 'تركيا',
  service_design_78: 'جورجيا',
  service_design_79: 'أذربيجان',
  service_design_80: 'اكتشف المزيد عن حالاتنا',
  service_design_81: 'اذهب إلى المكتبة',
  service_design_82: 'مرحبًا بكم في تصميم الخدمات!',
  four_opinion_1: 'استطلاع 4Service',
  four_opinion_2:
    'شارك في الاستطلاعات عبر الإنترنت مقابل المال واكسب دون مغادرة المنزل',
  four_opinion_3: 'ابدأ',
  four_opinion_4: 'مزايا́نا',
  four_opinion_5: 'نحن محل ثقة',
  four_opinion_6:
    'يضم مجتمعنا أكثر من 90,000 مستهلك في أوكرانيا و100,000 في كازاخستان',
  four_opinion_7: 'نقدّر وقتك',
  four_opinion_8:
    'نقدّر وقتك، لذا مقابل المشاركة في الاستطلاعات، لديك فرصة للحصول على هدية أو مكافأة مالية',
  four_opinion_9: 'رأيك له تأثير كبير',
  four_opinion_10:
    'كل تعليق منك يساعد العلامات التجارية على فهم احتياجات عملائها بشكل أفضل',
  four_opinion_11:
    'شارك في استطلاعات 4Opinion من 4Service واكسب عبر الإنترنت أو اربح جائزة',
  four_opinion_12: 'انضم إلى 4Opinion',
  four_opinion_13: 'المزيد من القصص الشيقة على قناتنا',
  four_opinion_14: 'مزيد من التفاصيل لأوكرانيا',
  four_opinion_15: 'مزيد من التفاصيل لكازاخستان',
  four_opinion_16: 'لماذا تختارنا؟',
  four_opinion_17: '4Service هي شركة أبحاث دولية متخصصة في إدارة تجربة العملاء',
  four_opinion_18:
    'نحن من بين أفضل 10 وكالات أوروبية في مجال إدارة تجربة العملاء',
  four_opinion_19: 'مهمتنا هي تحسين خدمة العملاء في جميع أنحاء العالم!',
  four_opinion_20: 'كيف تبدأ في كسب المال من الاستطلاعات عبر الإنترنت؟',
  four_opinion_21: 'سجّل في الموقع',
  four_opinion_22: 'استقبل إشعارات حول الاستطلاعات المتاحة',
  four_opinion_23: 'أكمل الاستطلاعات واكسب',
  four_opinion_24: 'آراء حقيقية من المستجيبين لدينا',
  four_opinion_25: 'فيتالي كوخان',
  four_opinion_26:
    '“أكملت استطلاعًا ونسيت أمره، وبعد فترة اتصلت بي السيدة ناتاليا وأخبرتني أنني فزت بجائزة. وها هو، هاتفي Samsung Galaxy M52 5G. شكرًا جزيلاً😁”',
  four_opinion_27: 'فيكتوريا بوبوفسكا',
  four_opinion_28:
    '“استلمت مكبر الصوت، شكرًا جزيلاً على السحب الصادق والعادل والمثير.”',
  four_opinion_29: 'يوليا أوليكساندريفنا',
  four_opinion_30:
    '“ربما هذا هو أكثر شيء لا يصدق حدث لي مؤخرًا💕 لم أفز فقط، بل حصلت أيضًا على شيء رائع حقًا. كنت أتوقع أي شيء، لكن لم أتخيل أنه سيكون بهذا الجمال. مرة أخرى، شكرًا جزيلًا!”',
  four_opinion_31: 'فقط معنا لديك فرصة لكسب المال الحقيقي أو الفوز بجائزة',
  four_opinion_32: 'تابع الاستطلاعات المتاحة على قناتنا',
  four_opinion_33: 'اذهب إلى القناة',
  career_1: 'كن جزءًا من',
  career_2: '4Service',
  career_3: 'ننتظرك في فريق يتمتع بفرص غير محدودة للنمو المهني المستمر!',
  career_4: 'إلى الوظائف الشاغرة',
  career_5: 'لم تجد وظيفة؟',
  career_6: 'أرسل إلينا سيرتك الذاتية وسنتواصل معك!',
  career_7: 'إرسال السيرة الذاتية',
  career_8: 'نموذج التسجيل',
  career_9: '*الاسم',
  career_10: '*اللقب',
  career_11: '*البريد الإلكتروني',
  career_12: '*رقم الهاتف',
  career_13: 'تحميل السيرة الذاتية',
  career_14: 'إرسال',
  career_15: 'ابدأ مسيرتك المهنية في 4Service',
  career_16: 'المهام الرئيسية:',
  career_17: 'المتطلبات:',
  career_18: 'نحن نقدم:',
  career_19: 'تقديم الطلب',
  career_20: '4Service — شركة أبحاث دولية',
  career_21: 'نعمل منذ عام 2001',
  career_22: 'عنّا',
  career_23: 'نطور الثقافة المؤسسية',
  career_24: 'مبادراتنا',
  career_25: 'نُحسّن خدمة العملاء حول العالم',
  career_26: 'وظائف 4Service',
  career_27: 'فرصك مع 4Service',
  career_28:
    'دعم الصحة النفسية من خلال جلسات أسبوعية "قهوة الصباح"، وأنشطة بناء الفريق والمبادرات الاجتماعية',
  career_29:
    'تجربة عمل مثيرة مع أشهر العلامات التجارية العالمية مثل: <span>Mercedes, Huawei, Philip Morris</span>',
  career_30: 'تطوير مهني مستمر من خلال الندوات وورش العمل والدورات التدريبية',
  career_31: 'دور المشتري السري وتأثيره على تطوير العلامات التجارية المعروفة',
  career_32:
    'العمل من أي مكان في العالم وإمكانية العمل عن بُعد أو في المكتب في: <span>أوكرانيا، كازاخستان، رومانيا، النمسا، أذربيجان، جورجيا</span>',
  career_33:
    'تطوير علامتك الشخصية من خلال المشاركة في الأحداث والندوات وفرص التواصل',
  career: 'المسيرة المهنية',
  footer_btn_1: 'كن متسوقًا سريًا',
  footer_btn_2: 'شارك في استطلاعات مدفوعة الأجر',
  diary_study_1: 'دراسة',
  diary_study_2: 'يومية',
  diary_study_3:
    'راقب واجمع رؤى حول تجارب المستخدمين وأنماط حياتهم المتغيرة بمرور الوقت',
  diary_study_4: 'تحدث إلى خبير',
  diary_study_5: 'اتصل بنا',
  diary_study_6: 'ابدأ الآن',
  diary_study_7:
    'اطلب دراسة يومية للحصول على وصول شامل إلى كل من البيانات النوعية والكمية، مما يوفر رؤى قيّمة حول سلوك المستهلكين واتجاهات السوق وأداء العلامة التجارية',
  diary_study_8: 'دراسة أنماط الحياة وتجربة المستخدم في سياقها الديناميكي',
  diary_study_9:
    'تقدّم الدراسة اليومية رؤى عميقة وسياقية حول كيفية تفاعل المستخدمين، مما يساعد في تحديد الأنماط والتغييرات التي قد لا تكون واضحة من خلال أساليب أخرى.',
  diary_study_10:
    'تتيح هذه الطريقة جمع البيانات في الوقت الفعلي ضمن بيئة طبيعية، مما يعزز موثوقيتها وأهميتها بشكل كبير',
  diary_study_11: 'تقديم',
  diary_study_12: 'نحن نقدّم دراسات يومية مخصصة',
  diary_study_13: 'مشاركة المستهلك',
  diary_study_14:
    'نوفّر مجتمعات عبر الإنترنت يشارك فيها الأفراد لتوثيق سلوكياتهم وأنشطتهم وتجاربهم بمرور الوقت في بيئاتهم اليومية.',
  diary_study_15: 'أبحاث السوق',
  diary_study_16:
    'يتمحور نهجنا حول إجراء أبحاث سوق معمقة لتوفير بيانات دقيقة وذات صلة باحتياجات عملائنا المحددة.',
  diary_study_17: 'رؤى العلامة التجارية',
  diary_study_18:
    'نغوص بعمق في تصورات وسلوكيات المستهلكين لاكتشاف رؤى قيّمة تُسهم في صياغة استراتيجيات العلامة التجارية.',
  diary_study_19: 'الخبراء',
  diary_study_20:
    'يبتكر خبراء 4Service الذين يمتلكون أكثر من 20 عامًا من الخبرة مع العملاء حلولًا فريدة تساعد على نمو عملك',
  diary_study_21: 'إدارة المشاريع',
  diary_study_22:
    'يقدّم فريقنا دعمًا شاملاً في إدارة المشاريع، مما يضمن التخطيط والتنفيذ الدقيقين لكل مرحلة لتحقيق نتائج سلسة.',
  diary_study_23: 'الاستشارات',
  diary_study_24:
    'نقدّم استشارات متخصصة لإرشاد عملائنا خلال جميع مراحل المشروع، مع معالجة التحديات وتحسين الأداء.',
  diary_study_25: 'ضمان الجودة',
  diary_study_26:
    'نلتزم بمعايير جودة صارمة في كل مرحلة، لضمان أن مشاريعنا تلبي وتتجاوز التوقعات.',
  diary_study_27: 'الفائدة',
  diary_study_28: 'استفد معنا',
  diary_study_29: '<b>مصدر لا محدود</b> من الرؤى على مرّ الزمن',
  diary_study_30: '<b>إرشادات الخبراء</b> في كل مرحلة من العملية',
  diary_study_31: '<b>ربط الشركات</b> بالمستهلكين حول العالم',
  diary_study_32: '<b>جمع بيانات مريح</b> مع تعليقات وملاحظات معمّقة',
  diary_study_33: '<b>بيانات متاحة</b> في أي مرحلة من المشروع',
  diary_study_34: '<b>حلول متكاملة</b> تساهم في نموّك',
  diary_study_35: 'البحث',
  diary_study_36: 'احصل على أبحاث كمية مخصصة مع رؤى خاصة',
  shoppers_1: 'المنصّة',
  shoppers_2: 'المتسوقين السريّين',
  shoppers_3: 'انضمّ',
  shoppers_4: 'قيّم الخدمة واكسب مع 4Service',
  shoppers_5: 'ابدأ مسيرتك المهنية في 4Service',
  shoppers_6: 'بانتظارك عمل في مشاريع مثيرة للاهتمام',
  shoppers_7: 'انضمّ',
  shoppers_8: 'انضم إلى فريقنا',
  shoppers_9: 'اعرف المزيد ›',
  shoppers_10: 'المشرف',
  shoppers_11:
    'القائد الذي يشرف على عمل الفريق، ويتحمل مسؤولية التخطيط وتنسيق العمل، ومراقبة الجودة، وحل القضايا التنظيمية لضمان تنفيذ المهام الموكلة.',
  shoppers_12: 'المتسوق السري',
  shoppers_13:
    'خبير يقوم بزيارة المتاجر أو المطاعم أو غيرها من المؤسسات وفقًا للسيناريو المحدد، ثم يقدّم تقريرًا عن انطباعاته.',
  shoppers_14: 'المروّج التجاري (Merchandiser)',
  shoppers_15:
    'متخصص يقوم بعرض المنتجات في المتاجر وفقًا لمعايير العلامة التجارية أو الشركة.',
  shoppers_16: 'المدقق',
  shoppers_17: 'خبير يتحقق من مدى الالتزام بالمعايير والمتطلبات.',
  shoppers_18: 'المختبر',
  shoppers_19:
    'خبير يفحص جودة الخدمة أو المنتجات أو العمليات من منظور العميل ويقيّم مدى توافقها مع توقعات المستهلكين ويكشف عن المشكلات المحتملة.',
  shoppers_20: 'المتقدّم السري',
  shoppers_21:
    'متخصص يحلّل عملية خدمة العملاء، ويقيّم جودة التواصل، وسرعة الاستجابة، وسهولة الإجراءات، والانطباع العام عن التفاعل.',
  shoppers_22: 'المروّج',
  shoppers_23:
    'خبير يروّج المنتجات من خلال عرضها، وتوزيع المواد الإعلانية، وتنظيم الحملات، والإجابة على أسئلة العملاء.',
  shoppers_24: 'المشارك في المقابلة',
  shoppers_25:
    'المشارك في المقابلات المعمقة يشارك في دراسة تفصيلية تهدف إلى الكشف عن آرائه ومشاعره ودوافعه أو خبراته المتعلقة بموضوع أو منتج أو خدمة معينة.',
  shoppers_26: 'كن جزءًا من 4Service',
  shoppers_27: 'نحن نعمل <b>حول العالم</b>',
  shoppers_28: 'يضم فريقنا <b>أكثر من 1000 محترف</b>',
  shoppers_29: 'لدينا <b>أكثر من 20 عامًا من الخبرة</b> في السوق',
  shoppers_30: 'التعليمات',
  shoppers_31: 'كيفية تسجيل زيارة صوتيًا',
  shoppers_32: 'كيفية تسجيل مكالمة صوتيًا',
  shoppers_33: 'لا يمكنك إرفاق ملف الصوت بالنموذج؟',
  shoppers_34: 'مدونة معايير وأخلاقيات MSPA للمتسوقين السريين',
  shoppers_35: 'الأسئلة الشائعة',
  shoppers_36: 'الأسئلة المتكررة',
  shoppers_37: 'كم يمكنني أن أكسب في الشهر؟',
  shoppers_38: 'كم مرة يمكنني تنفيذ المهام في مدينتي؟',
  shoppers_39:
    'ماذا أفعل إذا كان الموقع مغلقًا وما هي المكافأة على هذه الزيارة؟',
  shoppers_40: 'كيف يتم استلام المكافأة؟',
  shoppers_41: 'ما هي مواعيد استلام المكافأة؟',
  shoppers_42: 'إلى من أتوجه بشأن أسئلة تتعلق بالمكافأة؟',
  shoppers_43: 'يعتمد مبلغ مكافأتك الشهرية على مدى كثافة تنفيذك للمهام.',
  shoppers_44:
    'قد تتراوح قيمة المهمة الواحدة من 40 هريفنيا — للزيارات والمكالمات البسيطة، وحتى 1200 هريفنيا — للزيارات المعقدة والمميزة، وذلك حسب صعوبة المشروع وطبيعته.',
  shoppers_45:
    'يمكن أن يصبح تنفيذ المهام هواية ممتعة بالنسبة لك تتوافق مع مشترياتك اليومية أو زياراتك للمقاهي أو المطاعم مع الأصدقاء.',
  shoppers_46: 'عدد المواقع، وحجم المشاريع؛',
  shoppers_47:
    'التناوب (زيارة نفس الموقع مرة واحدة فقط كل ثلاثة أشهر / ربع سنة)؛',
  shoppers_48: 'مدى توافق ملفك الشخصي / مهاراتك مع متطلبات المشروع؛',
  shoppers_49: 'سرعة تقديم الطلب.',
  shoppers_50: 'إذا كان الموقع الذي تقوم بفحصه:',
  shoppers_51:
    'مغلقًا – قم بتصوير الباب الأمامي، أو الإعلان عن سبب الإغلاق إن وُجد، أو جدول العمل، وواجهة الموقع مع العنوان.',
  shoppers_52:
    'غير موجود في العنوان المحدد – التقط <b>فيديو</b> للمنطقة المحيطة وصورة لواجهة المبنى المجاور التي يظهر فيها العنوان. بعد ذلك، تواصل مع منسقك.',
  shoppers_53: 'يتم استلام المكافأة على بطاقة: «بريفات بنك» للأفراد.',
  shoppers_54: 'يمكنك الاطلاع على مواعيد استلام المكافأة في حسابك الشخصي.',
  shoppers_55:
    'يمكنك أيضًا الاستفسار من منسقك أو التواصل مع خدمة دعم المتسوقين السريين عبر البريد الإلكتروني: ua@4service.support، مع ذكر اسم المشروع في موضوع الرسالة.',
  shoppers_56:
    'يتم عرض المواعيد العامة لاستلام المكافآت في حسابك الشخصي: «الصفحة الرئيسية».',
  shoppers_57:
    'إذا لم تتلق المكافأة بعد انتهاء المدة المحددة، قم بالإجراءات التالية في حسابك الشخصي:',
  shoppers_58: '1. تحقق من أن جميع بياناتك الشخصية مكتملة ولا توجد حقول فارغة؛',
  shoppers_59: '2. تأكد من صحة بيانات بطاقتك المصرفية وأن صلاحيتها لم تنتهِ؛',
  shoppers_60: '3. تأكد من أن البطاقة المصرفية مسجلة باسم فرد؛',
  shoppers_61:
    '4. تأكد من تطابق اسمك الكامل في النظام مع الاسم الموجود على البطاقة (بدون أخطاء).',
  shoppers_62:
    'إذا تحققت من جميع البيانات وكل شيء صحيح — تواصل مع خدمة دعم المتسوقين السريين عبر البريد الإلكتروني: ua@4service.support، مع ذكر اسم المشروع في موضوع الرسالة.',
  shoppers_63: 'تطبيقات <br /> المتسوقين السريين',
  shoppers_64: 'قم بتحميل تطبيق 4Shoppers:',
  shoppers_65: 'أو',
  shoppers_66: 'اتصل بنا',
  shoppers_67: 'دردشة مع الدعم',
  shoppers_68: 'الهاتف:',
  shoppers_69: 'البريد الإلكتروني:',
  shoppers_70: 'هل لديك أسئلة أخرى؟',
  shoppers_71: 'خدمة دعم <br /> الطاقم الميداني',
  shoppers_72: 'تواصل',
  shoppers_73: 'دعم الطاقم الميداني',
  shoppers_74:
    'أسئلة حول الزيارات، المدفوعات، والجوانب الأخرى من عمل المتسوق السري',
  shoppers_75: 'أوافق على معالجة البيانات الشخصية وفقًا لـ',
  shoppers_76: 'الاسم الكامل',
  shoppers_77: 'وصف المشكلة',
  shoppers_78: 'اسم المستخدم الخاص بك',
  shoppers_79: 'هاتف للتواصل',
  shoppers_80: 'مواعيد الدفع',
  shoppers_81: 'أخرى',
  shoppers_82: 'اتصل بنا',
  employee_experience_1: 'تجربة الموظف',
  employee_experience_2: 'يبدأ نجاح عملك من تجربة الموظف',
  employee_experience_3: 'اتصل بنا',
  employee_experience_4: 'تبدأ قصة نجاحك من هنا',
  employee_experience_5:
    'يبتكر خبراء 4Service الذين لديهم أكثر من 20 عامًا من الخبرة في أبحاث السوق وتجربة العملاء حلولًا فريدة تساعد في تنمية أعمالك.',
  employee_experience_6:
    'توفر خدماتنا للشركات الأدوات اللازمة لاتخاذ قرارات مستنيرة، وتحسين الاستراتيجيات، وتحقيق النجاح في قطاعاتها المختلفة.',
  employee_experience_7: 'نختار المنهجية المثالية لاحتياجاتك الخاصة',
  employee_experience_8: 'خريطة رحلة الموظف',
  employee_experience_9:
    'نرسم دورة حياة الموظف بالكامل، من التوظيف إلى المغادرة، مع تحديد النقاط الأساسية التي تؤثر على تجربته. يساعد ذلك في تحديد مجالات التحسين والفرص لزيادة الرضا والمشاركة في كل مرحلة.',
  employee_experience_10: 'خريطة رحلة الموظف مع المقارنة المعيارية',
  employee_experience_11:
    'نأخذ رسم خريطة رحلة الموظف خطوة أبعد من خلال مقارنة تجارب موظفيك بالمعايير الصناعية. سيساعدك ذلك في تحديد طرق لتبسيط العمليات الداخلية، وتعزيز ولاء الموظفين، واعتماد أفضل الممارسات.',
  employee_experience_12: 'دراسة صحة العلامة التجارية لصاحب العمل',
  employee_experience_13:
    'نقيم كيف يرى موظفوك علامتك التجارية من الداخل. تؤدي العلامة التجارية الداخلية القوية إلى قوة عاملة أكثر تحفيزًا وولاءً، مما ينعكس في تفاعلات العملاء وسمعة الشركة الخارجية.',
  employee_experience_14: 'مؤشر صافي مروّجي الموظفين (eNPS)',
  employee_experience_15:
    'باستخدام eNPS، نقيس مدى احتمال أن يوصي موظفوك بشركتك كمكان رائع للعمل. يوفر هذا المقياس البسيط ولكنه قوي نظرة ثاقبة على رضا الموظفين وولائهم العام.',
  employee_experience_16: 'مؤشر التزام ورضا الموظفين (ECSI)',
  employee_experience_17:
    'تقيّم منهجية ECSI مدى التزام الموظفين ورضاهم عن أدوارهم والشركة. يساعد ذلك في قياس مستوى مشاركتهم وتحديد المجالات التي يمكن تحسينها لزيادة الاحتفاظ بهم.',
  employee_experience_18: 'مقابلات متعمقة مع الموظفين السابقين والحاليين',
  employee_experience_19:
    'نجري مقابلات مع الموظفين السابقين لتحديد أسباب مغادرتهم وكيفية تحسين الاحتفاظ بالموظفين. تكشف المحادثات مع الموظفين الحاليين عن طرق لتحسين خدمة العملاء، وزيادة المشاركة، والتغلب على العقبات لتحقيق مؤشرات الأداء الرئيسية.',
  employee_experience_20: 'تحليل المحتوى الذي ينشئه المستخدم (UGC)',
  employee_experience_21:
    'يتم إجراء تحليل المحتوى الذي ينشئه المستخدم من خلال جمع المراجعات من المواقع المتخصصة ووسائل التواصل الاجتماعي والمنتديات ومنصات الفيديو. يساعد هذا التحليل على فهم توقعات العملاء الحقيقية ونقاط الألم لديهم، وتحديد الاتجاهات والتغيرات في تفضيلات المستهلكين، ومعرفة نقاط القوة والضعف للعلامة التجارية مقارنة بالمنافسين.',
  employee_experience_22: 'الموظف الغامض',
  employee_experience_23:
    'الموظف الغامض هو تقييم للشركة من منظور الموظف المحتمل. يقيس مدى تنظيم العمليات الداخلية، وكيفية تفاعل الموظفين الحاليين مع المرشحين، ومدى التزام الشركة بمعايير الخدمة والتواصل الخاصة بها.',
  employee_experience_24: 'زيارات التحفيز',
  employee_experience_25:
    'تكافئ زيارات التحفيز الموظفين الذين يلتزمون بمعايير الخدمة، مثل التفاعل الممتاز مع العملاء أو النجاح في زيادة المبيعات. يحدد المتسوقون الغامضون أفضل الموظفين، مما يساعد على تعزيز الدافع وتشجيع الآخرين على اتباع مثالهم للحصول على جوائز وتقدير.',
  employee_experience_26: 'تصميم الخدمة',
  employee_experience_27:
    'نستخدم تصميم الخدمة لتحديد تحديات الأعمال وكشف الحلول المبتكرة، مما يؤدي إلى إنشاء استراتيجيات تحسن تقديم الخدمة وتلبي احتياجات العملاء أو الموظفين.',
  employee_experience_28: 'أبحاث الموارد البشرية',
  employee_experience_29:
    'تساعد أبحاث الموارد البشرية في قياس مدى توافق الموظفين مع مهمة الشركة وقيمها ومدى فعاليتهم في إيصالها إلى العملاء.',
  employee_experience_30: 'الابتكار المشترك مع الموظفين (مجموعات التركيز)',
  employee_experience_31:
    'من خلال إشراك الموظفين مباشرة، نجري مجموعات تركيز للابتكار المشترك لجمع الملاحظات والأفكار. تمكن هذه العملية التعاونية موظفيك من المساهمة في تشكيل بيئة عملهم، مما يعزز روح الانتماء والمشاركة.',
  employee_experience_32: 'لماذا تستثمر في تجربة الموظف؟',
  employee_experience_33: 'تقليل معدل دوران الموظفين',
  employee_experience_34:
    'احتفظ بأفضل المواهب لديك من خلال إنشاء بيئة عمل يرغب الموظفون في البقاء والنمو فيها.',
  employee_experience_35: 'زيادة ولاء الموظفين',
  employee_experience_36:
    'ابنِ التزامًا طويل الأمد من موظفيك، مما يقلل من تكاليف إعادة التوظيف المكلفة.',
  employee_experience_37: 'تكيف سلس مع التغيير',
  employee_experience_38:
    'قلل من مقاومة القواعد والمبادرات الجديدة، مما يضمن انتقالات أكثر سلاسة داخل شركتك.',
  employee_experience_39: 'زيادة الإنتاجية',
  employee_experience_40:
    'ساعد فريقك على تبني العمليات الجديدة والتفوق في أدوارهم.',
  employee_experience_41: 'خفض تكاليف الأعمال',
  employee_experience_42:
    'قم بتبسيط العمليات مما يؤدي إلى توفير التكاليف وزيادة الإيرادات.',
  employee_experience_43: 'تجربة موظف ممتازة تعزز نمو الأعمال',
  employee_experience_44:
    'تشمل تجربة الموظف (EX) كل ما يواجهه ويشعر به الموظفون طوال رحلتهم داخل الشركة.',
  employee_experience_45:
    'تعزز التجربة الإيجابية للموظف التوافق مع أهداف الشركة، وتزيد من التحفيز، وتشجع على المشاركة.',
  employee_experience_46:
    'يقدم الموظفون السعداء والمندمجون خدمة استثنائية، مما يؤدي إلى عملاء راضين ونمو مستدام.',
  employee_experience_47:
    'يخلق الاستثمار في تجربة الموظف تأثيرًا متسلسلًا - تحسين الاحتفاظ، وزيادة الإنتاجية، وتحقيق نتائج أعمال أقوى.',
  employee_experience_48: 'تجربتك + تجربة العميل تؤثر مباشرة على عملك',
  employee_experience_49:
    'تسير تجربة الموظف (EX) وتجربة العميل (CX) جنبًا إلى جنب. من المرجح أن يقدم الفريق الراضي خدمة متميزة تؤدي إلى رضا العملاء بشكل أفضل. من خلال نهجنا المتكامل في EX وCX، يمكنك مواءمة ثقافتك الداخلية مع تميز خدمة العملاء الخارجية.',
  employee_experience_50:
    'من خلال دمج رؤى تجربة الموظف وتجربة العميل، نقدم نهجًا شاملاً لتحسين كليهما. النتيجة هي ثقافة مؤسسية أقوى وأكثر ترابطًا تدفع نحو نجاح الأعمال.',
  employee_experience_51: 'صاحب عمل سعيد',
  employee_experience_52: 'خدمة ممتازة',
  employee_experience_53: 'عميل سعيد',
  cati_1: 'المقابلات الهاتفية بمساعدة الحاسوب (CATI)',
  cati_2: 'استطلاعات هاتفية فعالة بمساعدة الحاسوب',
  cati_3: 'اتصل بنا',
  cati_4: 'موثوق به من قبل',
  cati_5:
    '<b>المقابلات الهاتفية بمساعدة الحاسوب (CATI)</b> هي طريقة لجمع البيانات باستخدام الاستطلاعات الهاتفية، حيث يعمل المشغلون باستخدام برامج متخصصة لتسجيل الإجابات وضمان منطق الأسئلة وتحليل النتائج.',
  cati_6: 'المزايا الرئيسية لـ CATI من 4Service:',
  cati_7: '<b>السرعة</b> في إجراء الاستطلاعات',
  cati_8: '<b>جودة بيانات عالية</b>',
  cati_9: '<b>مرونة</b> في تخصيص الاستبيانات',
  cati_10: '<b>أتمتة</b> العملية',
  cati_11: 'مجموعة واسعة من <b>أدوات مراقبة الجودة</b>',
  cati_12: 'القدرة على استطلاع <b>الفئات الصعبة الوصول</b> من المستجيبين',
  cati_13: '<b>تسجيل</b> جميع <b>المحادثات</b> للمراجعة اللاحقة',
  cati_14: 'القدرة على <b>الوصول بسرعة إلى جمهور مستهدف واسع</b>',
  cati_15:
    'طريقة <b>أكثر فعالية من حيث التكلفة</b> مقارنة بطرق جمع البيانات الأخرى',
  cati_16: 'تحلّ',
  cati_17: 'ما المهام التي يمكن حلها من خلال الاستطلاعات الهاتفية:',
  cati_18:
    '<span>بحث تقسيم السوق.</span> تحديد مجموعات المستهلكين المختلفة لاستهداف دقيق واستراتيجيات تسويقية فعالة',
  cati_19:
    '<span>تقييم رضا العملاء.</span> قياس ولاء المستهلكين للمنتجات والخدمات باستخدام مؤشرات SCI وNPS',
  cati_20:
    '<span>إدارة مؤشر NPS وتنفيذ خطة العمل.</span> استخدام الاستطلاعات الهاتفية لتحسين تجربة العملاء بنشاط من خلال مركز الاتصال',
  cati_21:
    '<span>تحليل الطلب واتجاهات السوق.</span> دراسة شعبية المنتجات والخدمات وتحديد المناطق الواعدة واتجاهات النمو',
  cati_22:
    '<span>تحليل البيئة التنافسية.</span> تقييم تموضع العلامة التجارية في السوق، والمقارنة مع المنافسين، وتحديد فرص النمو',
  cati_23: 'لمن',
  cati_24: 'تعد المقابلات الهاتفية CATI مثالية لـ:',
  cati_25: 'الشركات التي تطلق منتجًا جديدًا',
  cati_26:
    'لجمع بيانات السوق المحدثة، وتحليل المشهد التنافسي، ودراسة تفضيلات المستهلكين',
  cati_27: 'العلامات التجارية والشركات التي تعمل مع العملاء',
  cati_28:
    'لتقييم مستويات رضا العملاء (رضا العملاء، NPS)، وتحليل احتياجاتهم، وجمع الملاحظات',
  cati_29: 'قطاع التجزئة والتجارة الإلكترونية',
  cati_30:
    'لفهم سلوك المستهلك، واختبار المنتجات الجديدة، وتحديد العوامل التي تؤثر على قرارات الشراء',
  cati_31: 'البنوك والمؤسسات المالية',
  cati_32:
    'لتقييم الخدمة، وقياس مستويات الثقة بالشركة، وجمع الملاحظات حول الخدمات',
  cati_33: 'المنظمات الاجتماعية',
  cati_34: 'لإجراء البحوث الاجتماعية وتحليل الرأي العام',
  cati_35: 'المؤسسات الحكومية والمنظمات غير الحكومية',
  cati_36:
    'لجمع البيانات الإحصائية، ودراسة القضايا الاجتماعية، وتنفيذ برامج البحث',
  cati_37: 'الجودة',
  cati_38: 'معايير تقييم جودة المكالمات',
  cati_39: 'مهارات الاتصال الأساسية',
  cati_40:
    'الالتزام بمعايير التحية وإنهاء المكالمات، وكذلك التبديل إلى اللغة المريحة للمستجيب',
  cati_41: 'أسلوب التواصل',
  cati_42:
    'دقة الحديث، واللباقة، والنبرة الودية، والقدرة على بناء علاقة ثقة مع المستجيب',
  cati_43: 'إدارة المحادثة',
  cati_44:
    'استخدام تقنيات الاستماع النشط، والحفاظ على تفاعل المستجيب، وقيادة الحوار بفعالية',
  cati_45: 'معرفة موضوع الاستطلاع',
  cati_46:
    'فهم عميق لموضوع الاستطلاع والقدرة على الإجابة بشكل صحيح على الأسئلة الإضافية من المستجيبين',
  cati_47: 'دقة استكمال الاستبيان',
  cati_48:
    'إدخال الإجابات بدقة دون تحريف، واتباع التعليمات، وتجنب الأخطاء أثناء تعبئة الاستطلاع',
  cati_49: 'لماذا 4Service',
  cati_50: 'لماذا تختار المقابلات الهاتفية CATI من 4Service؟',
  cati_51:
    'تعد CATI مناسبة للشركات التي تسعى للحصول على بيانات دقيقة ومنظمة من خلال الاستطلاعات الهاتفية',
  cati_52: 'مركز اتصال خاص',
  cati_53:
    'لقد أجرينا أكثر من 70,000 مكالمة ناجحة مع تحقيق 100٪ من طلبات العملاء',
  cati_54: 'ضمان الجودة',
  cati_55: 'تحقق بنسبة 100٪ من كل مكالمة – لضمان دقة البيانات',
  cati_56: 'نهج فردي',
  cati_57: 'تطوير استبيانات فريدة مصممة وفقًا لاحتياجات العميل المحددة',
  cati_58: 'برمجيات متقدمة',
  cati_59:
    'استخدام نظام VolPtime لتنفيذ المقابلات الهاتفية CATI بأي درجة من التعقيد',
  cati_60: 'الخبرة في العمل مع قطاع B2B',
  cati_61:
    'نحن نعمل مع الكيانات القانونية، ونجري استطلاعات مع كبار المتخصصين في مختلف قطاعات الأعمال والصناعة',
  cati_62: 'أرسل طلبك وسنجد لك أفضل حل!',
  cati_63: 'التكنولوجيا',
  cati_64: 'نستخدم أحدث التقنيات لتحليل النتائج وتحسين عملك',
  cati_65: 'القدرات:',
  cati_66: '<span>VolPtime</span> - برنامج احترافي',
  cati_67: 'تنظيم الخطوط الواردة (الخط الساخن)/الصادرة الآلية',
  cati_68: 'إحصائيات عن المشغلين، وكل نوع من الاستفسارات، ومدة الاستشارات',
  cati_69: 'المراقبة عبر الإنترنت لعمليات مركز الاتصال',
  cati_70: 'تسجيل جميع الاستشارات الصوتية عبر الهاتف',
  cati_71: 'إعداد البرنامج عن بُعد بسهولة',
  cati_72: '<span>Survey Monkey</span> - خدمة احترافية لبرمجة الاستبيانات',
  cati_73: 'برمجة الاستبيانات بمستويات مختلفة من التعقيد',
  cati_74: 'مع الأخذ في الاعتبار جميع احتياجات البحث',
  cati_75: 'البساطة والوضوح والراحة للمستجيبين',
  cati_76: 'الجودة',
  cati_77: 'تقييم جودة الحوار مع العملاء',
  cati_78: 'نظام تقييم قائم على قائمة فحص',
  cati_79:
    'يتم قياس جودة الخدمة باستخدام قائمة فحص خاصة، حيث يمنح موظفو تقييم الجودة درجة متوسطة خلال فترة التقارير',
  cati_80: 'مؤشرات الالتزام بالمعايير المستهدفة',
  cati_81:
    'يتم تقييم الالتزام بالمعايير بناءً على المستويات المحددة، والتي لا يمكن أن تقل عن 90٪. ويمكن تعديل هذه المؤشرات اعتمادًا على خبرة الموظف',
  cati_82: 'مراقبة المكالمات من خلال التسجيلات وفي الوقت الحقيقي',
  cati_83:
    'يتم مراجعة حوالي 40٪ من المكالمات من خلال التسجيلات و20٪ في الوقت الحقيقي، مما يسمح بالاستجابة السريعة لانتهاكات المعايير المحتملة',
  cati_84: 'الخبراء',
  cati_85: 'لدينا مركز اتصال خاص بنا',
  cati_86: 'مدير مركز الاتصال',
  cati_87: 'مديرو التوظيف',
  cati_88: 'موقع عمل عن بُعد في أوكرانيا',
  cati_89: 'موقع عمل عن بُعد في كازاخستان',
  cati_90: 'المنسق الفني',
  cati_91: 'مديرو المشاريع',
  cati_92: 'مديرو المشاريع',
  cati_93: 'قسم التدريب ومراقبة الجودة',
  cati_94: 'المشغلون – 60 شخصًا (20٪ يتحدثون الإنجليزية بطلاقة)',
  cati_95: 'المشغلون – 20 شخصًا',
  cati_96: 'رئيس قسم مراقبة الجودة',
  cati_97: 'أخصائيو مراقبة الجودة',
  cati_98: 'مدربو التدريب',
};
